(async function (algolia) {
  "use strict";

  /**
   * Extracts the user ID from the Google Analytics device ID.
   * @example `GA1.1.xxxxxxxxxx.xxxxxxxxxx => xxxxxxxxxx_xxxxxxxxxx`
   * @link https://support.google.com/analytics/answer/11397207
   */
  function extractGoogleAnalyticsUserIdFromCookie(gaCookie) {
    if (gaCookie) {
      // Remove the Google Analytics tracker from the device ID.
      const userIdParts = gaCookie.split(".").slice(-2);
      if (userIdParts.length === 2) {
        return userIdParts.join("_");
      }
    }
    return undefined;
  }

  function getBrowserCookie(cookieName) {
    // In React Native environments, `document.cookie` doesn't exist.
    if (typeof document !== "object" || typeof document.cookie !== "string") {
      return undefined;
    }
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return undefined;
  }

  /**
   * Returns the Google Analytics User ID from a browser cookie name.
   * @example `getGoogleAnalyticsUserIdFromBrowserCookie('_ga')`
   */
  function getGoogleAnalyticsUserIdFromBrowserCookie(cookieName) {
    const browserCookie = getBrowserCookie(cookieName);

    if (!browserCookie) {
      return undefined;
    }

    return extractGoogleAnalyticsUserIdFromCookie(browserCookie);
  }
  
  if (!window.location.pathname.includes("/collections/")) {
    // console.log("not a collection page");
    //return;
  } else if (window.location.pathname.includes("/collections/roo")) {
    // console.log("rooms page");
    //return;
  }

  const is_collection_results_page = Boolean(
    // We want to match `/collections/handle` but only if handle != 'all'
    window.location.pathname.match(
      /(^\/\w{2}\/|^\/|^\/\w{2}-\w{2}\/)collections\/(?!all$)([^/]+)[/]*$/
    )
    /**
     * To match /collections/handle/handle-two links as well, please use
     * the following regex instead:
     */
    // window.location.pathname.match(/(^\/\w{2}\/|^\/|^\/\w{2}-\w{2}\/)collections\/(?!all)(.*)$/)
  );
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.hits;
  var infiniteHits = algolia.externals.widgets.infiniteHits;
  var pagination = algolia.externals.widgets.pagination;
  var stats = algolia.externals.widgets.stats;
  var configure = algolia.externals.widgets.configure;
  var refinementList = algolia.externals.widgets.refinementList;
  var rangeSlider = algolia.externals.widgets.rangeSlider;
  var toggleRefinement = algolia.externals.widgets.toggleRefinement;
  var index_suffix = "_france_fr";
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;
  var connectRange = algolia.externals.connectors.connectRange;
  var connectRefinementList =
    algolia.externals.connectors.connectRefinementList;
  var connectSortBy =
    algolia.externals.connectors && algolia.externals.connectors.connectSortBy;

  var collectionPageEnabled = is_collection_results_page;

  let collection_name = '';
  let collection_handle = '';
  
  
  algoliaShopify.shopify = algoliaShopify.shopify || algolia.shopify || window.algoliasearch?.shopify;

  function oblistNormalizeMarketId(marketId) {
    if (marketId == null) return '';
    const s = String(marketId);
    const match = s.match(/(\d+)$/);
    return match ? match[1] : s;
  }

  function oblistGetMarketMapping(marketKey, locale) {
    const mapping = algoliaShopify.config.markets_mapping || [];
    let entry = mapping.find((m) => m.key === marketKey);
    if (entry) return entry;
    const marketId = marketKey.split('_')[0];
    return mapping.find((m) => String(m.id) === marketId && m.locale === locale) || null;
  }

  function oblistResolveMarketSuffix(entry, locale) {
    if (!entry) return '';
    // Le mapping fait foi : un suffixe explicite est respecté tel quel, Y COMPRIS
    // '' (chaîne vide) qui désigne le marché PRIMAIRE → indice de base sans suffixe
    // (ex. United States/en = primaire → 'shopify_theoblistproducts').
    if (typeof entry.suffix === 'string') return entry.suffix;
    // Fallback d'inférence UNIQUEMENT si l'entrée n'a pas de champ suffix.
    if (entry.regions && entry.regions.indexOf('US') >= 0) {
      return locale === 'fr' ? 'united_states_fr' : 'united_states_en';
    }
    if (entry.regions && entry.regions.indexOf('FR') >= 0) {
      return locale === 'fr' ? 'france_fr' : 'france_en';
    }
    if (entry.market === 'United States') {
      return locale === 'fr' ? 'united_states_fr' : 'united_states_en';
    }
    if (entry.market === 'France') {
      return locale === 'fr' ? 'france_fr' : 'france_en';
    }
    return '';
  }

  function oblistBuildIndexName(type, marketKey, locale) {
    const entry = oblistGetMarketMapping(marketKey, locale);
    const suffix = oblistResolveMarketSuffix(entry, locale);
    const hypen = suffix === '' ? '' : '_';
    return algoliaShopify.config.index_prefix + type + hypen + suffix;
  }

  const domMarketLocale = document.querySelector('.algolia_market_locale')?.textContent?.trim();
  const domMarketId = document.querySelector('.algolia_market_id')?.textContent?.trim();
  const current_locale = domMarketLocale || algoliaShopify.shopify.market.language.shop_locale.locale;
  const current_market = oblistNormalizeMarketId(
    domMarketId || algoliaShopify.shopify.market.id
  );
  const market_key = `${current_market}_${current_locale}`;
  
  // Traductions FR pour les filtres et suggestions
  const translationsFR = {
    // Titres des filtres
    "Colour": "Couleur", "Color": "Couleur", "Materials": "Matériaux", "Material": "Matériau",
    "Style": "Style", "Price": "Prix", "Vendor": "Marque", "Brand": "Marque",
    "In stock only": "En stock uniquement",
    "Ready to ship now — not available with Made to order.": "Pièces avec stock > 0 — incompatible avec le sur-mesure.",
    "Product Type": "Type de produit",
    "Vintage Condition": "État vintage", "Localisation": "Localisation",
    "Item location": "Localisation",
    "Choose to buy local by filtering your search by country.": "Affichez les pièces expédiées depuis une zone.",
    "See pieces that ship from a chosen area.": "Affichez les pièces expédiées depuis une zone.",
    "Everywhere": "Partout",
    "European Union": "Union européenne",
    "Other": "Ailleurs",
    "Delivery options": "Options de livraison",
    "Sort by": "Trier par",
    "No preference": "Aucune préférence",
    "Within 7 days": "Sous 7 jours",
    "Within 14 days": "Sous 14 jours",
    "Within 30 days": "Sous 30 jours",
    "+30 days": "+30 jours",
    "Creation Type": "Type de Création",
    "All": "Tout",
    "Antique and vintage": "Ancien et vintage",
    "New and made to order": "Neuf et fabriqué sur mesure",
    "Max make time": "Délai max de fabrication",
    "No max preference": "Pas de maximum",
    "Up to 2 weeks": "Jusqu'à 2 semaines",
    "Up to 4 weeks": "Jusqu'à 4 semaines",
    "Up to 8 weeks": "Jusqu'à 8 semaines",
    "Up to 12 weeks": "Jusqu'à 12 semaines",
    "More than 12 weeks": "Plus de 12 semaines",
    // Catégories de matériaux
    "Wood and Derivatives": "Bois et Dérivés", "Metals": "Métaux", "Stone and Minerals": "Pierres et Minéraux",
    "Glass and Derivatives": "Verre et Dérivés", "Ceramics and Clays": "Céramiques et Argiles",
    "Textiles and Natural Fibers": "Textiles et Fibres Naturelles", "Synthetic and Technical Fibers": "Fibres Synthétiques",
    "Leathers and Skins": "Cuirs et Peaux", "Plastics and Composites": "Plastiques et Composites",
    "Natural Other": "Autres Naturels", "Modern and Miscellaneous Materials": "Matériaux Modernes",
    "Precious Stones and Gems": "Pierres Précieuses",
    // Catégories de couleurs
    "Neutrals": "Neutres", "Browns": "Marrons", "Reds & Oranges": "Rouges et Oranges",
    "Yellows & Golds": "Jaunes et Dorés", "Greens": "Verts", "Blues": "Bleus",
    "Purples & Violets": "Violets et Mauves", "Metallics": "Métalliques",
    "Stones & Neutrals Extended": "Pierres et Neutres", "Special Finishes": "Finitions Spéciales",
    // Catégories de styles
    "19th Century Styles": "Styles du XIXe Siècle", "Early 20th Century Movements": "Mouvements Début XXe",
    "Mid-20th Century": "Milieu du XXe Siècle", "Late 20th Century": "Fin du XXe Siècle",
    "Contemporary & Transitional": "Contemporain et Transitionnel", "Asian & Nature Inspired": "Asiatique et Nature",
    "Revival & Eclectic Styles": "Styles Revival et Éclectiques", "21st Century & Emerging": "XXIe Siècle et Émergent",
    // Matériaux individuels
    "Wood": "Bois", "Oak": "Chêne", "Walnut": "Noyer", "Mahogany": "Acajou", "Maple": "Érable",
    "Teak": "Teck", "Pine": "Pin", "Birch": "Bouleau", "Rosewood": "Palissandre", "Ebony": "Ébène",
    "Ash": "Frêne", "Cherry": "Cerisier", "Beech": "Hêtre", "Poplar": "Peuplier", "Cedar": "Cèdre",
    "Bamboo": "Bambou", "Veneer": "Placage", "Plywood": "Contreplaqué", "MDF": "MDF", "Cork": "Liège",
    "Metal": "Métal", "Steel": "Acier", "Stainless Steel": "Acier Inoxydable", "Brass": "Laiton",
    "Bronze": "Bronze", "Copper": "Cuivre", "Aluminium": "Aluminium", "Iron": "Fer",
    "Cast Iron": "Fonte", "Wrought Iron": "Fer Forgé", "Nickel": "Nickel", "Chrome": "Chrome",
    "Gold": "Or", "Silver": "Argent", "Platinum": "Platine", "Zinc": "Zinc", "Pewter": "Étain",
    "Stone": "Pierre", "Marble": "Marbre", "Travertine": "Travertin", "Limestone": "Calcaire",
    "Granite": "Granit", "Quartz": "Quartz", "Onyx": "Onyx", "Jade": "Jade", "Slate": "Ardoise",
    "Sandstone": "Grès", "Terrazzo": "Terrazzo", "Concrete": "Béton", "Cement": "Ciment",
    "Alabaster": "Albâtre", "Basalt": "Basalte",
    "Glass": "Verre", "Crystal": "Cristal", "Murano Glass": "Verre de Murano",
    "Ceramic": "Céramique", "Porcelain": "Porcelaine", "Stoneware": "Grès", "Terracotta": "Terre Cuite",
    "Clay": "Argile", "Tile": "Carrelage", "Faience": "Faïence",
    "Textile": "Textile", "Cotton": "Coton", "Linen": "Lin", "Wool": "Laine", "Silk": "Soie",
    "Hemp": "Chanvre", "Jute": "Jute", "Cashmere": "Cachemire", "Velvet": "Velours",
    "Rattan": "Rotin", "Wicker": "Osier", "Cane": "Cannage", "Raffia": "Raphia",
    "Leather": "Cuir", "Suede": "Daim", "Cowhide": "Peau de Vache", "Lambskin": "Peau d'Agneau",
    "Plastic": "Plastique", "Resin": "Résine", "Acrylic": "Acrylique", "Fiberglass": "Fibre de Verre",
    "Mother of Pearl": "Nacre", "Shell": "Coquillage", "Bone": "Os", "Horn": "Corne",
    "Paper": "Papier", "Cardboard": "Carton", "Canvas": "Toile", "Foam": "Mousse",
    // Couleurs
    "White": "Blanc", "Off White": "Blanc Cassé", "Ivory": "Ivoire", "Cream": "Crème",
    "Beige": "Beige", "Sand": "Sable", "Taupe": "Taupe", "Gray": "Gris", "Grey": "Gris",
    "Light Gray": "Gris Clair", "Dark Gray": "Gris Foncé", "Charcoal": "Anthracite", "Black": "Noir",
    "Brown": "Marron", "Light Brown": "Marron Clair", "Dark Brown": "Marron Foncé",
    "Tan": "Havane", "Camel": "Camel", "Chocolate": "Chocolat", "Cognac": "Cognac",
    "Pink": "Rose", "Blush": "Rose Poudré", "Coral": "Corail", "Peach": "Pêche",
    "Orange": "Orange", "Rust": "Rouille", "Red": "Rouge", "Burgundy": "Bordeaux", "Wine": "Lie de Vin",
    "Yellow": "Jaune", "Mustard": "Moutarde", "Ochre": "Ocre", "Champagne": "Champagne",
    "Green": "Vert", "Mint": "Menthe", "Sage": "Sauge", "Olive": "Olive", "Moss": "Mousse",
    "Forest Green": "Vert Forêt", "Emerald": "Émeraude", "Teal": "Bleu Canard", "Dark Green": "Vert Foncé",
    "Blue": "Bleu", "Light Blue": "Bleu Clair", "Sky Blue": "Bleu Azur", "Navy Blue": "Bleu Marine",
    "Royal Blue": "Bleu Royal", "Turquoise": "Turquoise", "Indigo": "Indigo",
    "Purple": "Pourpre", "Violet": "Violet", "Lavender": "Lavande", "Lilac": "Lilas",
    "Mauve": "Mauve", "Plum": "Prune", "Orchid": "Orchidée",
    "Transparent": "Transparent", "Clear": "Clair", "Matte": "Mat", "Glossy": "Brillant",
    "Multicolor": "Multicolore", "Natural": "Naturel",
    // Types de produits
    "Chair": "Chaise", "Armchair": "Fauteuil", "Lounge Chair": "Chaise Longue", "Dining Chair": "Chaise de Salle à Manger",
    "Table": "Table", "Tables": "Tables", "Dining Table": "Table à manger", "Side Table": "Table d'appoint",
    "Side table": "Table d'appoint", "Coffee Table": "Table basse", "Low Table": "Table basse", "Low table": "Table basse",
    "Console Table": "Console", "Console": "Console", "Desk": "Bureau", "End Table": "Table de bout",
    "End Tables": "Tables de bout", "Nesting Table": "Tables gigognes", "Nesting tables": "Tables gigognes",
    "Sofa": "Canapé", "Bench": "Banc", "Stool": "Tabouret", "Ottoman": "Pouf",
    "Bed": "Lit", "Headboard": "Tête de lit", "Nightstand": "Table de nuit",
    "Cabinet": "Armoire", "Sideboard": "Buffet", "Bookcase": "Bibliothèque", "Shelf": "Étagère",
    "Wardrobe": "Garde-robe", "Dresser": "Commode", "Chest": "Coffre",
    "Mirror": "Miroir", "Lamp": "Lampe", "Table Lamp": "Lampe de table", "Table Lamps": "Lampes de table",
    "Floor Lamp": "Lampadaire", "Pendant Light": "Suspension", "Chandelier": "Lustre",
    "Wall Light": "Applique", "Sconce": "Applique",
    "Vase": "Vase", "Bowl": "Bol", "Tray": "Plateau", "Box": "Boîte", "Sculpture": "Sculpture",
    "Painting": "Peinture", "Art": "Art", "Frame": "Cadre", "Rug": "Tapis", "Carpet": "Moquette",
    "Curtain": "Rideau", "Cushion": "Coussin", "Pillow": "Oreiller", "Throw": "Plaid",
    "Clock": "Horloge", "Candle": "Bougie", "Candle Holders": "Bougeoirs", "Planter": "Jardinière", "Basket": "Panier",
    "Lighting": "Éclairage", "Furniture": "Mobilier", "Decor": "Décoration", "Accessories": "Accessoires",
    "Decorative Dishes": "Plats décoratifs", "Serveware Accessories": "Accessoires de service",
    "Desk Accessories": "Accessoires de bureau",
    // Pays (shipping_country)
    "France": "France", "Netherlands": "Pays-Bas", "Poland": "Pologne",
    "United States of America": "États-Unis", "United States": "États-Unis", "USA": "États-Unis",
    "United Kingdom": "Royaume-Uni", "Great Britain": "Royaume-Uni", "England": "Angleterre",
    "Germany": "Allemagne", "Italy": "Italie", "Spain": "Espagne", "Portugal": "Portugal",
    "Belgium": "Belgique", "Switzerland": "Suisse", "Austria": "Autriche", "Ireland": "Irlande",
    "Denmark": "Danemark", "Sweden": "Suède", "Norway": "Norvège", "Finland": "Finlande",
    "Czech Republic": "République tchèque", "Czechia": "Tchéquie", "Slovakia": "Slovaquie",
    "Hungary": "Hongrie", "Romania": "Roumanie", "Greece": "Grèce", "Turkey": "Turquie",
    "Canada": "Canada", "Australia": "Australie", "Japan": "Japon", "South Korea": "Corée du Sud",
    "China": "Chine", "India": "Inde", "Brazil": "Brésil", "Mexico": "Mexique",
    "Morocco": "Maroc", "Tunisia": "Tunisie", "Lebanon": "Liban", "Israel": "Israël",
    "United Arab Emirates": "Émirats arabes unis", "Singapore": "Singapour",
    "Indonesia": "Indonésie", "Thailand": "Thaïlande", "Vietnam": "Viêt Nam",
    "Luxembourg": "Luxembourg", "Monaco": "Monaco",
    "Bulgaria": "Bulgarie", "Croatia": "Croatie", "Serbia": "Serbie", "Ukraine": "Ukraine",
    "Lithuania": "Lituanie", "Latvia": "Lettonie", "Estonia": "Estonie", "Iceland": "Islande",
    "New Zealand": "Nouvelle-Zélande", "South Africa": "Afrique du Sud", "Argentina": "Argentine",
    "Chile": "Chili", "Colombia": "Colombie", "Peru": "Pérou", "Egypt": "Égypte",
    "Taiwan": "Taïwan", "Hong Kong": "Hong Kong", "Philippines": "Philippines",
    "Malaysia": "Malaisie", "Pakistan": "Pakistan", "Bangladesh": "Bangladesh",
    "Georgia": "Géorgie", "Armenia": "Arménie", "Albania": "Albanie", "Bosnia and Herzegovina": "Bosnie-Herzégovine",
    "North Macedonia": "Macédoine du Nord", "Slovenia": "Slovénie", "Cyprus": "Chypre", "Malta": "Malte",
    // Styles
    "Modern": "Moderne", "Contemporary": "Contemporain", "Classic": "Classique", "Traditional": "Traditionnel",
    "Vintage": "Vintage", "Antique": "Antiquité", "Retro": "Rétro", "Rustic": "Rustique",
    "Industrial": "Industriel", "Minimalist": "Minimaliste", "Minimalism": "Minimalisme", "Bohemian": "Bohème",
    "Scandinavian": "Scandinave", "Scandinavian Modern": "Scandinave Moderne",
    "Mid-Century Modern": "Mid-Century Modern", "Art Deco": "Art Déco",
    "Art Nouveau": "Art Nouveau", "Bauhaus": "Bauhaus", "Victorian": "Victorien",
    "Empire": "Empire", "Regency": "Régence", "Georgian": "Géorgien", "Federal": "Fédéral",
    "Biedermeier": "Biedermeier", "Rococo Revival": "Rococo Revival", "Gothic Revival": "Néogothique",
    "Renaissance Revival": "Néo-Renaissance", "Louis Philippe": "Louis-Philippe", "Second Empire": "Second Empire",
    "Arts and Crafts": "Arts and Crafts", "Vienna Secession": "Sécession Viennoise", "De Stijl": "De Stijl",
    "Streamline Moderne": "Streamline Moderne", "Organic Modernism": "Modernisme Organique",
    "International Style": "Style International", "Hollywood Regency": "Hollywood Regency",
    "Brutalism": "Brutalisme", "Postmodern": "Postmoderne", "Memphis Group": "Memphis",
    "High-Tech": "High-Tech", "Space Age": "Space Age", "Pop Art Design": "Design Pop Art",
    "Shabby Chic": "Shabby Chic", "Transitional": "Transitionnel", "Contemporary Classic": "Classique Contemporain",
    "Modern Rustic": "Rustique Moderne", "Urban Loft": "Loft Urbain",
    "Japandi": "Japandi", "Wabi-Sabi": "Wabi-Sabi", "Biophilic Design": "Design Biophilique",
    "Sustainable / Eco Design": "Design Durable", "Eclectic": "Éclectique",
    "Neo-Classic Revival": "Néoclassique Revival", "French Provincial Revival": "Provençal Revival",
    "Colonial Revival": "Colonial Revival", "Craft Revival": "Craft Revival",
    "Coastal Modern": "Côtier Moderne", "Farmhouse Modern": "Farmhouse Moderne", "Bohemian Chic": "Bohème Chic",
    "French": "Français", "Italian": "Italien", "Asian": "Asiatique", "Oriental": "Oriental",
    "Coastal": "Côtier", "Farmhouse": "Farmhouse", "Mediterranean": "Méditerranéen"
  };
  
  // Fonction de traduction globale
  function translateTerm(term) {
    if (current_locale !== 'fr' || !term) return term;
    
    // 1. Correspondance exacte
    if (translationsFR[term]) return translationsFR[term];
    
    // 2. Essayer avec trim
    const trimmedTerm = term.trim();
    if (translationsFR[trimmedTerm]) return translationsFR[trimmedTerm];
    
    // 3. Chercher dans les clés de manière insensible à la casse
    const termLower = trimmedTerm.toLowerCase();
    for (const [key, value] of Object.entries(translationsFR)) {
      if (key.toLowerCase() === termLower) return value;
    }
    
    // 4. Traduire chaque mot individuellement
    const words = trimmedTerm.split(' ');
    if (words.length > 1) {
      const translatedWords = words.map(word => {
        // Chercher correspondance insensible à la casse
        const wordLower = word.toLowerCase();
        for (const [key, value] of Object.entries(translationsFR)) {
          if (key.toLowerCase() === wordLower) return value;
        }
        return word;
      });
      const result = translatedWords.join(' ');
      if (result !== trimmedTerm) return result;
    }
    
    return term;
  }
  const marketsMappingEntry = oblistGetMarketMapping(market_key, current_locale);
  const market_suffix = oblistResolveMarketSuffix(marketsMappingEntry, current_locale);
  const hypen = market_suffix === '' ? '' : '_';
  const market_region = marketsMappingEntry?.regions?.[0] || 'FR';
  var algoliaIndexName = oblistBuildIndexName('products', market_key, current_locale);
  console.warn('[Algolia] market_key=', market_key, 'mapping=', marketsMappingEntry?.market, marketsMappingEntry?.suffix, 'products=', algoliaIndexName);
  const client = AlgoliaProxy.searchClient();
  const currency = algolia?.helpers?.getMarketCurrency ? algolia.helpers.getMarketCurrency(market_region) : 'EUR';

  // ============================================
  // Fonction pour charger le contenu "No Results"
  // ============================================
  async function loadNoResultsContent(isEnglish) {
    const searchClient = client;
    
    // 0. "Did you mean?" - Chercher une suggestion dans Query Suggestions
    try {
      const didYouMeanContainer = document.getElementById('no-results-did-you-mean');
      if (didYouMeanContainer) {
        const urlParams = new URLSearchParams(window.location.search);
        const userQuery = urlParams.get('q') || '';
        
        if (userQuery && userQuery.length > 2) {
          // Chercher dans Query Suggestions avec typo tolerance
          const querySuggestionsIndex = algoliaShopify.config.index_prefix + 'products' + (current_locale === 'en' ? '' : '_france_fr') + '_query_suggestions';
          
          const response = await AlgoliaProxy.search([{
            indexName: querySuggestionsIndex,
            query: userQuery,
            params: {
              hitsPerPage: 5,
              typoTolerance: true,
            },
          }]);
          
          const suggestions = response.results[0]?.hits || [];
          
          // Trouver une suggestion différente de la query originale
          const suggestion = suggestions.find(s => 
            s.query && s.query.toLowerCase() !== userQuery.toLowerCase()
          );
          
          if (suggestion) {
            const didYouMeanText = isEnglish ? 'Did you mean' : 'Vouliez-vous dire';
            const searchUrl = `${window.Shopify.routes.root}search?q=${encodeURIComponent(suggestion.query)}`;
            
            didYouMeanContainer.innerHTML = `
              <p class="ais-no-results__did-you-mean-text">
                ${didYouMeanText} <a href="${searchUrl}" class="ais-no-results__did-you-mean-link">${suggestion.query}</a> ?
              </p>
            `;
          } else {
            didYouMeanContainer.style.display = 'none';
          }
        } else {
          didYouMeanContainer.style.display = 'none';
        }
      }
    } catch (error) {
      const didYouMeanContainer = document.getElementById('no-results-did-you-mean');
      if (didYouMeanContainer) didYouMeanContainer.style.display = 'none';
    }

    // 1. Charger les Trending Searches depuis notre index
    try {
      const trendingContainer = document.getElementById('no-results-trending-searches');
      if (trendingContainer) {
        const localeFilter = current_locale === 'en' ? 'en' : 'fr';
        const response = await AlgoliaProxy.search([{
          indexName: 'trending_searches',
          query: '',
          params: {
            hitsPerPage: 6,
            filters: `locale:"${localeFilter}"`,
          },
        }]);
        
        const trendingSearches = response.results[0]?.hits || [];
        
        if (trendingSearches.length > 0) {
          trendingContainer.innerHTML = trendingSearches.map(item => `
            <a href="${window.Shopify.routes.root}search?q=${encodeURIComponent(item.query)}" class="ais-no-results__search-tag">
              <svg class="ais-no-results__trending-icon" width="14" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.119 0L14.428.002l.108.019.077.026.074.036.077.053.072.067.051.063.043.072.04.097.015.054.014.108L15 6.875a.625.625 0 01-1.25.012V2.134L7.321 8.567a.625.625 0 01-.797.072l-.086-.072-2.063-2.059-3.308 3.309a.625.625 0 01-.884-.884l3.75-3.75a.625.625 0 01.797-.072l.086.072 2.063 2.059 5.986-5.992H8.119a.625.625 0 01-.615-.512L7.494.625A.625.625 0 018.119 0z" fill="#01690F"/>
              </svg>
              ${item.query}
            </a>
          `).join('');
        } else {
          trendingContainer.innerHTML = '';
          trendingContainer.parentElement.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('[No Results] Error loading trending searches:', error);
      const trendingContainer = document.getElementById('no-results-trending-searches');
      if (trendingContainer) {
        trendingContainer.innerHTML = '';
        trendingContainer.parentElement.style.display = 'none';
      }
    }

    // 2. Charger les Trending Products via Algolia Recommend
    try {
      const productsContainer = document.getElementById('no-results-trending-products');
      if (productsContainer) {
        let products = [];
        
        // Essayer Algolia Recommend - Trending Items
        const recommendIndex = algoliaIndexName;
        
        const response = await AlgoliaProxy.recommendClient().getRecommendations({
          requests: [{
            indexName: recommendIndex,
            model: 'trending-items',
            maxRecommendations: 8,
            threshold: 0,
          }],
        });
        
        products = response.results[0]?.hits || [];
        
        // Fallback
        if (products.length === 0) {
          const fallbackResponse = await AlgoliaProxy.search([{
            indexName: algoliaIndexName,
            query: '',
            params: { hitsPerPage: 8 },
          }]);
          products = fallbackResponse.results[0]?.hits || [];
        }
        
        if (products.length > 0) {
          productsContainer.innerHTML = products.map(hit => {
            hit = algolia?.helpers?.localizeHitData ? algolia.helpers.localizeHitData(hit) : hit;
            const priceView = hit.price 
              ? (algolia?.helpers?.getPriceDisplay ? algolia.helpers.getPriceDisplay(hit.currency, hit.price) : `${hit.currency || '€'}${Math.round(hit.price)}`)
              : `${hit.price_range}€`;
            const productUrl = algolia?.helpers?.instantsearchLink ? algolia.helpers.instantsearchLink(hit) : `/products/${hit.handle}`;
            const imageUrl = algolia?.helpers?.grandeImage ? algolia.helpers.grandeImage(hit) : hit.featured_image || '';
            
            // Badge Sold Out
            const soldOut = hit.meta?.custom?.soldout == true || hit.meta?.custom?.soldout == "true" || hit.inventory_available === false;
            const soldOutBadge = soldOut ? '<span class="ais-no-results__badge ais-no-results__badge--sold-out">SOLD OUT</span>' : '';
            
            return `
              <a href="${productUrl}" class="ais-no-results__product-card">
                <div class="ais-no-results__product-image">
                  ${soldOutBadge}
                  <img src="${imageUrl}" alt="${hit.title}" loading="lazy" />
                </div>
                <div class="ais-no-results__product-info">
                  <h4 class="ais-no-results__product-title">${hit.title}</h4>
                  <span class="ais-no-results__product-price">${priceView}</span>
                </div>
              </a>
            `;
          }).join('');
        } else {
          productsContainer.innerHTML = '';
          productsContainer.parentElement.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('[No Results] Error loading trending products:', error);
      const productsContainer = document.getElementById('no-results-trending-products');
      if (productsContainer) {
        productsContainer.innerHTML = '';
        productsContainer.parentElement.style.display = 'none';
      }
    }

    // 3. Charger les Catégories dynamiquement depuis la section "Image Column" de la home page
    try {
      const categoriesContainer = document.getElementById('no-results-categories');
      if (categoriesContainer) {
        // Charger les données depuis la home page (via la fonction du snippet)
        let categoriesData = [];
        if (typeof window.loadImageColumnCategories === 'function') {
          categoriesData = await window.loadImageColumnCategories();
        }
        
        // Limiter à 6 catégories maximum
        const maxCategories = 6;
        const displayCategories = categoriesData ? categoriesData.slice(0, maxCategories) : [];
        
        if (displayCategories.length > 0) {
          categoriesContainer.innerHTML = displayCategories.map(cat => {
            return `
              <a href="${cat.link}" class="ais-no-results__category-card">
                <div class="ais-no-results__category-image">
                  <img src="${cat.image}" alt="${cat.heading}" loading="lazy" />
                </div>
                <span class="ais-no-results__category-name">${cat.heading}</span>
              </a>
            `;
          }).join('');
        } else {
          // Cacher la section si pas de données
          categoriesContainer.innerHTML = '';
          categoriesContainer.parentElement.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('[No Results] Error loading categories:', error);
      const categoriesContainer = document.getElementById('no-results-categories');
      if (categoriesContainer) {
        categoriesContainer.innerHTML = '';
        categoriesContainer.parentElement.style.display = 'none';
      }
    }

    // 4. Cacher les éléments inutiles quand pas de résultats
    const facetsContainer = document.querySelector('.ais-facets-container');
    if (facetsContainer) {
      facetsContainer.style.display = 'none';
    }
    const customContainer = document.querySelector('.ais-custom-container');
    if (customContainer) {
      customContainer.classList.remove('ais-grid-columns');
    }
    
    // Cacher le "0 results for..."
    const statsContainer = document.getElementById('aisStats');
    if (statsContainer) {
      statsContainer.style.display = 'none';
    }
    
    // Cacher le bouton "Hide Filter"
    const filterButton = document.querySelector('.filter_hide_show_container');
    if (filterButton) {
      filterButton.style.display = 'none';
    }
    const mobileFilterButton = document.querySelector('.collectio_filters_jtpl');
    if (mobileFilterButton) {
      mobileFilterButton.style.display = 'none';
    }
    
    // Cacher le "Sort By"
    const sortByContainer = document.querySelector('.ais-sort-orders-container');
    if (sortByContainer) {
      sortByContainer.style.display = 'none';
    }
    
    // Cacher tout le header avec filtres et sort
    const topContainer = document.querySelector('.ais-custom-container-top');
    if (topContainer) {
      topContainer.style.display = 'none';
    }
  }

  if (typeof window.colorCategoryStates === 'undefined') {
    window.colorCategoryStates = {};
  }
  if (typeof window.materialCategoryStates === 'undefined') {
    window.materialCategoryStates = {};
  }
  if (typeof window.styleCategoryStates === 'undefined') {
    window.styleCategoryStates = {};
  }

  function syncFacetPanelChevrons(root) {
    (root || document).querySelectorAll('.ais-Panel-header').forEach((panelHeader) => {
      const panelBody = panelHeader.nextElementSibling;
      if (!panelBody?.classList.contains('ais-Panel-body')) return;
      panelHeader.classList.toggle('is-expanded', panelBody.classList.contains('ais-Panel-body--expanded'));
    });
  }

  function syncFilterButtonLabel(facetsShown) {
    const isFr = String(document.body.dataset.locale || current_locale || '').startsWith('fr');
    const showLabel = isFr ? 'Afficher le filtre' : 'Show Filter';
    const hideLabel = isFr ? 'Masquer le filtre' : 'Hide Filter';
    document.querySelectorAll('.filter_hide_show_container .filter_text').forEach((el) => {
      el.textContent = facetsShown ? hideLabel : showLabel;
    });
  }

  function isMobileFilterViewport() {
    return window.matchMedia('(max-width: 1000px)').matches;
  }

  // iOS Safari ignores body { overflow: hidden } — use position:fixed lock
  let oblistScrollLockY = 0;
  function lockOblistBodyScroll(lock) {
    const body = document.body;
    const html = document.documentElement;
    if (lock) {
      if (body.dataset.oblistScrollLocked === '1') return;
      oblistScrollLockY = window.scrollY || window.pageYOffset || 0;
      body.dataset.oblistScrollLocked = '1';
      body.style.position = 'fixed';
      body.style.top = '-' + oblistScrollLockY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      body.style.overflow = 'hidden';
      html.style.overflow = 'hidden';
      return;
    }
    // Keep lock while another overlay is still open
    if (
      body.classList.contains('oblist-filters-open') ||
      body.classList.contains('oblist-quick-facet-open')
    ) {
      return;
    }
    if (body.dataset.oblistScrollLocked !== '1') {
      body.style.overflow = '';
      html.style.overflow = '';
      return;
    }
    body.dataset.oblistScrollLocked = '';
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    html.style.overflow = '';
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, oblistScrollLockY);
    } else {
      window.scrollY = oblistScrollLockY;
    }
  }

  function setFacetsOpen(open) {
    const facets = document.querySelector('.ais-facets-container');
    const overlay = document.querySelector('.ais-overlay');
    const custom = document.querySelector('.ais-custom-container');
    if (!facets) return;

    const nextOpen = !!open;
    if (nextOpen && typeof window.__oblistCloseQuickFacet === 'function') {
      window.__oblistCloseQuickFacet();
    }
    facets.classList.toggle('ais-facets__shown', nextOpen);
    overlay?.classList.toggle('ais-overlay__shown', nextOpen);

    if (isMobileFilterViewport()) {
      document.documentElement.classList.toggle('oblist-filters-open', nextOpen);
      document.body.classList.toggle('oblist-filters-open', nextOpen);
      lockOblistBodyScroll(nextOpen);
      // Keep grid off on mobile — sheet is fixed fullscreen
      custom?.classList.remove('ais-grid-columns');
    } else {
      document.documentElement.classList.remove('oblist-filters-open');
      document.body.classList.remove('oblist-filters-open');
      lockOblistBodyScroll(false);
      custom?.classList.toggle('ais-grid-columns', nextOpen);
    }

    syncFilterButtonLabel(nextOpen);
  }

  // Desktop sidebar open must not become a mobile fullscreen sheet on resize
  function bindOblistFacetsViewportGuard() {
    if (document.documentElement.dataset.oblistFacetsViewportGuard === '1') return;
    if (typeof window.matchMedia !== 'function') return;
    document.documentElement.dataset.oblistFacetsViewportGuard = '1';

    const mq = window.matchMedia('(max-width: 1000px)');
    let wasMobile = mq.matches;

    const onChange = () => {
      const nowMobile = mq.matches;
      if (nowMobile === wasMobile) return;

      if (nowMobile && !wasMobile) {
        setFacetsOpen(false);
        if (typeof window.__oblistCloseQuickFacet === 'function') {
          window.__oblistCloseQuickFacet();
        }
      } else if (!nowMobile && wasMobile) {
        if (typeof window.__oblistCloseQuickFacet === 'function') {
          window.__oblistCloseQuickFacet();
        }
        const isSearch = window.location.pathname.indexOf('/search') !== -1;
        setFacetsOpen(!!isSearch);
      }
      wasMobile = nowMobile;
    };

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onChange);
    }
  }

  function updateMobileFiltersResultsCount(nbHits) {
    const countEls = document.querySelectorAll('[data-oblist-results-count]');
    const applyBtns = document.querySelectorAll('[data-oblist-apply-filters], [data-oblist-quick-apply]');
    if (!countEls.length && !applyBtns.length) return;

    const n = Math.max(0, Number(nbHits) || 0);
    const isFr = String(document.body.dataset.locale || current_locale || '').startsWith('fr');
    const formatted = n.toLocaleString(isFr ? 'fr-FR' : 'en-US');
    const emptyLabel = isFr ? 'Aucun résultat' : 'No results';
    const label = n === 0
      ? emptyLabel
      : (isFr
        ? (n === 1 ? 'Afficher 1 résultat' : `Afficher ${formatted} résultats`)
        : (n === 1 ? 'Show 1 result' : `Show ${formatted} results`));
    const prefixText = isFr ? 'Afficher ' : 'Show ';
    const suffixText = isFr
      ? (n === 1 ? ' résultat' : ' résultats')
      : (n === 1 ? ' result' : ' results');

    countEls.forEach((countEl) => {
      countEl.textContent = formatted;
    });

    applyBtns.forEach((applyBtn) => {
      applyBtn.disabled = n === 0;
      applyBtn.setAttribute('aria-disabled', n === 0 ? 'true' : 'false');
      applyBtn.classList.toggle('is-disabled', n === 0);
      applyBtn.setAttribute('aria-label', label);

      const prefix = applyBtn.querySelector('[data-oblist-results-prefix]');
      const count = applyBtn.querySelector('[data-oblist-results-count]');
      const suffix = applyBtn.querySelector('[data-oblist-results-suffix]');

      if (n === 0) {
        // Flat label — don't invite closing onto an empty results page
        if (prefix) prefix.textContent = emptyLabel;
        if (count) count.textContent = '';
        if (suffix) suffix.textContent = '';
      } else {
        if (prefix) prefix.textContent = prefixText;
        if (count) count.textContent = formatted;
        if (suffix) suffix.textContent = suffixText;
      }
    });
  }

  function scrollFacetPanelIntoView(header) {
    if (!header || !isMobileFilterViewport()) return;
    const scroller = document.getElementById('ais-facets');
    if (!scroller) return;
    requestAnimationFrame(() => {
      const headerRect = header.getBoundingClientRect();
      const scrollerRect = scroller.getBoundingClientRect();
      const nextTop = Math.max(0, scroller.scrollTop + (headerRect.top - scrollerRect.top) - 12);
      // Safari < 15.4: smooth scrollTo options can throw / no-op
      try {
        scroller.scrollTo({ top: nextTop, behavior: 'smooth' });
      } catch (e) {
        scroller.scrollTop = nextTop;
      }
    });
  }
  window.__oblistScrollFacetIntoView = scrollFacetPanelIntoView;

  // Shared active-filter count (search quick bar + collection Filters entry)
  const OBLIST_PRICE_FILTER_MIN = 0;
  const OBLIST_PRICE_FILTER_MAX = 100000;

  function isOblistPriceAttribute(attr) {
    return attr === 'price'
      || /(?:^|[._])price$/i.test(String(attr || ''))
      || String(attr || '').indexOf('market_pricing') !== -1;
  }

  function hasOblistActivePriceFilter(state) {
    if (!state || !state.numericRefinements) return false;
    return Object.keys(state.numericRefinements).some((attr) => {
      if (!isOblistPriceAttribute(attr)) return false;
      const ops = state.numericRefinements[attr] || {};
      const minVals = (ops['>='] || ops['>']) || [];
      const maxVals = (ops['<='] || ops['<']) || [];
      const min = minVals[0];
      const max = maxVals[0];
      const minN = min == null || min === '' ? null : Number(min);
      const maxN = max == null || max === '' ? null : Number(max);
      if (minN != null && Number.isFinite(minN) && minN > OBLIST_PRICE_FILTER_MIN) return true;
      if (maxN != null && Number.isFinite(maxN) && maxN < OBLIST_PRICE_FILTER_MAX) return true;
      if ((ops['='] || []).length) return true;
      return false;
    });
  }

  function countOblistActiveFilters() {
    const helper = typeof instant !== 'undefined' && instant.search && instant.search.helper;
    if (!helper || !helper.state) return 0;
    let n = 0;
    try {
      const state = helper.state;
      const skipFacetAttrs = {
        'meta.custom.badges': true,
        'meta.mtoproduct.mtop': true,
        'meta.vintageconditionreport.vintagecr': true,
        'meta.maxdeliverytime.maxdeltime': true,
        // Delivery radios refine many week values (0,1,…) — count as one chip
        'meta.mindeliverytime.mindeltime': true,
      };
      const facets = state.facetsRefinements || {};
      Object.keys(facets).forEach((attr) => {
        if (skipFacetAttrs[attr]) return;
        n += (facets[attr] || []).length;
      });
      const disj = state.disjunctiveFacetsRefinements || {};
      Object.keys(disj).forEach((attr) => {
        if (skipFacetAttrs[attr]) return;
        n += (disj[attr] || []).length;
      });
      const deliveryWeeks = []
        .concat((facets['meta.mindeliverytime.mindeltime']) || [])
        .concat((disj['meta.mindeliverytime.mindeltime']) || []);
      if (deliveryWeeks.length) n += 1;
      const numeric = state.numericRefinements || {};
      let priceCounted = false;
      Object.keys(numeric).forEach((attr) => {
        if (attr === 'inventory_quantity') return;
        if (isOblistPriceAttribute(attr)) {
          if (!priceCounted && hasOblistActivePriceFilter(state)) {
            n += 1;
            priceCounted = true;
          }
          return;
        }
        const ops = numeric[attr] || {};
        Object.keys(ops).forEach((op) => {
          if ((ops[op] || []).length) n += 1;
        });
      });
      if (window.__oblistInStockQuantity && window.__oblistInStockQuantity.isEnabled()) n += 1;

      const creationActive = !!(window.__oblistItemTypeExclusive && (
        window.__oblistItemTypeExclusive.isMto() ||
        ((helper.getRefinements('meta.custom.badges') || []).some((r) => /vintage/i.test(String(r.value))))
      ));
      if (creationActive) n += 1;

      if ((helper.getRefinements('meta.vintageconditionreport.vintagecr') || []).length) n += 1;
      if ((helper.getRefinements('meta.maxdeliverytime.maxdeltime') || []).length) n += 1;
    } catch (e) { /* ok */ }

    return Math.max(0, n);
  }

  // Collection mobile only: match search "Filters" chip (icon + active count), no Sort/Price chips
  function initOblistCollectionFiltersEntry() {
    if (document.documentElement.dataset.oblistCollectionFiltersInit === '1') return;
    // Same breakpoint as theme md:hidden / custom.css collection floating filter
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    const host = document.querySelector(
      '.jtpl_cstm_filt_slide facet-floating-filter.collectio_filters_jtpl, facet-floating-filter.collectio_filters_jtpl:not(.search_filters)'
    );
    if (!host) return;
    // Search page uses its own quick-filters bar; leave that floating entry alone
    if (host.classList.contains('search_filters')) return;
    if (document.querySelector('.ais-quick-filters[data-oblist-quick-filters]')) return;

    document.documentElement.dataset.oblistCollectionFiltersInit = '1';
    host.classList.add('oblist-collection-filters-match');

    const isFr = () => String(document.body.dataset.locale || current_locale || '').startsWith('fr');
    const label = isFr() ? 'Filtres' : 'Filters';
    const iconSvg =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M4 7h9M17 7h3M4 17h3M11 17h9" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/>' +
        '<circle cx="15" cy="7" r="2.25" stroke="currentColor" stroke-width="1.5"/>' +
        '<circle cx="9" cy="17" r="2.25" stroke="currentColor" stroke-width="1.5"/>' +
      '</svg>';

    host.innerHTML =
      `<button type="button" class="ais-quick-filters__btn ais-quick-filters__btn--all ais-collection-filters-btn" aria-label="${label}">` +
        `<span class="ais-quick-filters__icon" aria-hidden="true">${iconSvg}</span>` +
        `<span data-oblist-collection-filters-label>${label}</span>` +
        `<span class="ais-quick-filters__count" data-oblist-collection-filters-count hidden></span>` +
      `</button>`;

    function syncCollectionFiltersCount() {
      const count = countOblistActiveFilters();
      const countEl = host.querySelector('[data-oblist-collection-filters-count]');
      const btn = host.querySelector('.ais-collection-filters-btn');
      if (countEl) {
        if (count > 0) {
          countEl.hidden = false;
          countEl.textContent = `(${count})`;
        } else {
          countEl.hidden = true;
          countEl.textContent = '';
        }
      }
      if (btn) {
        btn.setAttribute('aria-label', count > 0 ? `${label} (${count})` : label);
        btn.classList.toggle('is-active', count > 0);
      }
    }

    if (typeof instant !== 'undefined' && instant.search) {
      instant.search.on('render', syncCollectionFiltersCount);
    }
    syncCollectionFiltersCount();
  }

  // If InstantSearch boots on desktop then the viewport shrinks to mobile, mount once
  if (typeof window.matchMedia === 'function') {
    const collectionFiltersMq = window.matchMedia('(max-width: 767px)');
    const onCollectionFiltersMq = (event) => {
      if (event.matches) initOblistCollectionFiltersEntry();
    };
    if (typeof collectionFiltersMq.addEventListener === 'function') {
      collectionFiltersMq.addEventListener('change', onCollectionFiltersMq);
    } else if (typeof collectionFiltersMq.addListener === 'function') {
      collectionFiltersMq.addListener(onCollectionFiltersMq);
    }
  }

  function initOblistQuickFilters() {
    if (document.documentElement.dataset.oblistQuickFiltersInit === '1') return;
    document.documentElement.dataset.oblistQuickFiltersInit = '1';

    const isFr = () => String(document.body.dataset.locale || current_locale || '').startsWith('fr');
    const chevron = '<span class="ais-quick-filters__chevron" aria-hidden="true"></span>';
    const labels = () => ({
      all: isFr() ? 'Filtres' : 'Filters',
      sort: translateTerm('Sort by'),
      price: translateTerm('Price'),
      product_type: translateTerm('Product Type'),
      creation: translateTerm('Creation Type'),
      applyPrefix: isFr() ? 'Afficher ' : 'Show ',
      applySuffix: isFr() ? ' résultats' : ' results',
      close: isFr() ? 'Fermer' : 'Close',
      clearAll: isFr() ? 'Tout effacer' : 'Clear all',
      remove: isFr() ? 'Retirer le filtre' : 'Remove filter',
      inStock: translateTerm('In stock only'),
      vintage: translateTerm('Antique and vintage'),
      mto: translateTerm('New and made to order'),
    });

    function escapeQuickHtml(str) {
      return String(str || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    // Facet values sometimes arrive as JSON-ish noise: ["United States of America"]
    function cleanFacetDisplayValue(value) {
      let s = String(value == null ? '' : value).trim();
      if (!s) return '';
      if ((s.charAt(0) === '[' && s.charAt(s.length - 1) === ']')
        || (s.charAt(0) === '{' && s.charAt(s.length - 1) === '}')) {
        try {
          const parsed = JSON.parse(s);
          if (Array.isArray(parsed)) {
            s = parsed.map((v) => String(v == null ? '' : v).trim()).filter(Boolean).join(', ');
          } else if (parsed != null && typeof parsed !== 'object') {
            s = String(parsed);
          }
        } catch (e) {
          s = s.replace(/^\[+|\]+$/g, '').trim();
        }
      }
      s = s.replace(/^["']+|["']+$/g, '').trim();
      s = s.replace(/^\[+\s*["']?|["']?\s*\]+$/g, '').trim();
      s = s.replace(/^[\[\]"']+|[\[\]"']+$/g, '').trim();
      return s;
    }

    // Search top bar only (collections keep their existing mobile filter entry)
    const mountHost = document.querySelector('.ais-custom-container-top');
    if (!mountHost) return;

    const bar = document.createElement('div');
    bar.className = 'ais-quick-filters';
    bar.setAttribute('data-oblist-quick-filters', '1');
    const L0 = labels();
    bar.innerHTML =
      '<div class="ais-quick-filters__scroll">' +
        `<button type="button" class="ais-quick-filters__btn ais-quick-filters__btn--all" data-oblist-quick="all">` +
          `<span class="ais-quick-filters__icon" aria-hidden="true">` +
            `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 7h9M17 7h3M4 17h3M11 17h9" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/><circle cx="15" cy="7" r="2.25" stroke="currentColor" stroke-width="1.5"/><circle cx="9" cy="17" r="2.25" stroke="currentColor" stroke-width="1.5"/></svg>` +
          `</span>` +
          `<span data-oblist-quick-all-label>${L0.all}</span>` +
          `<span class="ais-quick-filters__count" data-oblist-quick-all-count hidden></span>` +
        `</button>` +
        `<button type="button" class="ais-quick-filters__btn" data-oblist-quick="sort"><span>${L0.sort}</span>${chevron}</button>` +
        `<button type="button" class="ais-quick-filters__btn" data-oblist-quick="price"><span>${L0.price}</span>${chevron}</button>` +
        `<button type="button" class="ais-quick-filters__btn" data-oblist-quick="product_type"><span>${L0.product_type}</span>${chevron}</button>` +
        `<button type="button" class="ais-quick-filters__btn" data-oblist-quick="creation"><span>${L0.creation}</span>${chevron}</button>` +
      '</div>' +
      '<div class="ais-quick-filters__active" data-oblist-active-row hidden>' +
        '<div class="ais-quick-filters__active-scroll" data-oblist-active-tags></div>' +
        `<button type="button" class="ais-quick-filters__clear-all" data-oblist-clear-filters>${L0.clearAll}</button>` +
      '</div>';

    mountHost.appendChild(bar);
    const activeRow = bar.querySelector('[data-oblist-active-row]');
    const activeTagsEl = bar.querySelector('[data-oblist-active-tags]');

    // Desktop: chips sit above the product grid (hits column), not under Hide Filter
    function syncActiveFiltersPlacement() {
      if (!activeRow) return;
      const desktopHost = document.querySelector('[data-oblist-desktop-active-host]');
      const desktop = !isMobileFilterViewport();
      if (desktop && desktopHost) {
        if (activeRow.parentElement !== desktopHost) {
          desktopHost.appendChild(activeRow);
        }
        bar.classList.add('ais-quick-filters--desktop-split');
        return;
      }
      bar.classList.remove('ais-quick-filters--desktop-split');
      if (activeRow.parentElement !== bar) {
        const scroll = bar.querySelector('.ais-quick-filters__scroll');
        if (scroll && scroll.nextSibling) {
          bar.insertBefore(activeRow, scroll.nextSibling);
        } else {
          bar.appendChild(activeRow);
        }
      }
    }
    syncActiveFiltersPlacement();
    if (typeof window.matchMedia === 'function') {
      const placeMq = window.matchMedia('(max-width: 1000px)');
      const onPlaceMq = () => syncActiveFiltersPlacement();
      if (typeof placeMq.addEventListener === 'function') {
        placeMq.addEventListener('change', onPlaceMq);
      } else if (typeof placeMq.addListener === 'function') {
        placeMq.addListener(onPlaceMq);
      }
    }

    // Sticky mini-header: same main filters (no active-tags row, no category chips)
    const miniSlot = document.getElementById('miniHeaderQuickFilters');
    let miniBar = null;
    if (miniSlot) {
      miniBar = document.createElement('div');
      miniBar.className = 'ais-quick-filters ais-quick-filters--mini';
      miniBar.setAttribute('data-oblist-quick-filters', 'mini');
      miniBar.innerHTML =
        '<div class="ais-quick-filters__scroll">' +
          `<button type="button" class="ais-quick-filters__btn ais-quick-filters__btn--all" data-oblist-quick="all">` +
            `<span class="ais-quick-filters__icon" aria-hidden="true">` +
              `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 7h9M17 7h3M4 17h3M11 17h9" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/><circle cx="15" cy="7" r="2.25" stroke="currentColor" stroke-width="1.5"/><circle cx="9" cy="17" r="2.25" stroke="currentColor" stroke-width="1.5"/></svg>` +
            `</span>` +
            `<span data-oblist-quick-all-label>${L0.all}</span>` +
            `<span class="ais-quick-filters__count" data-oblist-quick-all-count hidden></span>` +
          `</button>` +
          `<button type="button" class="ais-quick-filters__btn" data-oblist-quick="sort"><span>${L0.sort}</span>${chevron}</button>` +
          `<button type="button" class="ais-quick-filters__btn" data-oblist-quick="price"><span>${L0.price}</span>${chevron}</button>` +
          `<button type="button" class="ais-quick-filters__btn" data-oblist-quick="product_type"><span>${L0.product_type}</span>${chevron}</button>` +
          `<button type="button" class="ais-quick-filters__btn" data-oblist-quick="creation"><span>${L0.creation}</span>${chevron}</button>` +
        '</div>';
      miniSlot.appendChild(miniBar);
      miniSlot.classList.add('is-ready');
    }

    function forEachQuickFiltersRoot(fn) {
      fn(bar);
      if (miniBar) fn(miniBar);
    }

    const sheet = document.createElement('div');
    sheet.className = 'ais-quick-facet-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="ais-quick-facet-sheet__panel" role="dialog" aria-modal="true">' +
        '<div class="ais-quick-facet-sheet__header">' +
          '<p class="ais-quick-facet-sheet__title" data-oblist-quick-title></p>' +
          `<button type="button" class="ais-quick-facet-sheet__close" aria-label="${L0.close}">` +
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor" stroke-width="1"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="ais-quick-facet-sheet__body" data-oblist-quick-body></div>' +
        '<div class="ais-quick-facet-sheet__footer">' +
          `<button type="button" class="ais-quick-facet-sheet__apply" data-oblist-quick-apply>` +
            `<span data-oblist-results-prefix>${L0.applyPrefix}</span>` +
            `<span data-oblist-results-count>0</span>` +
            `<span data-oblist-results-suffix>${L0.applySuffix}</span>` +
          `</button>` +
        '</div>' +
      '</div>';
    document.body.appendChild(sheet);

    const overlay = document.createElement('div');
    overlay.className = 'ais-quick-facet-overlay';
    overlay.hidden = true;
    document.body.appendChild(overlay);

    let activeKey = null;
    const titleEl = sheet.querySelector('[data-oblist-quick-title]');
    const bodyEl = sheet.querySelector('[data-oblist-quick-body]');
    const applyBtn = sheet.querySelector('[data-oblist-quick-apply]');

    function getQuickFacetSource(key) {
      const byData = document.querySelector(`[data-oblist-quick-facet="${key}"]`);
      if (byData) return byData;
      if (key === 'sort') return document.getElementById('ais-mobile-sort-by');
      return null;
    }

    function ensureSlot(source) {
      if (!source) return null;
      if (!source._oblistQuickSlot || !source._oblistQuickSlot.isConnected) {
        source._oblistQuickSlot = document.createComment('oblist-quick-facet-slot');
        if (source.parentNode) {
          source.parentNode.insertBefore(source._oblistQuickSlot, source);
        }
      }
      return source._oblistQuickSlot;
    }

    function expandSourcePanels(source) {
      if (!source) return;
      source.querySelectorAll('.ais-Panel-body').forEach((el) => {
        el.classList.add('ais-Panel-body--expanded');
      });
      source.querySelectorAll('.ais-Panel-header').forEach((el) => {
        el.classList.add('is-expanded');
      });
    }

    function closeQuickFacet() {
      if (!activeKey) {
        sheet.hidden = true;
        overlay.hidden = true;
        document.documentElement.classList.remove('oblist-quick-facet-open');
        document.body.classList.remove('oblist-quick-facet-open');
        lockOblistBodyScroll(false);
        forEachQuickFiltersRoot((root) => {
          root.querySelectorAll('.ais-quick-filters__btn.is-open').forEach((btn) => {
            btn.classList.remove('is-open');
          });
        });
        return;
      }
      const source = bodyEl.firstElementChild;
      const slot = source && source._oblistQuickSlot;
      if (source && slot && slot.parentNode) {
        slot.parentNode.insertBefore(source, slot);
      }
      activeKey = null;
      sheet.hidden = true;
      overlay.hidden = true;
      document.documentElement.classList.remove('oblist-quick-facet-open');
      document.body.classList.remove('oblist-quick-facet-open');
      lockOblistBodyScroll(false);
      forEachQuickFiltersRoot((root) => {
        root.querySelectorAll('.ais-quick-filters__btn.is-open').forEach((btn) => {
          btn.classList.remove('is-open');
        });
      });
    }

    window.__oblistCloseQuickFacet = closeQuickFacet;

    function openQuickFacet(key) {
      if (!isMobileFilterViewport()) return;
      if (activeKey === key) {
        closeQuickFacet();
        return;
      }
      closeQuickFacet();
      setFacetsOpen(false);

      const source = getQuickFacetSource(key);
      if (!source) {
        console.warn('[Oblist quick filters] missing facet source for', key);
        // Fallback: open full filters sheet only for "all"; never for a missing quick key
        return;
      }

      const slot = ensureSlot(source);
      if (!slot) {
        console.warn('[Oblist quick filters] could not slot facet source for', key);
        return;
      }
      if (source.parentNode !== bodyEl) {
        bodyEl.appendChild(source);
      }
      expandSourcePanels(source);

      const L = labels();
      const titleMap = {
        sort: L.sort,
        price: L.price,
        product_type: L.product_type,
        creation: L.creation,
      };
      if (titleEl) titleEl.textContent = titleMap[key] || L.all;

      activeKey = key;
      sheet.hidden = false;
      overlay.hidden = false;
      document.documentElement.classList.add('oblist-quick-facet-open');
      document.body.classList.add('oblist-quick-facet-open');
      lockOblistBodyScroll(true);

      forEachQuickFiltersRoot((root) => {
        root.querySelectorAll('.ais-quick-filters__btn').forEach((btn) => {
          btn.classList.toggle('is-open', btn.getAttribute('data-oblist-quick') === key);
        });
      });

      const nbHits = (typeof instant !== 'undefined' && instant.search && instant.search.helper
        && instant.search.helper.lastResults)
        ? instant.search.helper.lastResults.nbHits
        : null;
      if (nbHits != null) updateMobileFiltersResultsCount(nbHits);
    }

    // connectRange keeps price at [0, 100000] in state — NOT a user filter
    const PRICE_FILTER_MIN = 0;
    const PRICE_FILTER_MAX = 100000;

    function isPriceAttribute(attr) {
      return attr === 'price' || /(?:^|[._])price$/i.test(String(attr || '')) || String(attr || '').indexOf('market_pricing') !== -1;
    }

    function getPriceBounds(ops) {
      const minVals = (ops && (ops['>='] || ops['>'])) || [];
      const maxVals = (ops && (ops['<='] || ops['<'])) || [];
      const min = minVals[0];
      const max = maxVals[0];
      return {
        min: min == null || min === '' ? null : Number(min),
        max: max == null || max === '' ? null : Number(max),
      };
    }

    function hasActivePriceFilter(state) {
      if (!state || !state.numericRefinements) return false;
      return Object.keys(state.numericRefinements).some((attr) => {
        if (!isPriceAttribute(attr)) return false;
        const ops = state.numericRefinements[attr] || {};
        const { min, max } = getPriceBounds(ops);
        if (min != null && Number.isFinite(min) && min > PRICE_FILTER_MIN) return true;
        if (max != null && Number.isFinite(max) && max < PRICE_FILTER_MAX) return true;
        if ((ops['='] || []).length) return true;
        return false;
      });
    }

    function countActiveFilters() {
      return countOblistActiveFilters();
    }

    function formatActivePriceLabel(min, max) {
      const sym = typeof getPriceCurrencySymbol === 'function' ? getPriceCurrencySymbol() : '€';
      const fmt = (v) => Number(v).toLocaleString(isFr() ? 'fr-FR' : 'en-US');
      if (min != null && max != null) {
        return isFr()
          ? `${fmt(min)} ${sym} – ${fmt(max)} ${sym}`
          : `${sym}${fmt(min)} – ${sym}${fmt(max)}`;
      }
      if (max != null) return `< ${fmt(max)}${sym}`;
      if (min != null) return `> ${fmt(min)}${sym}`;
      return '';
    }

    function collectActiveFilterTags() {
      const helper = typeof instant !== 'undefined' && instant.search && instant.search.helper;
      const state = helper && helper.state;
      if (!helper || !state) return [];
      const L = labels();
      const tags = [];
      const defaultIndex = (instant && instant.sortOrders && instant.sortOrders[0] && instant.sortOrders[0].value)
        || (activeSortOrders && activeSortOrders[0] && activeSortOrders[0].value)
        || '';

      // Sort (non-default)
      if (defaultIndex && state.index && state.index !== defaultIndex) {
        const orders = (instant && instant.sortOrders) || activeSortOrders || [];
        const match = orders.find((o) => o.value === state.index);
        tags.push({
          key: 'sort',
          value: state.index,
          label: match ? match.label : L.sort,
        });
      }

      // Price — pick the attribute that actually has a user-set range
      // (not the default connectRange [0, 100000] on `price`)
      if (hasActivePriceFilter(state)) {
        const numeric = state.numericRefinements || {};
        let bestAttr = null;
        let bestMin = null;
        let bestMax = null;
        Object.keys(numeric).forEach((attr) => {
          if (!isPriceAttribute(attr)) return;
          const { min, max } = getPriceBounds(numeric[attr] || {});
          const meaningfulMin = min != null && Number.isFinite(min) && min > PRICE_FILTER_MIN ? min : null;
          const meaningfulMax = max != null && Number.isFinite(max) && max < PRICE_FILTER_MAX ? max : null;
          if (meaningfulMin == null && meaningfulMax == null) return;
          bestAttr = attr;
          bestMin = meaningfulMin;
          bestMax = meaningfulMax;
        });
        // Fallback: prefer the live market price attribute
        if (!bestAttr && typeof getOblistPriceAttribute === 'function') {
          const preferred = getOblistPriceAttribute();
          if (numeric[preferred]) {
            const { min, max } = getPriceBounds(numeric[preferred] || {});
            bestAttr = preferred;
            bestMin = min != null && min > PRICE_FILTER_MIN ? min : null;
            bestMax = max != null && max < PRICE_FILTER_MAX ? max : null;
          }
        }
        const label = formatActivePriceLabel(bestMin, bestMax);
        if (label && bestAttr) {
          tags.push({ key: 'price', value: bestAttr, label });
        } else if (hasActivePriceFilter(state)) {
          // Still show a generic tag so the row never stays empty when count > 0
          const priceAttr = (typeof getOblistPriceAttribute === 'function' && getOblistPriceAttribute()) || 'price';
          tags.push({ key: 'price', value: priceAttr, label: L.price });
        }
      }

      // Product type(s)
      const productTypes = []
        .concat((state.facetsRefinements && state.facetsRefinements.product_type) || [])
        .concat((state.disjunctiveFacetsRefinements && state.disjunctiveFacetsRefinements.product_type) || []);
      Array.from(new Set(productTypes)).forEach((value) => {
        const clean = cleanFacetDisplayValue(value);
        tags.push({
          key: 'product_type',
          value: String(value),
          label: translateTerm(clean || String(value)),
        });
      });

      // Creation type
      const isMto = !!(window.__oblistItemTypeExclusive && window.__oblistItemTypeExclusive.isMto());
      const isVintage = (helper.getRefinements('meta.custom.badges') || [])
        .some((r) => /vintage/i.test(String(r.value)));
      if (isMto) {
        tags.push({ key: 'creation', value: 'mto', label: L.mto });
      } else if (isVintage) {
        tags.push({ key: 'creation', value: 'vintage', label: L.vintage });
      }

      // In stock
      if (window.__oblistInStockQuantity && window.__oblistInStockQuantity.isEnabled()) {
        tags.push({ key: 'in_stock', value: '1', label: L.inStock });
      }

      // Delivery options — one chip for the radio bucket (not one chip per week value)
      const DELIVERY_ATTR = 'meta.mindeliverytime.mindeltime';
      const deliveryWeeks = []
        .concat((state.facetsRefinements && state.facetsRefinements[DELIVERY_ATTR]) || [])
        .concat((state.disjunctiveFacetsRefinements && state.disjunctiveFacetsRefinements[DELIVERY_ATTR]) || [])
        .map(String);
      if (deliveryWeeks.length) {
        const refined = new Set(deliveryWeeks);
        const universe = Array.from(new Set(
          [0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14].concat(
            deliveryWeeks.map((w) => parseInt(w, 10)).filter((n) => Number.isFinite(n))
          )
        )).sort((a, b) => a - b);
        const deliveryBuckets = [
          { id: 'd7', label: 'Within 7 days', maxWeek: 1 },
          { id: 'd14', label: 'Within 14 days', maxWeek: 2 },
          { id: 'd30', label: 'Within 30 days', maxWeek: 4 },
          { id: 'd30plus', label: '+30 days', minWeek: 5 },
        ];
        let deliveryLabel = translateTerm('Delivery options');
        for (let i = 0; i < deliveryBuckets.length; i++) {
          const bucket = deliveryBuckets[i];
          const weeks = bucket.maxWeek != null
            ? universe.filter((w) => w >= 0 && w <= bucket.maxWeek).map(String)
            : universe.filter((w) => w >= bucket.minWeek).map(String);
          if (weeks.length && weeks.length === refined.size && weeks.every((w) => refined.has(w))) {
            deliveryLabel = translateTerm(bucket.label);
            break;
          }
        }
        tags.push({
          key: 'delivery',
          value: DELIVERY_ATTR,
          label: deliveryLabel,
          attr: DELIVERY_ATTR,
        });
      }

      // Other facet refinements from full sheet (colour, materials, style, location…)
      const skipAttrs = {
        product_type: true,
        'meta.custom.badges': true,
        'meta.mtoproduct.mtop': true,
        'meta.vintageconditionreport.vintagecr': true,
        'meta.maxdeliverytime.maxdeltime': true,
        'meta.mindeliverytime.mindeltime': true,
      };
      const pushFacetValues = (map, mode) => {
        Object.keys(map || {}).forEach((attr) => {
          if (skipAttrs[attr]) return;
          (map[attr] || []).forEach((value) => {
            const clean = cleanFacetDisplayValue(value);
            tags.push({
              key: mode,
              value: `${attr}::${value}`,
              label: translateTerm(clean || String(value)),
              attr,
              facetValue: String(value),
            });
          });
        });
      };
      pushFacetValues(state.facetsRefinements, 'facet');
      pushFacetValues(state.disjunctiveFacetsRefinements, 'disjunctive');

      return tags;
    }

    function syncActiveFilterTags() {
      if (!activeRow || !activeTagsEl) return;
      const tags = collectActiveFilterTags();
      const L = labels();
      if (!tags.length) {
        activeRow.hidden = true;
        activeTagsEl.innerHTML = '';
        return;
      }
      activeRow.hidden = false;
      activeTagsEl.innerHTML = tags.map((tag) => {
        const removeValue = tag.facetValue != null
          ? escapeQuickHtml(tag.value)
          : escapeQuickHtml(tag.value);
        return (
          '<span class="ais-quick-filters__tag">' +
            `<span class="ais-quick-filters__tag-label">${escapeQuickHtml(tag.label)}</span>` +
            `<button type="button" class="ais-quick-filters__tag-remove" aria-label="${escapeQuickHtml(L.remove)}"` +
              ` data-oblist-remove-filter="${escapeQuickHtml(tag.key)}"` +
              ` data-oblist-remove-value="${removeValue}"` +
              (tag.attr ? ` data-oblist-remove-attr="${escapeQuickHtml(tag.attr)}"` : '') +
              (tag.facetValue ? ` data-oblist-remove-facet-value="${escapeQuickHtml(tag.facetValue)}"` : '') +
            '>' +
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor" stroke-width="1.5"/></svg>' +
            '</button>' +
          '</span>'
        );
      }).join('');
      const clearBtn = activeRow.querySelector('[data-oblist-clear-filters]');
      if (clearBtn) clearBtn.textContent = L.clearAll;
    }

    function removeActiveFilter(key, value, attr, facetValue) {
      const helper = typeof instant !== 'undefined' && instant.search && instant.search.helper;
      if (!helper) return;

      if (key === 'sort') {
        const defaultIndex = (instant && instant.sortOrders && instant.sortOrders[0] && instant.sortOrders[0].value)
          || (activeSortOrders && activeSortOrders[0] && activeSortOrders[0].value);
        if (defaultIndex) helper.setIndex(defaultIndex).search();
        return;
      }

      if (key === 'price') {
        const priceAttr = value || (typeof getOblistPriceAttribute === 'function' ? getOblistPriceAttribute() : 'price');
        try { helper.clearRefinements(priceAttr); } catch (e) { /* ok */ }
        if (priceAttr !== 'price') {
          try { helper.clearRefinements('price'); } catch (e2) { /* ok */ }
        }
        helper.search();
        return;
      }

      if (key === 'product_type') {
        try { helper.removeFacetRefinement('product_type', value); } catch (e) { /* ok */ }
        try { helper.removeDisjunctiveFacetRefinement('product_type', value); } catch (e2) { /* ok */ }
        helper.search();
        return;
      }

      if (key === 'creation') {
        if (window.__oblistItemTypeExclusive && typeof window.__oblistItemTypeExclusive.resetAll === 'function') {
          window.__oblistItemTypeExclusive.resetAll(helper);
        }
        helper.search();
        return;
      }

      if (key === 'in_stock') {
        if (window.__oblistInStockQuantity && typeof window.__oblistInStockQuantity.clearAndApply === 'function') {
          window.__oblistInStockQuantity.clearAndApply(helper);
        }
        helper.search();
        return;
      }

      if (key === 'delivery') {
        const deliveryAttr = attr || 'meta.mindeliverytime.mindeltime';
        try { helper.clearRefinements(deliveryAttr); } catch (e) { /* ok */ }
        helper.search();
        return;
      }

      if ((key === 'facet' || key === 'disjunctive') && attr) {
        const v = facetValue || value;
        if (key === 'facet') {
          try { helper.removeFacetRefinement(attr, v); } catch (e) { /* ok */ }
        } else {
          try { helper.removeDisjunctiveFacetRefinement(attr, v); } catch (e2) { /* ok */ }
        }
        helper.search();
      }
    }

    function syncQuickFilterChips() {
      const helper = typeof instant !== 'undefined' && instant.search && instant.search.helper;
      const state = helper && helper.state;
      const defaultIndex = (instant && instant.sortOrders && instant.sortOrders[0] && instant.sortOrders[0].value)
        || (activeSortOrders && activeSortOrders[0] && activeSortOrders[0].value)
        || '';

      const active = {
        sort: !!(state && defaultIndex && state.index && state.index !== defaultIndex),
        price: hasActivePriceFilter(state),
        product_type: !!(state && (
          (state.facetsRefinements && state.facetsRefinements.product_type && state.facetsRefinements.product_type.length) ||
          (state.disjunctiveFacetsRefinements && state.disjunctiveFacetsRefinements.product_type && state.disjunctiveFacetsRefinements.product_type.length)
        )),
        creation: !!(window.__oblistItemTypeExclusive && (
          window.__oblistItemTypeExclusive.isMto() ||
          (helper && (helper.getRefinements('meta.custom.badges') || []).some((r) => /vintage/i.test(String(r.value))))
        )),
      };

      const count = countActiveFilters();
      forEachQuickFiltersRoot((root) => {
        root.querySelectorAll('.ais-quick-filters__btn[data-oblist-quick]').forEach((btn) => {
          const key = btn.getAttribute('data-oblist-quick');
          if (key === 'all') return;
          btn.classList.toggle('is-active', !!active[key]);
        });
        const countEl = root.querySelector('[data-oblist-quick-all-count]');
        if (countEl) {
          if (count > 0) {
            countEl.hidden = false;
            countEl.textContent = `(${count})`;
          } else {
            countEl.hidden = true;
            countEl.textContent = '';
          }
        }
      });

      syncActiveFilterTags();
    }

    function onQuickFiltersClick(event) {
      const root = event.currentTarget;
      const removeBtn = event.target.closest('[data-oblist-remove-filter]');
      if (removeBtn && root.contains(removeBtn)) {
        event.preventDefault();
        removeActiveFilter(
          removeBtn.getAttribute('data-oblist-remove-filter'),
          removeBtn.getAttribute('data-oblist-remove-value'),
          removeBtn.getAttribute('data-oblist-remove-attr'),
          removeBtn.getAttribute('data-oblist-remove-facet-value')
        );
        return;
      }

      const btn = event.target.closest('[data-oblist-quick]');
      if (!btn || !root.contains(btn)) return;
      const key = btn.getAttribute('data-oblist-quick');
      if (key === 'all') {
        closeQuickFacet();
        setFacetsOpen(true);
        return;
      }
      openQuickFacet(key);
    }

    bar.addEventListener('click', onQuickFiltersClick);
    if (miniBar) miniBar.addEventListener('click', onQuickFiltersClick);
    // Desktop chips are portaled into the hits column — listen there too
    document.querySelector('[data-oblist-desktop-active-host]')
      ?.addEventListener('click', onQuickFiltersClick);

    sheet.querySelector('.ais-quick-facet-sheet__close')?.addEventListener('click', closeQuickFacet);
    applyBtn?.addEventListener('click', () => {
      if (applyBtn.disabled || applyBtn.classList.contains('is-disabled')) return;
      const nb = instant.search?.helper?.lastResults?.nbHits;
      if (nb === 0) return;
      closeQuickFacet();
    });
    overlay.addEventListener('click', closeQuickFacet);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!document.body.classList.contains('oblist-quick-facet-open')) return;
      closeQuickFacet();
    });

    if (typeof instant !== 'undefined' && instant.search) {
      instant.search.on('render', () => {
        syncActiveFiltersPlacement();
        syncQuickFilterChips();
        if (!sheet.hidden) {
          const nbHits = instant.search.helper?.lastResults?.nbHits;
          if (nbHits != null) updateMobileFiltersResultsCount(nbHits);
        }
      });
    }
    syncQuickFilterChips();
  }

  function bindFacetPanelTogglesOnce() {
    const container = document.querySelector('.ais-facets-container');
    if (!container || container.dataset.oblistPanelDelegated === '1') return;
    container.dataset.oblistPanelDelegated = '1';
    container.addEventListener('click', (e) => {
      const header = e.target.closest('.ais-Panel-header');
      if (!header || !container.contains(header)) return;
      const panelBody = header.nextElementSibling;
      if (!panelBody?.classList.contains('ais-Panel-body')) return;
      const willExpand = !panelBody.classList.contains('ais-Panel-body--expanded');
      panelBody.classList.toggle('ais-Panel-body--expanded');
      header.classList.toggle('is-expanded');
      if (willExpand) scrollFacetPanelIntoView(header);
    });
    // In stock ON → drop Made to order (mutually exclusive for shoppers)
    container.addEventListener('change', (e) => {
      const input = e.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.classList.contains('ais-ToggleRefinement-checkbox') && !input.classList.contains('switch')) return;
      const toggleRoot = input.closest('.ais-ToggleRefinement');
      if (!toggleRoot || !container.contains(toggleRoot)) return;
      if (!input.checked) return;
      const exclusive = window.__oblistItemTypeExclusive;
      if (!exclusive || typeof exclusive.resetMtoMode !== 'function' || !exclusive.isMto()) return;
      const liveHelper = exclusive.helper;
      if (exclusive.resetMtoMode(liveHelper) && liveHelper && typeof liveHelper.search === 'function') {
        liveHelper.search();
      }
    });
    syncFacetPanelChevrons(container);
    bindFacetScrollChainOnce(container);
  }

  /**
   * UX: wheel over filters scrolls the filter panel when possible;
   * at boundaries (or if no overflow), scroll the page instead.
   */
  function bindFacetScrollChainOnce(facetsContainer) {
    const scroller =
      facetsContainer.querySelector('#ais-facets') ||
      facetsContainer.querySelector('.ais-facets') ||
      facetsContainer;
    if (!scroller || scroller.dataset.oblistScrollChain === '1') return;
    scroller.dataset.oblistScrollChain = '1';

    scroller.addEventListener(
      'wheel',
      (event) => {
        // Touchpads / mice: only vertical intent
        if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;

        const maxScroll = scroller.scrollHeight - scroller.clientHeight;
        const canScroll = maxScroll > 1;
        const atTop = scroller.scrollTop <= 0;
        const atBottom = scroller.scrollTop >= maxScroll - 1;
        const goingUp = event.deltaY < 0;
        const goingDown = event.deltaY > 0;

        const shouldChainToPage =
          !canScroll || (goingUp && atTop) || (goingDown && atBottom);

        if (!shouldChainToPage) return; // let the panel scroll normally

        // Panel can't absorb this wheel → scroll the page
        event.preventDefault();
        window.scrollBy({ top: event.deltaY, left: 0, behavior: 'auto' });
      },
      { passive: false }
    );
  }

  function getPriceCurrencySymbol() {
    const code = String(currency || 'eur').toLowerCase();
    if (code === 'usd') return '$';
    if (code === 'gbp') return '£';
    if (code === 'ils') return '₪';
    return '€';
  }

  // Attribut RÉELLEMENT filtré = celui de la devise affichée.
  // `price` est en devise du store (EUR) ; sur un marché USD/GBP l'utilisateur voit
  // market_pricing_<cur>.price → on filtre sur ce champ pour que "< 500$" = < 500 $.
  function getOblistPriceAttribute() {
    try {
      const helpers = algolia?.helpers;
      const storeCur = String(algoliaShopify?.config?.store_currency || 'eur').toLowerCase();
      const activeCur = helpers?.activeCurrencyCode?.();
      if (helpers?.marketsEnabled?.() && activeCur && activeCur !== storeCur) {
        return `market_pricing_${activeCur}.price`;
      }
    } catch (e) {
      /* fallback below */
    }
    return 'price';
  }

  function getOblistPricePresets() {
    const sym = getPriceCurrencySymbol();
    return [
      { id: 'lt500', label: `< 500${sym}`, min: null, max: 500 },
      { id: '500-2000', label: `500 - 2000${sym}`, min: 500, max: 2000 },
      { id: '2000-5000', label: `2000 - 5000${sym}`, min: 2000, max: 5000 },
      { id: 'gt5000', label: `> 5000${sym}`, min: 5000, max: null },
    ];
  }

  // Filtre prix mobile via connectRange — attribute = devise AFFICHÉE
  // (price en EUR store, sinon market_pricing_<cur>.price). Native refine only,
  // so uiState.range / URL routing stay in sync in the quick sheet AND full panel.
  function createOblistMobilePriceFilter() {
    if (!connectRange) {
      console.warn('[Algolia] connectRange indisponible, fallback rangeSlider');
      return rangeSlider;
    }

    const PRICE_RANGE_MIN = 0;
    const PRICE_RANGE_MAX = 100000;

    const rangesMatch = (a, b) => {
      const n = (v) => (v == null || v === '' ? null : Math.round(Number(v)));
      return n(a.min) === n(b.min) && n(a.max) === n(b.max);
    };

    const renderMobilePrice = (renderOptions, isFirstRender) => {
      const { refine, start, widgetParams } = renderOptions;
      const container = widgetParams?.container;
      if (!container) return;

      const lo = Number.isFinite(start?.[0]) ? start[0] : PRICE_RANGE_MIN;
      const hi = Number.isFinite(start?.[1]) ? start[1] : PRICE_RANGE_MAX;
      const current = {
        min: lo <= PRICE_RANGE_MIN ? null : lo,
        max: hi >= PRICE_RANGE_MAX ? null : hi,
      };
      container._oblistActive = current;
      container._oblistRefine = refine;

      const apply = (min, max) => {
        (container._oblistRefine || refine)([
          min == null || min === '' ? undefined : Number(min),
          max == null || max === '' ? undefined : Number(max),
        ]);
      };

      // Rebuild UI if the panel body was recreated / emptied (e.g. after portal)
      const needsMount = isFirstRender || !container.querySelector('.oblist-price-filter');
      if (needsMount) {
        const sym = getPriceCurrencySymbol();
        const presets = getOblistPricePresets();
        container.innerHTML =
          '<div class="oblist-price-filter">' +
            '<div class="oblist-price-filter__presets">' +
              presets.map((p) => `<button type="button" class="oblist-price-filter__preset" data-preset-id="${p.id}">${p.label}</button>`).join('') +
            '</div>' +
            '<div class="oblist-price-filter__inputs">' +
              '<label class="oblist-price-filter__field">' +
                '<span class="oblist-price-filter__field-label">MIN</span>' +
                '<span class="oblist-price-filter__input-wrap">' +
                  '<input type="number" class="oblist-price-filter__input oblist-price-filter__input--min" inputmode="numeric" min="0" autocomplete="off" />' +
                  `<span class="oblist-price-filter__suffix">${sym}</span>` +
                '</span>' +
              '</label>' +
              '<span class="oblist-price-filter__sep" aria-hidden="true">—</span>' +
              '<label class="oblist-price-filter__field">' +
                '<span class="oblist-price-filter__field-label">MAX</span>' +
                '<span class="oblist-price-filter__input-wrap">' +
                  '<input type="number" class="oblist-price-filter__input oblist-price-filter__input--max" inputmode="numeric" min="0" autocomplete="off" />' +
                  `<span class="oblist-price-filter__suffix">${sym}</span>` +
                '</span>' +
              '</label>' +
            '</div>' +
          '</div>';

        container.querySelectorAll('.oblist-price-filter__preset').forEach((btn) => {
          btn.addEventListener('click', () => {
            const preset = getOblistPricePresets().find((p) => p.id === btn.dataset.presetId);
            if (!preset) return;
            const active = container._oblistActive || { min: null, max: null };
            if (rangesMatch(active, preset)) {
              apply(null, null);
              return;
            }
            apply(preset.min, preset.max);
          });
        });

        const minInput = container.querySelector('.oblist-price-filter__input--min');
        const maxInput = container.querySelector('.oblist-price-filter__input--max');
        const applyInputs = () => {
          const minVal = minInput.value === '' ? null : Number(minInput.value);
          const maxVal = maxInput.value === '' ? null : Number(maxInput.value);
          if (minVal != null && Number.isNaN(minVal)) return;
          if (maxVal != null && Number.isNaN(maxVal)) return;
          if (minVal != null && maxVal != null && minVal > maxVal) return;
          if (rangesMatch({ min: minVal, max: maxVal }, container._oblistActive || {})) return;
          apply(minVal, maxVal);
        };
        [minInput, maxInput].forEach((input) => {
          input.addEventListener('change', applyInputs);
          input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              applyInputs();
              input.blur();
            }
          });
        });
      }

      const minInput = container.querySelector('.oblist-price-filter__input--min');
      const maxInput = container.querySelector('.oblist-price-filter__input--max');
      if (minInput && document.activeElement !== minInput) {
        minInput.value = current.min != null ? String(Math.round(current.min)) : '';
      }
      if (maxInput && document.activeElement !== maxInput) {
        maxInput.value = current.max != null ? String(Math.round(current.max)) : '';
      }
      container.querySelectorAll('.oblist-price-filter__preset').forEach((btn) => {
        const preset = getOblistPricePresets().find((p) => p.id === btn.dataset.presetId);
        btn.classList.toggle('is-active', Boolean(preset && rangesMatch(current, preset)));
      });
    };

    return connectRange(renderMobilePrice);
  }

  // Shared helper for hierarchical facets (color/material/style)
  window.hierarchicalFacetHelper = {
    getCategoryState: function(facetType, categoryId) {
      if (facetType === 'color') {
        return window.colorCategoryStates[categoryId] || 'collapsed';
      } else if (facetType === 'material') {
        return window.materialCategoryStates[categoryId] || 'collapsed';
      } else if (facetType === 'style') {
        return window.styleCategoryStates[categoryId] || 'collapsed';
      }
      return 'collapsed';
    },
    setCategoryState: function(facetType, categoryId, state) {
      if (facetType === 'color') {
        window.colorCategoryStates[categoryId] = state;
      } else if (facetType === 'material') {
        window.materialCategoryStates[categoryId] = state;
      } else if (facetType === 'style') {
        window.styleCategoryStates[categoryId] = state;
      }
    },
    cleanupDuplicateCategories: function(facetType) {
      // Remove duplicate category headers for the given facet type
      const selector = `.ais-${facetType}-category-header`;
      const categoryGroups = {};
      const allCategoryHeaders = document.querySelectorAll(selector);
      allCategoryHeaders.forEach(header => {
        const categoryId = header.getAttribute('data-category');
        if (categoryId) {
          if (!categoryGroups[categoryId]) {
            categoryGroups[categoryId] = [];
          }
          categoryGroups[categoryId].push(header);
        }
      });
      Object.keys(categoryGroups).forEach(categoryId => {
        const headers = categoryGroups[categoryId];
        if (headers.length > 1) {
          for (let i = 1; i < headers.length; i++) {
            headers[i].remove();
          }
        }
      });
    },
    setupCategoryHandlers: function(facetType) {
      // Attach click handlers for category headers for the given facet type
      const selector = `.ais-${facetType}-category-header`;
      const categoryHeaders = document.querySelectorAll(selector);
      categoryHeaders.forEach(header => {
        if (!header.hasAttribute('data-click-handler')) {
          header.setAttribute('data-click-handler', 'true');
          header.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const categoryId = this.getAttribute('data-category');
            if (categoryId) {
              window.hierarchicalFacetHelper.toggleCategory(facetType, categoryId);
            }
          });
        }
      });
    },
    toggleCategory: function(facetType, categoryId) {
      const selector = `.ais-${facetType}-category-header[data-category="${categoryId}"]`;
      const itemSelector = `.ais-${facetType}-subitem[data-category-item="${categoryId}"]`;
      const categoryHeader = document.querySelector(selector);
      const categoryItems = document.querySelectorAll(itemSelector);
      if (categoryHeader && categoryItems.length > 0) {
        const isCollapsed = categoryHeader.classList.contains('collapsed');
        if (isCollapsed) {
          categoryHeader.classList.remove('collapsed');
          this.setCategoryState(facetType, categoryId, 'expanded');
          categoryItems.forEach(item => {
            item.classList.remove('hidden');
          });
          if (typeof window.__oblistScrollFacetIntoView === 'function') {
            window.__oblistScrollFacetIntoView(categoryHeader);
          }
        } else {
          categoryHeader.classList.add('collapsed');
          this.setCategoryState(facetType, categoryId, 'collapsed');
          categoryItems.forEach(item => {
            const checkbox = item.querySelector('.ais-RefinementList-checkbox');
            const isSelected = checkbox && checkbox.checked;
            if (isSelected) {
              checkbox.setAttribute('checked', 'checked');
            } else {
              checkbox.removeAttribute('checked');
            }
            if (!isSelected) {
              item.classList.add('hidden');
            }
          });
        }
      }
    }
  };
  
  if(collectionPageEnabled) {
      collection_name = window.location.pathname.match(
      /(^\/\w{2}\/|^\/|^\/\w{2}-\w{2}\/)collections\/(?!all$)([^/]+)[/]*$/
    )[2];

      collection_handle = document.querySelector(".collection_handle")?.innerHTML;
      const collection_vendor = document.querySelector(".collection_vendor")?.innerHTML;
      const price_ranking_vendors = ['mokko', 'astrid-houssin', 'coseincorso', 'coseencours', 'photography-wall-art', 'photographie-art-contemporain', 'fry-powers'];
      if(collection_vendor == 'true' || collection_vendor == 'True') {
        if(price_ranking_vendors.includes(collection_handle.toLowerCase()))
          algoliaIndexName = `${algoliaIndexName}_price_asc`;
      }
      console.log("collection_handle", collection_handle);
      console.log("algoliaIndexName", algoliaIndexName);
    
    if (collection_handle == "Mobiliers") {
        collection_handle = "furniture";
      } else if (collection_handle == "Couverts") {
        collection_handle = "cutlery";
      } else if (collection_handle == "Bols") {
        collection_handle = "bowls";
      } else if (collection_handle == "Photographie") {
        // broken
        collection_handle = "photography";
      } else if (collection_handle == "Dessins") {
        collection_handle = "drawings";
      } else if (collection_handle == "Art") {
        // broken
        collection_handle = "collectibles";  
      } else if (collection_handle == "Miroirs") {
        collection_handle = "mirrors";
      } else if (collection_handle == "Plaid de lit") {
        // broken
        collection_handle = "plaids";
      } else if (collection_handle == "Luminaires") {
        collection_handle = "lighting";
      } else if (collection_handle == "Tapis") {
        collection_handle = "rugs";
      } else if (collection_handle == "Literie") {
        collection_handle = "bedding";
      } else if (collection_handle == "Coussins") {
        collection_handle = "pillows";
      } else if (collection_handle == "Des boites") {
        collection_handle = "boxes";
      } else if (collection_handle == "Paniers") {
        collection_handle = "baskets";
      } else if (collection_handle == "Service de Table") {
        collection_handle = "serveware";
        } else if (collection_handle == "lampe-a-poser-salon") {
        collection_handle = "table-lamps-for-living-rooms";
      } else if (collection_handle == "cendrier-en-verre") {
        collection_handle = "glass-ashtray";
         } else if (collection_handle == "applique-murale-design") {
        collection_handle = "wall-lights";
      } else if (collection_handle == "Jeux") {
        collection_handle = "games";
      }
    
  }

var results_selector = collectionPageEnabled
    ? algoliaShopify.config.collection_css_selector
    : algoliaShopify.config.results_selector;

var activeSortOrders =
    collectionPageEnabled && algolia.collectionSortOrders
      ? algolia.collectionSortOrders
      : algolia.sortOrders;

// Traductions FR pour les options de tri
const sortOrderTranslations = {
  'Relevance': 'Pertinence',
  'Most popular': 'Plus populaire',
  'Newest first': 'Plus récent',
  'Cheapest first': 'Prix croissant',
  'Most expensive first': 'Prix décroissant',
  'Price (low to high)': 'Prix croissant',
  'Price (high to low)': 'Prix décroissant'
};

const productsIndexBase = algoliaShopify.config.index_prefix + 'products';

// Relevant sorts (virtual replicas) : remplacent les standard replicas là où elles existent.
// Elles trient par l'attribut MAIS conservent un seuil de pertinence (relevancyStrictness),
// ce qui évite que "Cheapest first" remonte des items hors-sujet (ex: bougeoirs pour "chair").
// Clé = nom d'index standard résolu pour le marché ; valeur = virtual replica équivalente.
const OBLIST_RELEVANT_SORTS = (function () {
  var rel = 'shopify_theoblistproducts';
  var marketBases = [
    rel,
    rel + '_australia_en', rel + '_australia_fr',
    rel + '_canada_en', rel + '_canada_fr',
    rel + '_eu_zone_en', rel + '_eu_zone_fr',
    rel + '_eu_zone_duties_not_collected_en', rel + '_eu_zone_duties_not_collected_fr',
    rel + '_france_en', rel + '_france_fr',
    rel + '_singapore_en', rel + '_singapore_fr',
    rel + '_south_korea_en', rel + '_south_korea_fr',
    rel + '_suisse_en', rel + '_suisse_fr',
    rel + '_uk_en', rel + '_uk_fr',
    rel + '_united_arab_emirates_en', rel + '_united_arab_emirates_fr',
    rel + '_united_states_en', rel + '_united_states_fr',
  ];
  // "Newest first" : relevant replicas créées sur tous les marchés (mêmes index que price).
  var newestBases = marketBases;
  // "Most popular" : relevant replicas créées sur tous les marchés.
  var popularBases = marketBases;
  var map = {};
  marketBases.forEach(function (base) {
    map[base + '_price_asc'] = base + '_price_asc_relevant';
  });
  newestBases.forEach(function (base) {
    map[base + '_published_at_desc'] = base + '_published_at_desc_relevant';
  });
  popularBases.forEach(function (base) {
    map[base + '_recently_ordered_count_desc'] = base + '_recently_ordered_count_desc_relevant';
  });
  return map;
})();

activeSortOrders = activeSortOrders.map(order => {
  let value = order.value;
  if (value.startsWith(productsIndexBase)) {
    value = value.replace(productsIndexBase, algoliaIndexName);
  }

  // Rediriger vers la relevant sort (virtual replica) si disponible pour ce marché.
  if (OBLIST_RELEVANT_SORTS[value]) {
    value = OBLIST_RELEVANT_SORTS[value];
  }
  
  // Traduire le label si en français
  let label = order.label;
  if (current_locale === 'fr' && sortOrderTranslations[label]) {
    label = sortOrderTranslations[label];
  }
  
  return {...order, value: value, label: label};
})

  
var aisInstantRouting = false;

// is this needed?
// if (window.location.pathname.includes("/fr/collections/")) {
//   algoliaIndexName = algoliaShopify.config.index_prefix + 'products' + hypen + market_suffix;
// }

  if(collectionPageEnabled) {
         aisInstantRouting = {    
          router: instantsearch.routers.history({
            windowTitle({ category, query }) {
              if(!collectionPageEnabled) {
                const queryTitle = query ? `Results for "${query}"` : 'Search';  
                if (category) {
                  return `${category} – ${queryTitle}`;
                }
                return queryTitle;
              }            
            },
            createURL({ qsModule, routeState, location }) {
              const urlParts = location.href.match(/^(.*?)\/search/);
              const { origin, pathname, hash, search } = location;
              const indexState = routeState[algoliaIndexName] || {};
              if (!indexState.query) {
                return `${origin}${pathname}${hash}`;
              }
              
              let baseUrl = `${urlParts ? urlParts[1] : ""}/`;               
              if (window.location.pathname.includes("/fr/collections/")) {
                baseUrl = baseUrl + "fr/";
              }
     
              const queryParameters = {};
              if (routeState.query) {
                queryParameters.query = encodeURIComponent(routeState.query) || customQuery;
              } else {
                queryParameters.query = customQuery;
              }
              if (routeState.page !== 1) {
                queryParameters.page = routeState.page;
              }
              if (routeState.product_type) {
                queryParameters.product_type =
                  routeState.product_type.map(encodeURIComponent);
              }
  
              const queryString = qsModule.stringify(queryParameters, {
                addQueryPrefix: true,
                arrayFormat: "repeat",
              });
              let middle_path= 'search/';
              if(is_collection_results_page) {
                middle_path = 'collections/'+collection_name;
              }
              return `${baseUrl}${middle_path}${queryString}`;
            },
  
            parseURL({ qsModule, location }) {
              const {
                query = "",
                page,
                product_type = [],
              } = qsModule.parse(location.search.slice(1));
              // `qs` does not return an array when there's a single value.
              const allProductTypes = Array.isArray(product_type)
                ? product_type
                : [product_type].filter(Boolean);
  
              return {
                query: decodeURIComponent(query),
                page,
                product_type: allProductTypes.map(decodeURIComponent),
              };
            },
          }),
          stateMapping: {
            stateToRoute(uiState) {
              const indexUiState = uiState[algoliaIndexName];
              return {
                query: indexUiState.query,
                q: indexUiState.query,
                product_type:
                  indexUiState.refinementList &&
                  indexUiState.refinementList.product_type,
                page: indexUiState.page,
              };
            },
            routeToState(routeState) {
              return {
                [algoliaIndexName]: {
                  ...initialUiState.algoliaIndexName,
                  query: routeState.query
                      ? routeState.query
                      : initialUiState[algoliaIndexName].query,
                  refinementList: {
                    product_type: routeState.product_type,
                  },
                  page: routeState.page,
                },
              };
            },
          },
    };  
  } 
  

  
  let chevronHTML = `
            <span class="circle-chevron group-hover:colors group-expanded:colors group-expanded:rotate">
              <svg
                role="presentation"
                focusable="false"
                width="20"
                height="18"
                class="icon icon-chevron-bottom-small"
                viewBox="0 0 8 6"
              >
                <path
                  d="m1 1.5 3 3 3-3"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="0.5"
                ></path>
              </svg>
            </span>`;
      
if(algoliaShopify.config.index_prefix === algoliaIndexName) {
    algoliaIndexName += 'products'; 
}

  
   var url_string = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname + window.location.search; //window.location.href
   var url = new URL(url_string);
   var collection_meta_enabled = false;
   var collection_meta_keyword = '';
   var collection_product_types = []; // collections "type" filtrées par product_type (au lieu du mot-clé neural)
   var customQuery = url.searchParams.get("q") || '';
   const frSearchResolved = algolia.helpers?.resolveFrSearchParams
     ? algolia.helpers.resolveFrSearchParams(customQuery, current_locale)
     : { query: customQuery, extraFilters: '', analyticsQuery: customQuery };
   let statedPage = url.searchParams.get("page");
   statedPage = statedPage ? statedPage - 1: 0;
   var oblistListingRouterReady = false;


  // index.setSettings({
  //   distinct: true,
  //   attributeForDistinct: 'id' // Replace 'productID' with your attribute
  // }).then(() => {
  //   console.log('Index settings updated');
  // });

  
  if(customQuery) {
    const price_ranking_queries = ['mokko', 'fry powers']
    if(price_ranking_queries.includes(customQuery.toLowerCase()))
        algoliaIndexName = `${algoliaIndexName}_price_asc`;
  }

  var instant = {
    distinct: true,
    facets: {
      hidden:
        collectionPageEnabled && algolia.collectionHiddenFacets
          ? algolia.collectionHiddenFacets
          : algolia.hiddenFacets,
      shown:
        collectionPageEnabled && algolia.collectionShownFacets
          ? algolia.collectionShownFacets
          : algolia.shownFacets,
      list:
        collectionPageEnabled && algolia.collectionFacets
          ? algolia.collectionFacets
          : algolia.facets,
      widgets:
        collectionPageEnabled && algolia.collectionFacetsWidgets
          ? algolia.collectionFacetsWidgets
          : algolia.facetsWidgets,
    },
    // IMPORTANT: Synchroniser le userToken AVANT la création d'InstantSearch
    // Prioriser le token déjà stocké, sinon cookie GA, sinon cookie 1st party, sinon générer un fallback
    _syncedUserToken: (function() {
      const storedToken = localStorage.getItem('ais_user_id');
      const gaToken = getGoogleAnalyticsUserIdFromBrowserCookie("_ga");
      
      // Lire le cookie 1st party comme fallback supplémentaire
      const getCookieToken = () => {
        const match = document.cookie.match(/algolia_user_token=([^;]+)/);
        return match ? match[1] : null;
      };
      const cookieToken = getCookieToken();

      // Générer un token de fallback si aucun n'est disponible
      // Format: timestamp_random pour être unique et persistant
      const generateFallbackToken = () => {
        const timestamp = Date.now();
        const random = Math.floor(Math.random() * 1000000000);
        return `${timestamp}_${random}`;
      };

      // Priorité: localStorage > GA > cookie 1st party
      let token = storedToken || gaToken || cookieToken;

      // Si pas de token, en générer un et le stocker
      if (!token) {
        token = generateFallbackToken();
        console.log('[Algolia InstantSearch] No token found, generating fallback:', token);
      }

      // Stocker le token dans localStorage si pas déjà présent
      if (!storedToken && token) {
        localStorage.setItem('ais_user_id', token);
      }
      
      // Stocker dans cookie 1st party (backup persistant)
      if (!cookieToken || cookieToken !== token) {
        document.cookie = 'algolia_user_token=' + token + ';path=/;max-age=31536000;SameSite=Lax';
      }

      // Synchroniser avec le client Insights
      if (token && window.aa) {
        window.aa("setUserToken", token);
        console.log('[Algolia InstantSearch] UserToken synchronized:', token);
      }

      return token;
    })(),
    search: instantsearch({
      indexName: algoliaIndexName,
      numberLocale: current_locale,
      // initialUiState retiré - le routing (routeToState) gère la query depuis l'URL
      insights: true,
      searchClient: AlgoliaProxy.searchClient(),
      routing: {
        // Initial URL normalization and live search typing replace the current entry.
        // User-driven pagination, filters and sorting push one entry so Back restores
        // the previous listing state. writeDelay 0 avoids a late write on product click.
        router: instantsearch.routers.history({
          writeDelay: 0,
          cleanUrlOnDispose: false,
          push: function (url) {
            try {
              var next = new URL(url, window.location.origin);
              var path = next.pathname || '';
              var herePath = window.location.pathname || '';
              var isListing = path.indexOf('/collections/') !== -1 || path.indexOf('/search') !== -1;
              var onListing = herePath.indexOf('/collections/') !== -1 || herePath.indexOf('/search') !== -1;
              if (!isListing || !onListing) return;
              if (window.OblistCfHistory && typeof window.OblistCfHistory.stripSearch === 'function') {
                next.search = window.OblistCfHistory.stripSearch(next.search) || '';
              }
              var dest = next.pathname + next.search + next.hash;
              var curr = herePath + window.location.search + window.location.hash;
              if (dest !== curr) {
                var current = new URL(window.location.href);
                var queryChanged = next.searchParams.get('q') !== current.searchParams.get('q');
                if (!oblistListingRouterReady || queryChanged) {
                  history.replaceState(history.state, '', dest);
                } else {
                  history.pushState(history.state, '', dest);
                }
              }
            } catch (e) { /* ignore */ }
          },
        }),
        stateMapping: {
          // Persist query + page + ALL InstantSearch refinements in the URL.
          // hitsPerPage stays on the configure widget (avoids double searches).
          // Custom Oblist widgets expose oblistInStock / oblistCreation via getWidgetUiState.
          stateToRoute(uiState) {
            const indexUiState = (uiState && uiState[algoliaIndexName]) || {};
            const route = {
              q: customQuery || indexUiState.query || undefined,
            };

            const page = parseInt(indexUiState.page, 10);
            if (Number.isFinite(page) && page > 1) route.page = page;

            if (indexUiState.refinementList && Object.keys(indexUiState.refinementList).length) {
              route.refinementList = indexUiState.refinementList;
            }
            if (indexUiState.menu && Object.keys(indexUiState.menu).length) {
              route.menu = indexUiState.menu;
            }
            if (indexUiState.hierarchicalMenu && Object.keys(indexUiState.hierarchicalMenu).length) {
              route.hierarchicalMenu = indexUiState.hierarchicalMenu;
            }
            if (indexUiState.numericMenu && Object.keys(indexUiState.numericMenu).length) {
              route.numericMenu = indexUiState.numericMenu;
            }
            if (indexUiState.ratingMenu && Object.keys(indexUiState.ratingMenu).length) {
              route.ratingMenu = indexUiState.ratingMenu;
            }
            if (indexUiState.toggle && Object.keys(indexUiState.toggle).length) {
              route.toggle = indexUiState.toggle;
            }
            if (indexUiState.sortBy) route.sortBy = indexUiState.sortBy;

            // Drop default connectRange noise [0, 100000]
            if (indexUiState.range && typeof indexUiState.range === 'object') {
              const cleaned = {};
              Object.keys(indexUiState.range).forEach((attr) => {
                const raw = String(indexUiState.range[attr] || '');
                const parts = raw.split(':');
                const min = parts[0] === '' || parts[0] == null ? null : Number(parts[0]);
                const max = parts[1] === '' || parts[1] == null ? null : Number(parts[1]);
                const meaningfulMin = Number.isFinite(min) && min > 0;
                const meaningfulMax = Number.isFinite(max) && max < 100000;
                if (meaningfulMin || meaningfulMax) cleaned[attr] = raw;
              });
              if (Object.keys(cleaned).length) route.range = cleaned;
            }

            if (indexUiState.oblistInStock) route.inStock = 1;
            if (indexUiState.oblistCreation && indexUiState.oblistCreation.mode
              && indexUiState.oblistCreation.mode !== 'any') {
              route.creation = indexUiState.oblistCreation;
            }

            return route;
          },
          routeToState(routeState) {
            // Keep statedPage in sync for configure / analytics — never full-reload
            // (reload wiped in-memory refinements and fought InstantSearch history).
            const pageNum = routeState.page ? parseInt(routeState.page, 10) : 1;
            statedPage = Number.isFinite(pageNum) && pageNum > 0 ? pageNum - 1 : 0;

            const indexState = {
              query: customQuery || routeState.q || '',
              page: Number.isFinite(pageNum) && pageNum > 0 ? pageNum : 1,
              refinementList: routeState.refinementList || {},
              menu: routeState.menu || {},
              hierarchicalMenu: routeState.hierarchicalMenu || {},
              numericMenu: routeState.numericMenu || {},
              ratingMenu: routeState.ratingMenu || {},
              range: routeState.range || {},
              toggle: routeState.toggle || {},
            };
            if (routeState.sortBy) indexState.sortBy = routeState.sortBy;
            if (routeState.inStock === 1 || routeState.inStock === '1' || routeState.inStock === true) {
              indexState.oblistInStock = true;
            }
            if (routeState.creation && typeof routeState.creation === 'object') {
              indexState.oblistCreation = routeState.creation;
            }
            return { [algoliaIndexName]: indexState };
          },
        },
      },
    }),
    stalledSearchDelay: 500,
    selector: results_selector + ", .algolia-shopify-instantsearch , #ais-page", //+ ", .algolia-shopify-instantsearch",
    sortOrders: activeSortOrders,
  };

  instant.search.client.addAlgoliaAgent("Custom Algolia Integration");

  // NOTE: userToken déjà synchronisé AVANT la création d'InstantSearch (voir instant._syncedUserToken)

  //Link CSS and set up CSS variables
  const cssFile = document.getElementById(
    "template_algolia_instant_search.css"
  );

  window.algoliasearch.appendStyle(cssFile.text);

  // Instantiating the main page
  instant.$results = document.querySelector(".shopify-section--main-collection").querySelector(".container");
  // instant.$results.innerHTML = "";
  
  // Wait for categorizers to be available
  async function waitForCategorizers() {
    let attempts = 0;
    const maxAttempts = 20; // 2 seconds max
    
    while (attempts < maxAttempts) {
      if (window.colorCategorizer && window.materialCategorizer && window.styleCategorizer) {
        return true;
      }
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }
    
    console.warn('Some categorizers not loaded within timeout, proceeding without them');
    return false;
  }

  document.addEventListener("DOMContentLoaded", async function () {
    // Ne pas bloquer le démarrage InstantSearch (categorizers chargent en parallèle)
    waitForCategorizers();
    const sidebarMenu = document.querySelector(".sidebar-menu-container");
    let check = false;
    // (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    // const isMobile = check; // navigator.userAgentData.mobile;
    
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];
    
    const isMobile = toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
    const isSearchPage = window.location.pathname.includes('/search');
    // Search desktop : filtres ouverts par défaut ; collections et mobile : fermés.
    // Viewport wins over UA — a narrowed desktop window must not boot the mobile sheet open.
    let showFacets = isSearchPage && !isMobile && !isMobileFilterViewport();
    let sortByDiv = document.querySelector('.ais-sort-orders-container');
    if(sortByDiv) {  
      sortByDiv.classList.add('justify-end'); 
      //sortByDiv  : sortByDiv.classList.remove('justify-end'); 
    }
    const filtersSheetTitle = current_locale === 'fr' ? 'Filtres et tri' : 'Filters & sort';
    const filtersClearLabel = current_locale === 'fr' ? 'Tout effacer' : 'Clear all';
    const filtersApplyPrefix = current_locale === 'fr' ? 'Afficher ' : 'Show ';
    const filtersApplySuffix = current_locale === 'fr' ? ' résultats' : ' results';
    instant.$results.insertAdjacentHTML(
      "beforeend",
      `<div class="ais-page">
          <div class="ais-overlay ${showFacets ? 'ais-overlay__shown' : ''}" id="ais-overlay"></div>
          <div class="ais-custom-container ${showFacets ? 'ais-grid-columns' : ''}" id="ais-custom-container">
            <div class="ais-facets-container ${showFacets ? 'ais-facets__shown' : ''}">
              <div class="ais-facets-sheet__header">
                <p class="ais-facets-sheet__title">${filtersSheetTitle}</p>
                <button type="button" class="ais-mobile-close-button" aria-label="Close">
                  <svg role="presentation" stroke-width="1" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
                  <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
                  </svg>
                </button>
              </div>
              <div class="ais-facets" id="ais-facets">
                <div id="ais-mobile-sort-by" class="ais-mobile-sort-by" data-oblist-quick-facet="sort"></div>
                ${sidebarMenu.outerHTML}
              </div>
              <div class="ais-facets-sheet__footer">
                <button type="button" class="ais-facets-sheet__clear" data-oblist-clear-filters>${filtersClearLabel}</button>
                <button type="button" class="ais-facets-sheet__apply" data-oblist-apply-filters aria-label="${filtersApplyPrefix}0${filtersApplySuffix}">
                  <span data-oblist-results-prefix>${filtersApplyPrefix}</span><span data-oblist-results-count>0</span><span data-oblist-results-suffix>${filtersApplySuffix}</span>
                </button>
              </div>
            </div>
            <div class="ais-hits-main">
              <div class="ais-desktop-active-filters" data-oblist-desktop-active-host="1"></div>
              <div class="ais-hits" id="ais-hits"></div>
            </div>
          </div>
        </div>`
    );

    syncFilterButtonLabel(showFacets);
    bindOblistFacetsViewportGuard();

    instant.search.addWidgets([
      {
        init: function () {
           //console.log(
           //  'Algolia init - "init" function - instant.search.addWidgets'
           //);
          // Function to recalculate container height after filter toggle
          function recalculateContainerHeight() {
            const collectionDiv = document.querySelector('.shopify-section--main-collection .container');
            if (collectionDiv) {
              collectionDiv.style.minHeight = 'auto';
            }
          }
          
          // Desktop / mobile facets toggle
          var $filterButton = document.querySelector(
            ".filter_hide_show_container"
          );

          if ($filterButton) {
            $filterButton.addEventListener("click", function () {
              var $facets = document.querySelector(".ais-facets-container");
              setFacetsOpen(!$facets?.classList.contains("ais-facets__shown"));
              setTimeout(recalculateContainerHeight, 50);
            });
          }

          var $mobileFilterButton = document.querySelector(
            ".collectio_filters_jtpl"
          );
          if ($mobileFilterButton) {
            $mobileFilterButton.addEventListener("click", function () {
              var $facets = document.querySelector(".ais-facets-container");
              setFacetsOpen(!$facets?.classList.contains("ais-facets__shown"));
              setTimeout(recalculateContainerHeight, 50);
            });
          }

          var $mobileCloseButton = document.querySelector(
            ".ais-mobile-close-button"
          );
          $mobileCloseButton?.addEventListener("click", function () {
            setFacetsOpen(false);
            setTimeout(recalculateContainerHeight, 50);
          });

          document.querySelector('[data-oblist-apply-filters]')?.addEventListener('click', function (event) {
            const btn = event.currentTarget;
            if (btn && (btn.disabled || btn.classList.contains('is-disabled'))) return;
            const nb = instant.search?.helper?.lastResults?.nbHits;
            if (nb === 0) return;
            setFacetsOpen(false);
            setTimeout(recalculateContainerHeight, 50);
          });

          document.querySelector('#ais-overlay')?.addEventListener('click', function () {
            if (!isMobileFilterViewport()) return;
            setFacetsOpen(false);
            setTimeout(recalculateContainerHeight, 50);
          });

          if (!document.documentElement.dataset.oblistFiltersEscBound) {
            document.documentElement.dataset.oblistFiltersEscBound = '1';
            document.addEventListener('keydown', function (event) {
              if (event.key !== 'Escape') return;
              if (!document.body.classList.contains('oblist-filters-open')) return;
              setFacetsOpen(false);
              setTimeout(recalculateContainerHeight, 50);
            });
          }

          bindFacetPanelTogglesOnce();
        },
      },
    ]);

    const oblistMobilePriceFilter = createOblistMobilePriceFilter();

    const pricePanel = panel({
      templates: {
        header() {
          const priceTitle = translateTerm('Price');
          return `<div class="ais-Panel-header-span">${priceTitle} ${chevronHTML}</div>`;
        },
      },
    })(oblistMobilePriceFilter);

    const inStockOnlyPanel = panel({
      templates: {
        header() {
          const stockTitle = translateTerm('In stock only');
          return `<div class="ais-Panel-header-span">${stockTitle} 
            ${chevronHTML}</div>`;
        },
      },
    })(toggleRefinement);

    // Masquer les panneaux vides (équivalent UX de dynamicWidgets : pas de
    // header "Vintage Condition" sans valeurs). items = valeurs facette courantes.
    const hideEmptyFacetPanel = ({ items }) => !items || items.length === 0;

    const productTypePanel = panel({
      hidden: hideEmptyFacetPanel,
      templates: {
        header() {
          const productTypeTitle = translateTerm('Product Type');
          return `<div class="ais-Panel-header-span">${productTypeTitle} 
            ${chevronHTML}</div>`;
        },
      },
    })(refinementList);

    const vintageConditionPanel = panel({
      hidden: hideEmptyFacetPanel,
      templates: {
        header() {
          const conditionTitle = translateTerm('Vintage Condition');
          return `<div class="ais-Panel-header-span">${conditionTitle} 
            ${chevronHTML}</div>`;
        },
      },
    })(refinementList);

    const colorPanel = panel({
      hidden: hideEmptyFacetPanel,
      templates: {
        header() {
          const title = translateTerm('Colour');
          return `<div class="ais-Panel-header-span">${title} 
            ${chevronHTML}</div>`;
        },
      },
    })(refinementList);

    const shippingLocationPanel = panel({
      hidden: ({ items, canRefine }) =>
        (canRefine === false) || !items || items.length === 0,
      templates: {
        header() {
          const locTitle = translateTerm('Item location');
          const locDesc = translateTerm('See pieces that ship from a chosen area.');
          return `<div class="ais-Panel-header-span">${locTitle} 
            ${chevronHTML}</div><p>${locDesc}</p>`;
        },
      },
    });

    // Hits

    let collection_id = '';
    let collection_title = '';  // Titre lisible pour les analytics

    // Search page : handle = dernier segment d'URL. Collection page : garder le
    // handle déjà résolu plus haut (metafield EN + remap FR), plus fiable que l'URL.
    if (!collectionPageEnabled || !collection_handle) {
      const splitted = location.pathname.split('/');
      collection_handle = splitted[splitted.length - 1] || '';
    }

    // Plus de search Algolia handle→ID : Liquid fournit collection.id (= objectID).
    if (collection_handle !== 'search' && collectionPageEnabled) {
      const fromWindow = window.__OBLIST_COLLECTION__ || null;
      collection_id = String(
        (fromWindow && fromWindow.id) ||
        document.querySelector('.collection_id')?.textContent?.trim() ||
        ''
      );
      collection_title =
        (fromWindow && fromWindow.title) ||
        document.querySelector('.collection_title')?.textContent?.trim() ||
        collection_handle;

      if (!collection_id) {
        console.warn('[Algolia] collection.id manquant dans le DOM — filtre collection_ids vide');
      }

      try {
        // textContent (pas innerHTML) pour récupérer le texte DÉCODÉ.
        // Sinon les caractères spéciaux du metafield (", ', &, …) restent
        // sous forme d'entités HTML (&quot;, &#39;, &amp;) et sont envoyés
        // tels quels à Algolia, ce qui casse complètement la query.
        const collection_keyword = document.querySelector('.collection_keyword')?.textContent?.trim();
        if (collection_keyword) {
          collection_meta_keyword = collection_keyword;
          collection_meta_enabled = true;
        }
        const collection_keyword_fr = document.querySelector('.collection_keyword_fr')?.textContent?.trim();
        if (current_locale == 'fr' && collection_keyword_fr) {
          collection_meta_keyword = collection_keyword_fr;
          collection_meta_enabled = true;
        }
        // Collections "type" : liste de product_type (metafield custom.collection_product_types,
        // ex. "Mirrors" ou "Vases, Vase, Ceramic Vases"). Si présent, on filtre par
        // product_type EXACT (sans recherche neural) -> organique ET featured propres,
        // plus d'intrus sémantiques (ex. bowl dans "mirrors"). Prioritaire sur le mot-clé.
        const collection_ptypes = document.querySelector('.collection_product_types')?.textContent?.trim();
        if (collection_ptypes) {
          collection_product_types = collection_ptypes.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        }
      } catch (e) {
        console.log(`Error: ${e} with getting collection keyword`);
      }
    }

    const COLLECTION_IN_STOCK_FILTER = 'inventory_available:true AND NOT meta.custom.soldout:true';
    const COLLECTION_SOLD_FILTER = 'inventory_available:false OR meta.custom.soldout:true';

    function mergeAlgoliaFilters(base, extra) {
      const trimmed = String(base || '').trim();
      return trimmed ? `(${trimmed}) AND (${extra})` : extra;
    }

    // Sur les pages collection, optionalFilters ne garantit pas "sold en fin" sur
    // toutes les pages (page 2+ peut mélanger). On fusionne 2 requêtes : in-stock
    // puis sold-out, avec offset/length pour garder la pagination InstantSearch.
    function wrapSearchClientStockLast(searchClient, productIndexName) {
      if (searchClient.__oblistStockLastWrapped) return;
      searchClient.__oblistStockLastWrapped = true;
      const originalSearch = searchClient.search.bind(searchClient);

      function shouldMergeStockLast(request) {
        if (request.indexName !== productIndexName) return false;
        if (collection_handle === 'search') return false;
        // Sold-out en fin UNIQUEMENT sur les collections SEO (avec keyword).
        // Les collections Shopify normales sont merchandisées (query rules / pins) :
        // on n'applique pas le filtre stock dur qui masquerait les pins sold-out.
        if (!collection_meta_enabled) return false;
        const params = request.params || {};
        if (params.hitsPerPage === 0) return false;
        return true;
      }

      async function searchMergedStockLast(request) {
        const params = request.params || {};
        const hitsPerPage = params.hitsPerPage || 40;
        const page = params.page || 0;
        const offset = page * hitsPerPage;
        const baseFilters = params.filters || '';

        const countParams = (extraFilter) => ({
          ...params,
          filters: mergeAlgoliaFilters(baseFilters, extraFilter),
          hitsPerPage: 0,
          page: 0,
          offset: undefined,
          length: undefined,
        });

        const countRes = await originalSearch([
          { indexName: request.indexName, params: countParams(COLLECTION_IN_STOCK_FILTER) },
          { indexName: request.indexName, params: countParams(COLLECTION_SOLD_FILTER) },
        ]);
        const inStockNb = countRes.results[0]?.nbHits || 0;
        const soldNb = countRes.results[1]?.nbHits || 0;
        const totalNb = inStockNb + soldNb;
        const hits = [];
        let remaining = hitsPerPage;
        let cursor = offset;

        if (cursor < inStockNb && remaining > 0) {
          const take = Math.min(remaining, inStockNb - cursor);
          const inStockRes = await originalSearch([{
            indexName: request.indexName,
            params: {
              ...params,
              filters: mergeAlgoliaFilters(baseFilters, COLLECTION_IN_STOCK_FILTER),
              offset: cursor,
              length: take,
              page: undefined,
            },
          }]);
          hits.push(...(inStockRes.results[0]?.hits || []));
          remaining -= take;
        }

        if (remaining > 0) {
          const soldOffset = Math.max(0, cursor - inStockNb);
          const soldRes = await originalSearch([{
            indexName: request.indexName,
            params: {
              ...params,
              filters: mergeAlgoliaFilters(baseFilters, COLLECTION_SOLD_FILTER),
              offset: soldOffset,
              length: remaining,
              page: undefined,
            },
          }]);
          hits.push(...(soldRes.results[0]?.hits || []));
        }

        const template = countRes.results[0] || {};
        return {
          ...template,
          hits,
          nbHits: totalNb,
          page,
          hitsPerPage,
          nbPages: Math.max(1, Math.ceil(totalNb / hitsPerPage)),
        };
      }

      searchClient.search = async function (requests) {
        const mergeFlags = requests.map(shouldMergeStockLast);
        if (!mergeFlags.some(Boolean)) {
          return originalSearch(requests);
        }

        const results = new Array(requests.length);
        const passthrough = [];
        mergeFlags.forEach((flag, i) => {
          if (!flag) passthrough.push({ index: i, request: requests[i] });
        });

        if (passthrough.length) {
          const passthroughRes = await originalSearch(passthrough.map((p) => p.request));
          passthrough.forEach((p, j) => {
            results[p.index] = passthroughRes.results[j];
          });
        }

        await Promise.all(mergeFlags.map(async (flag, i) => {
          if (flag) results[i] = await searchMergedStockLast(requests[i]);
        }));

        return { results };
      };
    }

    // ============================================
    // Programme "Featured" (Oblist Ads) — anti-monopolisation
    // ============================================
    // visibility_boost (meta.custom) fait remonter les pièces "Featured" via le
    // customRanking Algolia. Pour éviter qu'un vendeur (ou les featured en général)
    // saturent une page, on RÉ-ORDONNE côté thème, APRÈS la réponse Algolia :
    //   - max OBLIST_FEATURED_PER_PAGE featured visibles par page,
    //   - max OBLIST_FEATURED_PER_VENDOR_PER_PAGE featured du même vendeur par page.
    // Principe : on PRÉSERVE l'ordre source (donc la pertinence texte) et on se
    // contente de DÉMÔTER le surplus vers les pages suivantes (jamais de promotion
    // au-dessus de la position naturelle). Gate par index (scope test = UAE en) :
    // aucun impact (ni requête supplémentaire) sur les marchés sans featured.
    const OBLIST_FEATURED_PER_PAGE = 4;
    const OBLIST_FEATURED_PER_VENDOR_PER_PAGE = 2;
    const OBLIST_FEATURED_WINDOW_EXTRA_PAGES = 2; // marge pour le report des featured démôtés
    // Bande "prime" = top positions de chaque page où les clics sont concentrés
    // (data Algolia : pos 1≈1.6k … pos 10≈400 ; au-delà, clics faibles hors scroll
    // profond). On confine les featured à cette bande au lieu de les disperser en
    // profondeur ; l'exposition longue est assurée par la ROTATION (offset du
    // visibility_boost, géré côté oblist-starter), pas en clouant des items en bas.
    const OBLIST_FEATURED_PRIME_BAND = 16; // featured placés dans le top 16/page (bande haute)
    // Écart min entre 2 featured ≈ 1 par ligne (grille), densité ~20-25% de la bande.
    // 5 (et non un multiple du nb de colonnes) -> colonnes décalées (diagonale).
    const OBLIST_FEATURED_MIN_GAP = 5;
    // Bande "deep" = bas de page. Data : le scroll profond (pos 21+) capte ÉNORMÉMENT
    // de clics (browse) ; on y place quelques featured supplémentaires sans toucher au
    // haut, pour capter ce trafic. Total/page = PER_PAGE (prime) + DEEP_PER_PAGE (deep).
    const OBLIST_FEATURED_DEEP_BAND_START = 28; // la bande deep = positions [28, H)
    const OBLIST_FEATURED_DEEP_PER_PAGE = 2;    // featured supplémentaires en bas de page
    const OBLIST_FEATURED_FETCH = 100;          // nb max de featured récupérés (requête sponsorisée)
    // Tous les index marché primaires (base + 11 marchés × EN/FR). Le programme
    // Featured (badge + injection/placement) s'active sur ces index. Les replicas de
    // tri ne sont volontairement PAS inclus (les tris restent purs).
    const OBLIST_FEATURED_INDICES = (function () {
      var rel = 'shopify_theoblistproducts';
      var markets = ['australia', 'canada', 'eu_zone', 'eu_zone_duties_not_collected',
        'france', 'singapore', 'south_korea', 'suisse', 'uk',
        'united_arab_emirates', 'united_states'];
      var list = [rel];
      markets.forEach(function (m) { list.push(rel + '_' + m + '_en'); list.push(rel + '_' + m + '_fr'); });
      return list;
    })();

    function oblistIndexHasFeaturedProgram(indexName) {
      return OBLIST_FEATURED_INDICES.indexOf(indexName) >= 0;
    }

    function oblistHitIsFeatured(hit) {
      return Number(hit && hit.meta && hit.meta.custom && hit.meta.custom.visibility_boost) > 0;
    }

    const OBLIST_FEATURED_TRUSTED_MATCH_PATHS = [
      'title',
      'product_type',
      'category',
      'meta.custom.materials',
      'meta.custom.style_period',
      'meta.custom.color',
    ];
    const OBLIST_FEATURED_STOP_WORDS = {
      en: new Set(['the', 'a', 'an', 'of', 'in', 'on', 'at', 'for', 'and', 'or', 'with', 'to', 'from', 'by']),
      fr: new Set(['le', 'la', 'les', 'un', 'une', 'des', 'du', 'de', 'd', 'l', 'en', 'a', 'au', 'aux', 'et', 'ou', 'pour', 'par', 'sur', 'sous', 'avec', 'sans', 'dans', 'chez', 'vers']),
    };

    function oblistFeaturedTokens(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .split(/[^a-z0-9]+/)
        .filter(Boolean);
    }

    function oblistFeaturedCanonicalToken(token) {
      if (token.length > 4 && /(ches|shes|sses|xes|zes)$/.test(token)) {
        return token.slice(0, -2);
      }
      if (token.length > 3 && token.endsWith('s') && !token.endsWith('ss')) {
        return token.slice(0, -1);
      }
      return token;
    }

    function oblistFeaturedQueryTokens(query) {
      const locale = current_locale === 'fr' ? 'fr' : 'en';
      const stopWords = OBLIST_FEATURED_STOP_WORDS[locale];
      return Array.from(new Set(
        oblistFeaturedTokens(query)
          .filter(function (token) { return token.length > 1 && !stopWords.has(token); })
          .map(oblistFeaturedCanonicalToken)
      ));
    }

    function oblistFeaturedPathIsTrusted(path) {
      return OBLIST_FEATURED_TRUSTED_MATCH_PATHS.some(function (trustedPath) {
        return path === trustedPath || path.indexOf(trustedPath + '.') === 0;
      });
    }

    function oblistFeaturedMatchedTokens(hit) {
      const matched = new Set();

      function walk(node, path) {
        if (!node || typeof node !== 'object') return;
        if (typeof node.matchLevel === 'string') {
          if (node.matchLevel !== 'none' && oblistFeaturedPathIsTrusted(path)) {
            (node.matchedWords || []).forEach(function (word) {
              oblistFeaturedTokens(word).forEach(function (token) {
                matched.add(oblistFeaturedCanonicalToken(token));
              });
            });
          }
          return;
        }
        if (Array.isArray(node)) {
          node.forEach(function (item) { walk(item, path); });
          return;
        }
        Object.keys(node).forEach(function (key) {
          walk(node[key], path ? path + '.' + key : key);
        });
      }

      walk(hit && hit._highlightResult, '');
      return matched;
    }

    function oblistFeaturedIntentGateEnabled() {
      return collection_meta_enabled || collection_handle === 'search';
    }

    function oblistFeaturedMatchesIntent(hit, query) {
      if (!oblistFeaturedIntentGateEnabled()) return true;
      const queryTokens = oblistFeaturedQueryTokens(query);
      if (!queryTokens.length) return true;
      const nbTypos = Number(hit && hit._rankingInfo && hit._rankingInfo.nbTypos) || 0;
      if (nbTypos > 0) return false;
      const matchedTokens = oblistFeaturedMatchedTokens(hit);
      return queryTokens.every(function (token) { return matchedTokens.has(token); });
    }

    function oblistHitVendor(hit) {
      return hit && hit.vendor ? String(hit.vendor) : '';
    }

    // En stock = exactement COLLECTION_IN_STOCK_FILTER (inventory_available:true AND
    // NOT soldout). Sert à confiner le boost featured à la zone in-stock (un featured
    // dispo ne descend jamais chez les sold-out ; un sold-out n'est jamais remonté).
    function oblistHitInStock(hit) {
      if (!hit || hit.inventory_available !== true) return false;
      const c = hit.meta && hit.meta.custom;
      return !(c && (c.soldout === true || c.soldout === 'true'));
    }

    // Positions régulièrement espacées (gap) pour `count` featured dans [start, end).
    function oblistBandSlots(start, end, count, gap) {
      const slots = [];
      let p = start;
      for (let k = 0; k < count && p < end; k++) { slots.push(p); p += gap; }
      return slots;
    }

    // Ré-ordonne la source (= [featured triés boost desc] + [organiques]) en 2 phases :
    //  Phase 1 — assigner les featured aux PAGES : <=PER_PAGE+DEEP_PER_PAGE par page,
    //            <=VENDOR_PER_PAGE par vendeur (anti-monopolisation).
    //  Phase 2 — dans CHAQUE page, répartir ses featured entre la bande HAUTE (CTR) et
    //            la bande BASSE (scroll browse) proportionnellement (≈ ratio des caps),
    //            espacés par GAP ; les organiques remplissent le reste.
    // -> featured aérés haut ET bas, jamais un paquet, déterministe (page P ne dépend
    //    que des pages 0..P). even-spread prend le relais pour les petits résultats denses.
    function oblistRerankFeaturedCaps(source, hitsPerPage, totalHits) {
      const H = hitsPerPage || 40;
      const VCAP = OBLIST_FEATURED_PER_VENDOR_PER_PAGE;
      const GAP = OBLIST_FEATURED_MIN_GAP;
      const PRIME_BAND = Math.min(H, OBLIST_FEATURED_PRIME_BAND);
      const PRIME_CAP = OBLIST_FEATURED_PER_PAGE;
      const DEEP_START = Math.min(H, OBLIST_FEATURED_DEEP_BAND_START);
      const DEEP_CAP = OBLIST_FEATURED_DEEP_PER_PAGE;
      const PAGE_CAP = PRIME_CAP + DEEP_CAP;

      const featured = source.filter(oblistHitIsFeatured);
      const organics = source.filter(function (h) { return !oblistHitIsFeatured(h); });

      // Nb de pages RÉELLES du résultat (vrai total Algolia, pas la fenêtre). On
      // n'assigne jamais un featured à une page inexistante : sinon, sur un résultat
      // mono-vendeur court (= page collection vendeur), le surplus s'empilait sur la
      // dernière page (« bloc »). Borne dure = realPages.
      const realPages = Math.max(1, Math.ceil((totalHits || source.length) / H) || 1);

      function vCountOn(pg, v) {
        return pg.reduce(function (n, x) { return n + (oblistHitVendor(x) === v ? 1 : 0); }, 0);
      }

      // --- Phase 1 : assigner CHAQUE featured à une page réelle (3 passes) ---
      // A (équité) : 1re page avec place ET vendeur < VCAP -> concentre en tête (CTR)
      //   en plafonnant chaque vendeur. Browse multi-vendeurs : comportement inchangé.
      // B (relâche VCAP) : si aucune page sous VCAP (ex. page collection vendeur : un
      //   seul vendeur sature tout), page la MOINS remplie jusqu'à PAGE_CAP -> homogène.
      // C (résultat featured-dense) : si toutes les pages sont à PAGE_CAP, page la moins
      //   remplie (dépasse PAGE_CAP). Garantit qu'aucun featured n'est perdu, de façon
      //   DÉTERMINISTE (l'assignation ne dépend pas de la fenêtre) -> pagination stable.
      const pagesFeatured = [];
      for (let p = 0; p < realPages; p++) pagesFeatured.push([]);
      for (const f of featured) {
        const v = oblistHitVendor(f);
        let target = -1;
        for (let p = 0; p < realPages; p++) {
          if (pagesFeatured[p].length < PAGE_CAP && vCountOn(pagesFeatured[p], v) < VCAP) { target = p; break; }
        }
        if (target < 0) {
          for (let p = 0; p < realPages; p++) {
            if (pagesFeatured[p].length < PAGE_CAP &&
              (target < 0 || pagesFeatured[p].length < pagesFeatured[target].length)) target = p;
          }
        }
        if (target < 0) {
          target = 0;
          for (let p = 1; p < realPages; p++) {
            if (pagesFeatured[p].length < pagesFeatured[target].length) target = p;
          }
        }
        pagesFeatured[target].push(f);
      }

      // Positions des featured DANS une page : bandes haut/bas si K<=PAGE_CAP, sinon
      // (page featured-dense) répartition uniforme sur toute la page. Déterministe.
      function pageSlotMap(pf) {
        const K = pf.length;
        const sm = {};
        if (K <= PAGE_CAP) {
          let deepCount = Math.round(K * DEEP_CAP / PAGE_CAP);
          deepCount = Math.min(deepCount, DEEP_CAP, K);
          let primeCount = K - deepCount;
          if (primeCount > PRIME_CAP) { deepCount += primeCount - PRIME_CAP; primeCount = PRIME_CAP; }
          deepCount = Math.min(deepCount, DEEP_CAP);
          primeCount = Math.min(K - deepCount, PRIME_CAP);
          const primeF = pf.slice(0, primeCount);              // meilleurs boosts en haut
          const deepF = pf.slice(primeCount, primeCount + deepCount);
          oblistBandSlots(0, PRIME_BAND, primeF.length, GAP).forEach(function (pos, k) { sm[pos] = primeF[k]; });
          oblistBandSlots(DEEP_START, H, deepF.length, GAP).forEach(function (pos, k) { sm[pos] = deepF[k]; });
        } else {
          for (let k = 0; k < K && k < H; k++) {
            let pos = Math.min(H - 1, Math.round((k + 0.5) * H / K));
            let guard = 0;
            while (sm[pos] !== undefined && guard < H) { pos = (pos + 1) % H; guard += 1; }
            sm[pos] = pf[k];
          }
        }
        return sm;
      }

      // --- Phase 2 : construire chaque page (featured placés + organiques en ordre) ---
      const total = featured.length + organics.length;
      const numPages = Math.max(pagesFeatured.length, Math.ceil(total / H) || 1);
      const result = [];
      let oi = 0;
      for (let p = 0; p < numPages; p++) {
        const pf = pagesFeatured[p] || [];
        const slotMap = pageSlotMap(pf);
        const want = Object.keys(slotMap).length;
        let placedFeatured = 0;
        for (let pos = 0; pos < H; pos++) {
          if (slotMap[pos] !== undefined) {
            result.push(slotMap[pos]); placedFeatured += 1;
          } else if (oi < organics.length) {
            result.push(organics[oi]); oi += 1;
          } else if (placedFeatured < want) {
            // organiques épuisés : poser les featured restants de la page (fin de liste)
            for (let s = pos; s < H; s++) if (slotMap[s] !== undefined) { result.push(slotMap[s]); placedFeatured += 1; }
            break;
          } else {
            break; // page incomplète en fin de liste
          }
        }
        if (oi >= organics.length && placedFeatured >= want && p >= pagesFeatured.length - 1) {
          // plus d'organiques ni de featured à venir -> stop
          if (oi >= organics.length) break;
        }
      }
      return result;
    }

    // Les caps sont-ils atteignables ? Faux s'il y a plus de featured que de slots
    // (au total ou pour un vendeur) sur le nombre de pages disponibles.
    function oblistFeaturedCapsFeasible(source, hitsPerPage) {
      const H = hitsPerPage || 40;
      const nPages = Math.max(1, Math.ceil(source.length / H));
      const capPerPage = OBLIST_FEATURED_PER_PAGE + OBLIST_FEATURED_DEEP_PER_PAGE; // prime + deep
      const perVendor = {};
      let nF = 0;
      for (const h of source) {
        if (oblistHitIsFeatured(h)) {
          nF += 1;
          const v = oblistHitVendor(h);
          perVendor[v] = (perVendor[v] || 0) + 1;
        }
      }
      if (nF > nPages * capPerPage) return false;
      for (const v in perVendor) {
        if (perVendor[v] > nPages * OBLIST_FEATURED_PER_VENDOR_PER_PAGE) return false;
      }
      return true;
    }

    // Entrelace uniformément `featured` (en préservant leur ordre) parmi `normals`
    // (ordre préservé) sur T positions. Les featured tombent à des positions
    // régulièrement espacées (jamais collés, jamais tous en tête).
    function oblistInterleaveEven(featured, normals, T) {
      if (!T) return [];
      if (!featured.length) return normals.slice(0, T);
      const result = new Array(T).fill(null);
      const used = new Set();
      const slots = [];
      for (let k = 0; k < featured.length; k++) {
        let p = Math.min(T - 1, Math.round((k + 0.5) * T / featured.length));
        while (used.has(p)) p = (p + 1) % T;
        used.add(p);
        slots.push(p);
      }
      slots.sort(function (a, b) { return a - b; });
      for (let k = 0; k < featured.length; k++) result[slots[k]] = featured[k];
      let ni = 0;
      for (let p = 0; p < T; p++) {
        if (result[p] === null && ni < normals.length) result[p] = normals[ni++];
      }
      return result.filter(function (x) { return x !== null; });
    }

    // Fallback (petits résultats denses où les caps sont impossibles) : répartit les
    // featured UNIFORMÉMENT parmi TOUT le jeu (équilibré entre pages), pour éviter un
    // bloc de featured. Déterministe (utilisé seulement quand la fenêtre couvre tout).
    function oblistEvenSpreadFeatured(source) {
      const featured = source.filter(oblistHitIsFeatured);
      const normals = source.filter(function (h) { return !oblistHitIsFeatured(h); });
      if (!featured.length) return source.slice();
      return oblistInterleaveEven(featured, normals, source.length);
    }

    // Réinsère les items PINNÉS (merchandising) à leur position absolue dans une séquence
    // rerangée qui les EXCLUT déjà. Les pins priment ; le reste comble les positions libres.
    // pins = [{ pos, hit }] où pos = position absolue voulue (0-based).
    function oblistInsertPins(ordering, pins) {
      if (!pins || !pins.length) return ordering;
      const byPos = {};
      let maxPos = -1;
      pins.forEach(function (p) { byPos[p.pos] = p.hit; if (p.pos > maxPos) maxPos = p.pos; });
      const out = [];
      let oi = 0;
      const total = Math.max(ordering.length + pins.length, maxPos + 1);
      for (let pos = 0; pos < total; pos++) {
        if (byPos[pos] !== undefined) out.push(byPos[pos]);
        else if (oi < ordering.length) out.push(ordering[oi++]);
      }
      return out;
    }

    // Fallback collection : si la requête collection principale (filtre collection_ids)
    // renvoie 0 hit, on retente le batch en remplaçant collection_ids par le handle
    // (cas ex. gifts, où une Query Rule vide l'id). PASS-THROUGH TOTAL sinon -> aucun
    // impact sur les collections normales, le featured, les tris ou la recherche.
    function wrapSearchClientCollectionFallback(searchClient, productIndexName) {
      if (searchClient.__oblistCollFallbackWrapped) return;
      searchClient.__oblistCollFallbackWrapped = true;
      const originalSearch = searchClient.search.bind(searchClient);
      searchClient.search = async function (requests) {
        const res = await originalSearch(requests);
        const fallback = window.__OBLIST_COLL_FALLBACK__;
        if (!fallback) return res; // pas d'id/handle -> rien à faire (pass-through)
        let needRetry = false;
        (res.results || []).forEach(function (r, i) {
          const req = requests[i];
          const p = (req && req.params) || {};
          if (req && req.indexName === productIndexName && p.hitsPerPage !== 0 &&
            typeof p.filters === 'string' && p.filters.indexOf('collection_ids:') >= 0 &&
            r && r.nbHits === 0) needRetry = true;
        });
        if (!needRetry) return res; // cas nominal -> pass-through (0 impact)
        const retried = requests.map(function (req) {
          const p = (req && req.params) || {};
          if (req && req.indexName === productIndexName &&
            typeof p.filters === 'string' && p.filters.indexOf('collection_ids:') >= 0) {
            return { ...req, params: { ...p, filters: fallback } };
          }
          return req;
        });
        return originalSearch(retried);
      };
    }

    // Wrapper featured : sur-récupère une fenêtre (pages 0..P + marge) via le client
    // courant (déjà éventuellement enveloppé par stock-last), ré-ordonne pour les
    // plafonds, puis renvoie la tranche de la page demandée avec pagination recomposée.
    function wrapSearchClientFeaturedCaps(searchClient, productIndexName) {
      if (!oblistIndexHasFeaturedProgram(productIndexName)) return;
      if (searchClient.__oblistFeaturedWrapped) return;
      searchClient.__oblistFeaturedWrapped = true;
      const originalSearch = searchClient.search.bind(searchClient);

      function shouldRerank(request) {
        if (!request || request.indexName !== productIndexName) return false;
        const params = request.params || {};
        if (params.hitsPerPage === 0) return false; // requêtes de facettes/comptage
        return true;
      }

      function buildFeaturedWindowRequests(request) {
        const params = request.params || {};
        const H = params.hitsPerPage || 40;
        const page = params.page || 0;
        const windowPages = page + 1 + OBLIST_FEATURED_WINDOW_EXTRA_PAGES;
        const windowReqs = [];
        for (let pg = 0; pg < windowPages; pg++) {
          windowReqs.push({
            indexName: request.indexName,
            // getRankingInfo -> chaque hit expose _rankingInfo.promoted (=true si pinné
            // par une règle de merchandising). Sert à respecter les pins (cf. plus bas).
            params: { ...params, page: pg, hitsPerPage: H, getRankingInfo: true },
          });
        }
        // Requête "sponsorisée" : MÊME query/filtres + visibility_boost>0.
        // Les collections SEO et la recherche ajoutent ensuite un garde-fou : chaque
        // terme utile doit matcher sans typo dans un champ fiable avant toute injection.
        // removeWordsIfNoResults:'none' : l'index est en 'allOptional', donc une
        // recherche précise ("Onda Raku Black Wall Sconce") sans featured strict
        // rendrait TOUS les mots optionnels et ramènerait 100+ featured hors-sujet
        // (n'importe quel "wall"/"black"). On force le match complet -> pas de flood.
        const featuredParams = {
          ...params,
          page: 0,
          hitsPerPage: OBLIST_FEATURED_FETCH,
          filters: mergeAlgoliaFilters(params.filters || '', 'meta.custom.visibility_boost > 0'),
          removeWordsIfNoResults: 'none',
        };
        if (oblistFeaturedIntentGateEnabled()) {
          featuredParams.getRankingInfo = true;
          featuredParams.attributesToHighlight = OBLIST_FEATURED_TRUSTED_MATCH_PATHS;
        }
        const featuredReq = {
          indexName: request.indexName,
          params: featuredParams,
        };
        return { params, H, page, windowPages, windowReqs, featuredReq };
      }

      async function composeFeaturedResult(request, windowResults, featuredRes) {
        const params = request.params || {};
        const H = params.hitsPerPage || 40;
        const page = params.page || 0;
        const first = windowResults[0] || {};
        const total = first.nbHits || 0;
        const nbPages = Math.max(1, Math.ceil(total / H));
        const base = { ...first, page, hitsPerPage: H, nbHits: total, nbPages };

        // Fenêtre concaténée (positions absolues) : sert à détecter pins + vendeurs.
        const windowHits = [];
        for (let pg = 0; pg < windowResults.length; pg++) {
          const r = windowResults[pg];
          if (r && r.hits) for (const h of r.hits) windowHits.push(h);
        }
        // PINS : items promus par une règle de merchandising (Visual Editor). On les garde
        // FIGÉS à leur position absolue et on n'injecte les featured que dans les positions
        // NON pinnées (les "trous"). Un pin garde son badge featured éventuel mais n'est
        // jamais déplacé par le boost -> tes pins sont respectés.
        const pins = [];
        const pinnedIds = new Set();
        windowHits.forEach(function (h, idx) {
          if (h && h._rankingInfo && h._rankingInfo.promoted) { pins.push({ pos: idx, hit: h }); pinnedIds.add(h.objectID); }
        });

        // Featured pertinents (hors pins), triés PREMIUM d'abord (boost desc).
        const featuredHits = ((featuredRes && featuredRes.hits) || []).slice()
          .filter(function (h) { return !pinnedIds.has(h.objectID); })
          .filter(function (h) {
            return oblistFeaturedMatchesIntent(
              h,
              params.query || collection_meta_keyword
            );
          })
          .sort(function (a, b) {
            const ba = Number(a && a.meta && a.meta.custom && a.meta.custom.visibility_boost) || 0;
            const bb = Number(b && b.meta && b.meta.custom && b.meta.custom.visibility_boost) || 0;
            return bb - ba;
          });

        // Aucun featured à injecter -> page native (contient déjà les pins + ordre naturel).
        if (!featuredHits.length) {
          const native = (windowResults[page] && windowResults[page].hits) || [];
          return { ...base, hits: native };
        }

        // Page collection MONO-VENDEUR (= page vendeur) : un seul vendeur sur la fenêtre.
        // Le confinement stock-aware ne s'applique QU'À ce cas ; multi-vendeurs, SEO et
        // recherche gardent STRICTEMENT leur comportement habituel.
        const windowVendors = new Set();
        windowHits.forEach(function (h) { const v = oblistHitVendor(h); if (v) windowVendors.add(v); });
        const singleVendorCollection = collection_handle !== 'search' && windowVendors.size <= 1;

        let reranked;
        if (singleVendorCollection) {
          // PAGE VENDEUR uniquement. Ordre in-stock-first (customRanking) -> on ne booste
          // que les featured EN STOCK, confinés au bloc in-stock ; le bloc sold-out reste
          // intact. Comptage in-stock fait ICI seulement (0 impact sur les autres pages).
          const cntRes = await originalSearch([{
            indexName: request.indexName,
            params: {
              ...params, page: 0, hitsPerPage: 0,
              filters: mergeAlgoliaFilters(params.filters || '', COLLECTION_IN_STOCK_FILTER),
            },
          }]);
          const inStockCount = (cntRes.results && cntRes.results[0] && cntRes.results[0].nbHits) || 0;

          const inStockFeatured = featuredHits.filter(oblistHitInStock);
          const boostIds = new Set(inStockFeatured.map(function (h) { return h.objectID; }));
          const organics = windowHits.filter(function (h) { return !boostIds.has(h.objectID) && !pinnedIds.has(h.objectID); });
          const inStockOrganics = organics.filter(oblistHitInStock);
          const soldTail = organics.filter(function (h) { return !oblistHitInStock(h); });
          const inStockSource = inStockFeatured.concat(inStockOrganics);
          const inStockCoversAll = inStockCount <= (1 + OBLIST_FEATURED_WINDOW_EXTRA_PAGES) * H;
          const inStockBlock = (inStockCoversAll && !oblistFeaturedCapsFeasible(inStockSource, H))
            ? oblistEvenSpreadFeatured(inStockSource)
            : oblistRerankFeaturedCaps(inStockSource, H, inStockCount);
          reranked = inStockBlock.concat(soldTail);
        } else {
          // Multi-vendeur / SEO / recherche : comportement habituel. Tous les featured
          // pertinents sont répartis en bandes parmi les organiques (pins exclus).
          const featuredIds = new Set(featuredHits.map(function (h) { return h.objectID; }));
          const organics = windowHits.filter(function (h) { return !featuredIds.has(h.objectID) && !pinnedIds.has(h.objectID); });
          const source = featuredHits.concat(organics);
          const coversAll = total <= (1 + OBLIST_FEATURED_WINDOW_EXTRA_PAGES) * H;
          reranked = (coversAll && !oblistFeaturedCapsFeasible(source, H))
            ? oblistEvenSpreadFeatured(source)
            : oblistRerankFeaturedCaps(source, H, total);
        }
        // Réinsère les pins à leur position absolue (ils priment sur les featured/organiques).
        reranked = oblistInsertPins(reranked, pins);
        const start = page * H;
        return { ...base, hits: reranked.slice(start, start + H) };
      }

      // UN SEUL POST multi-queries : fenêtre featured + requêtes InstantSearch annexes
      // (bornes prix, compteurs disjonctifs…). L'ancien split passthrough/featured
      // cassait la fédération native d'InstantSearch (1 clic facette → 2 HTTP).
      searchClient.search = async function (requests) {
        const flags = requests.map(shouldRerank);
        if (!flags.some(Boolean)) return originalSearch(requests);

        const federated = [];
        const plan = [];

        requests.forEach((request, i) => {
          if (!flags[i]) {
            plan.push({ type: 'pass', requestIndex: i, start: federated.length, len: 1 });
            federated.push(request);
            return;
          }
          const built = buildFeaturedWindowRequests(request);
          plan.push({
            type: 'rerank',
            requestIndex: i,
            request,
            start: federated.length,
            windowPages: built.windowPages,
            page: built.page,
          });
          for (let w = 0; w < built.windowReqs.length; w++) federated.push(built.windowReqs[w]);
          federated.push(built.featuredReq);
        });

        const res = await originalSearch(federated);
        const allResults = (res && res.results) || [];
        const results = new Array(requests.length);

        await Promise.all(plan.map(async (step) => {
          if (step.type === 'pass') {
            results[step.requestIndex] = allResults[step.start];
            return;
          }
          const windowResults = allResults.slice(step.start, step.start + step.windowPages);
          const featuredRes = allResults[step.start + step.windowPages];
          results[step.requestIndex] = await composeFeaturedResult(
            step.request,
            windowResults,
            featuredRes
          );
        }));

        return { results };
      };
    }

    // Même pipeline Algolia que la page /search (header).
    function buildTextSearchConfigure(query, page, options) {
      const resolved = algolia.helpers?.resolveFrSearchParams
        ? algolia.helpers.resolveFrSearchParams(query, current_locale)
        : { query, extraFilters: '', analyticsQuery: query };
      const cfg = {
        query: resolved.query,
        hitsPerPage: 40,
        clickAnalytics: true,
        analyticsTags: [`${resolved.analyticsQuery || query}`],
        maxValuesPerFacet: 100,
        optionalFilters: ['inventory_available:true<score=10000>', 'meta.custom.soldout:false<score=10000>'],
      };
      // Search routing owns `page` — locking it here fights pagination + URL restore.
      if (!(options && options.omitPage)) {
        cfg.page = page || 0;
      }
      if (resolved.extraFilters) {
        cfg.filters = resolved.extraFilters;
      }
      return cfg;
    }

    // Create a shared function for creating hierarchical facets
    /**
     * Item location facet: economic zones (EU / US / UK / Other) + country drill-down.
     * Zone click refines all countries in that zone (OR). Visitor zone listed first.
     */
    /**
     * Delivery options — radio buckets from meta.mindeliverytime.mindeltime (weeks).
     * 1 week = 7 days. Buckets: any | ≤1w | ≤2w | ≤4w | ≥5w.
     * Requires attributesForFaceting to include meta.mindeliverytime.mindeltime
     * (see tools/algolia-enable-delivery-facet.py).
     */
    function createDeliveryOptionsFacet(config) {
      if (typeof connectRefinementList !== 'function') return null;

      const ATTRIBUTE = 'meta.mindeliverytime.mindeltime';
      const BUCKETS = [
        { id: 'any', label: 'No preference', weeks: null },
        { id: 'd7', label: 'Within 7 days', maxWeek: 1 },
        { id: 'd14', label: 'Within 14 days', maxWeek: 2 },
        { id: 'd30', label: 'Within 30 days', maxWeek: 4 },
        { id: 'd30plus', label: '+30 days', minWeek: 5 },
      ];

      function escapeHtml(str) {
        return String(str || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function weekNumber(value) {
        const n = parseInt(String(value).replace(/[^\d-]/g, ''), 10);
        return Number.isFinite(n) ? n : null;
      }

      function weeksForBucket(bucket, availableWeeks) {
        if (!bucket || bucket.id === 'any') return [];
        if (bucket.maxWeek != null) {
          return availableWeeks.filter((w) => w >= 0 && w <= bucket.maxWeek).map(String);
        }
        if (bucket.minWeek != null) {
          return availableWeeks.filter((w) => w >= bucket.minWeek).map(String);
        }
        return [];
      }

      function detectSelectedBucket(refinedValues, availableWeeks) {
        const refined = new Set((refinedValues || []).map(String));
        if (refined.size === 0) return 'any';
        // Match the tightest bucket whose week set equals current refinements
        for (const bucket of BUCKETS) {
          if (bucket.id === 'any') continue;
          const weeks = weeksForBucket(bucket, availableWeeks);
          if (!weeks.length) continue;
          if (weeks.length === refined.size && weeks.every((w) => refined.has(w))) {
            return bucket.id;
          }
        }
        // Partial / manual — treat as any visually if not exact
        return 'any';
      }

      let boundRoot = null;
      const deliveryWidget = connectRefinementList((renderOptions) => {
        const { items, refine, widgetParams, canRefine, instantSearchInstance } = renderOptions;
        const root = typeof widgetParams.container === 'string'
          ? document.querySelector(widgetParams.container)
          : widgetParams.container;
        if (!root) return;

        // Keep panel visible even before facet is enabled (show radios; counts 0)
        const availableWeeks = (items || [])
          .map((item) => weekNumber(item.value))
          .filter((n) => n != null)
          .sort((a, b) => a - b);
        // Always include common weeks so buckets work once facet is live
        const weekUniverse = Array.from(new Set(availableWeeks.concat([0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14])));

        const refinedValues = (items || []).filter((i) => i.isRefined).map((i) => String(i.value));
        const selectedId = detectSelectedBucket(refinedValues, weekUniverse);

        const countByWeek = {};
        (items || []).forEach((item) => {
          countByWeek[String(item.value)] = item.count || 0;
        });

        function bucketCount(bucket) {
          if (bucket.id === 'any') return null;
          const weeks = weeksForBucket(bucket, weekUniverse);
          return weeks.reduce((sum, w) => sum + (countByWeek[w] || 0), 0);
        }

        let html = '<div class="ais-delivery-facet">';
        BUCKETS.forEach((bucket) => {
          const count = bucketCount(bucket);
          const checked = selectedId === bucket.id;
          html +=
            '<label class="ais-delivery-option' + (checked ? ' is-selected' : '') + '">' +
              '<input type="radio" name="ais-delivery-options" data-bucket="' + escapeHtml(bucket.id) + '" ' +
                (checked ? 'checked ' : '') + '/>' +
              '<span class="ais-delivery-label">' + escapeHtml(translateTerm(bucket.label)) + '</span>' +
              (count != null && canRefine ? '<span class="count">' + count.toLocaleString(current_locale === 'fr' ? 'fr-FR' : 'en-US') + '</span>' : '') +
            '</label>';
        });
        html += '</div>';
        root.innerHTML = html;

        root._deliveryRefine = refine;
        root._deliveryHelper = instantSearchInstance && instantSearchInstance.helper;
        root._deliveryAttribute = ATTRIBUTE;
        root._deliveryItems = items || [];
        root._deliveryWeekUniverse = weekUniverse;

        if (boundRoot !== root) {
          boundRoot = root;
          root.addEventListener('change', (event) => {
            const input = event.target;
            if (!(input instanceof HTMLInputElement) || input.getAttribute('data-bucket') == null) return;
            const bucketId = input.getAttribute('data-bucket');
            const bucket = BUCKETS.find((b) => b.id === bucketId);
            const helper = root._deliveryHelper;
            const attribute = root._deliveryAttribute;
            const refineFn = root._deliveryRefine;
            const universe = root._deliveryWeekUniverse || weekUniverse;
            const currentRefined = new Set(
              (root._deliveryItems || []).filter((i) => i.isRefined).map((i) => String(i.value))
            );
            const targetWeeks = bucket && bucket.id !== 'any'
              ? weeksForBucket(bucket, universe)
              : [];

            if (helper && attribute) {
              helper.clearRefinements(attribute);
              targetWeeks.forEach((value) => {
                helper.addDisjunctiveFacetRefinement(attribute, value);
              });
              helper.search();
              return;
            }

            // Fallback: toggle via refine()
            if (typeof refineFn !== 'function') return;
            currentRefined.forEach((value) => refineFn(value));
            targetWeeks.forEach((value) => refineFn(value));
          });
        }
      });

      const deliveryPanel = panel({
        hidden: () => false,
        templates: {
          header() {
            return `<div class="ais-Panel-header-span">${translateTerm('Delivery options')}
              ${chevronHTML}</div>`;
          },
        },
      });

      return deliveryPanel(deliveryWidget)({
        container: config.container,
        attribute: ATTRIBUTE,
        operator: 'or',
        limit: 100,
        showMore: false,
        sortBy: ['name:asc'],
      });
    }

    /**
     * In stock only — physical stock (inventory_quantity > 0).
     * NOT inventory_available (that stays true with "Sell when out of stock" / MTO).
     * Example: Lamina console is MTO + inventory_available:true + inventory_quantity:0.
     *
     * Important: must mutate helper numericRefinements directly. Calling helper.search()
     * alone does NOT re-run getWidgetSearchParameters for plain custom widgets.
     */
    function createInStockQuantityToggle(config) {
      let enabled = false;
      let boundRoot = null;
      const rootEl = config && config.container;

      function escapeHtml(str) {
        return String(str || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function helperHasStockFilter(helper) {
        try {
          const current = helper.state && helper.state.numericRefinements
            ? helper.state.numericRefinements.inventory_quantity
            : null;
          return !!(current && Object.keys(current).length);
        } catch (e) {
          return false;
        }
      }

      function applyStockFilterToHelper(helper) {
        if (!helper) return;
        // helper.add/removeNumericRefinement reset the page to 0. On init the state
        // already comes from getWidgetSearchParameters, so touching it here wiped
        // ?page=N (Back to page 2 rendered page 1). Only mutate when out of sync.
        if (helperHasStockFilter(helper) === enabled) return;
        try { helper.removeNumericRefinement('inventory_quantity'); } catch (e) { /* ok */ }
        if (enabled) {
          helper.addNumericRefinement('inventory_quantity', '>', 0);
        }
      }

      window.__oblistInStockQuantity = {
        isEnabled: () => enabled,
        clear() {
          enabled = false;
        },
        clearAndApply(helper) {
          enabled = false;
          applyStockFilterToHelper(helper);
        },
        setEnabled(v) { enabled = !!v; },
      };

      return {
        $$type: 'oblist.inStockQuantity',
        init({ helper, uiState }) {
          const indexUiState = (uiState && uiState[algoliaIndexName]) || uiState || {};
          if (indexUiState.oblistInStock) enabled = true;
          applyStockFilterToHelper(helper);
        },
        dispose({ helper }) {
          enabled = false;
          applyStockFilterToHelper(helper);
        },
        getWidgetUiState(uiState) {
          if (!enabled) {
            if (!uiState.oblistInStock) return uiState;
            const next = { ...uiState };
            delete next.oblistInStock;
            return next;
          }
          return { ...uiState, oblistInStock: true };
        },
        getWidgetSearchParameters(searchParameters, { uiState }) {
          if (uiState && Object.prototype.hasOwnProperty.call(uiState, 'oblistInStock')) {
            enabled = !!uiState.oblistInStock;
          }
          let next = searchParameters.removeNumericRefinement('inventory_quantity');
          if (enabled) {
            next = next.addNumericRefinement('inventory_quantity', '>', 0);
          }
          return next;
        },
        render(renderOptions) {
          const { helper } = renderOptions;
          const root = rootEl;
          if (!root) return;

          const mtoActive = !!(window.__oblistItemTypeExclusive && window.__oblistItemTypeExclusive.isMto());
          if (mtoActive && enabled) {
            enabled = false;
            applyStockFilterToHelper(helper);
          }

          root.innerHTML =
            '<div class="ais-ToggleRefinement' +
              (enabled ? ' ais-ToggleRefinement--selected' : '') +
              (mtoActive ? ' ais-ToggleRefinement--disabled-by-mto' : '') +
            '">' +
              '<label class="ais-ToggleRefinement-label ais-Panel-header-span">' +
                '<input type="checkbox" class="ais-ToggleRefinement-checkbox switch" ' +
                  (enabled ? 'checked ' : '') +
                  (mtoActive ? 'disabled ' : '') +
                '/>' +
                '<span class="ais-ToggleRefinement-labelText">' +
                  escapeHtml(translateTerm('In stock only')) +
                '</span>' +
              '</label>' +
              (mtoActive
                ? '<p class="ais-ToggleRefinement-mtoHint">' +
                    escapeHtml(translateTerm('Ready to ship now — not available with Made to order.')) +
                  '</p>'
                : '') +
            '</div>';

          if (boundRoot !== root) {
            boundRoot = root;
            root.addEventListener('change', (event) => {
              const input = event.target;
              if (!(input instanceof HTMLInputElement)) return;
              if (input.disabled) return;
              enabled = !!input.checked;
              if (enabled && window.__oblistItemTypeExclusive && window.__oblistItemTypeExclusive.isMto()) {
                window.__oblistItemTypeExclusive.resetMtoMode(helper);
              }
              applyStockFilterToHelper(helper);
              if (helper) helper.search();
            });
          }
        },
      };
    }

    /**
     * Item type — radio buckets:
     *   All
     *   Antique and vintage  → meta.custom.badges contains VINTAGE (NOT mtop:No)
     *     └ Vintage condition → meta.vintageconditionreport.vintagecr (checkboxes)
     *   New and made to order → meta.mtoproduct.mtop Yes/yes
     *     └ Max make time → meta.maxdeliverytime.maxdeltime (≤ N weeks radios)
     *
     * Requires attributesForFaceting (tools/algolia-enable-mto-facet.py):
     *   meta.custom.badges, meta.mtoproduct.mtop,
     *   meta.vintageconditionreport.vintagecr, meta.maxdeliverytime.maxdeltime
     */
    function createItemTypeFacet(config) {
      if (typeof connectRefinementList !== 'function') return null;

      const BADGES_ATTR = 'meta.custom.badges';
      const MTOP_ATTR = 'meta.mtoproduct.mtop';
      const CONDITION_ATTR = 'meta.vintageconditionreport.vintagecr';
      const MAX_ATTR = 'meta.maxdeliverytime.maxdeltime';
      const VINTAGE_BADGES = ['VINTAGE', 'vintage', 'Vintage'];
      const MTO_VALUES = ['Yes', 'yes'];
      const MAX_BUCKETS = [
        { id: 'any', label: 'No max preference' },
        { id: 'w2', label: 'Up to 2 weeks', maxWeek: 2 },
        { id: 'w4', label: 'Up to 4 weeks', maxWeek: 4 },
        { id: 'w8', label: 'Up to 8 weeks', maxWeek: 8 },
        { id: 'w12', label: 'Up to 12 weeks', maxWeek: 12 },
        { id: 'w12plus', label: 'More than 12 weeks', minWeek: 13 },
      ];

      // Single source of truth — avoids half-applied helper refinements
      const itemTypeState = {
        mode: 'any', // any | vintage | mto
        conditions: [], // trimmed condition values
        maxBucketId: 'any',
      };

      // Shared with In stock toggle: MTO and "in stock" are mutually exclusive for shoppers
      // (even if Shopify marks some MTO as inventory_available=true).
      window.__oblistItemTypeExclusive = {
        helper: null,
        isMto: () => itemTypeState.mode === 'mto',
        resetMtoMode(helper) {
          if (itemTypeState.mode !== 'mto') return false;
          itemTypeState.mode = 'any';
          itemTypeState.conditions = [];
          itemTypeState.maxBucketId = 'any';
          const h = helper || window.__oblistItemTypeExclusive.helper;
          if (!h) return true;
          ensureDisjunctiveFacets(h);
          clearVintageBadges(h);
          clearMto(h);
          clearCondition(h);
          clearMaxMakeTime(h);
          syncInStockToggleUi(false);
          return true;
        },
        resetAll(helper) {
          itemTypeState.mode = 'any';
          itemTypeState.conditions = [];
          itemTypeState.maxBucketId = 'any';
          const h = helper || window.__oblistItemTypeExclusive.helper;
          if (!h) return true;
          ensureDisjunctiveFacets(h);
          clearVintageBadges(h);
          clearMto(h);
          clearCondition(h);
          clearMaxMakeTime(h);
          syncInStockToggleUi(false);
          return true;
        },
      };

      function escapeHtml(str) {
        return String(str || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function weekNumber(value) {
        const n = parseInt(String(value).replace(/[^\d-]/g, ''), 10);
        return Number.isFinite(n) ? n : null;
      }

      function facetEntries(results, attribute) {
        if (!results || typeof results.getFacetValues !== 'function') return [];
        try {
          const values = results.getFacetValues(attribute, { sortBy: ['count:desc', 'name:asc'] });
          if (Array.isArray(values)) return values;
          if (values && Array.isArray(values.data)) return values.data;
        } catch (e) { /* facet not declared yet */ }
        return [];
      }

      function isVintageBadge(value) {
        return VINTAGE_BADGES.includes(String(value));
      }

      function isMtoValue(value) {
        return MTO_VALUES.includes(String(value));
      }

      function weeksForMaxBucket(bucket, availableWeeks) {
        if (!bucket || bucket.id === 'any') return [];
        if (bucket.maxWeek != null) {
          return availableWeeks.filter((w) => w >= 0 && w <= bucket.maxWeek).map(String);
        }
        if (bucket.minWeek != null) {
          return availableWeeks.filter((w) => w >= bucket.minWeek).map(String);
        }
        return [];
      }

      function ensureDisjunctiveFacets(helper) {
        if (!helper || !helper.state) return;
        let state = helper.state;
        [BADGES_ATTR, MTOP_ATTR, CONDITION_ATTR, MAX_ATTR].forEach((attr) => {
          if (!state.disjunctiveFacets || state.disjunctiveFacets.indexOf(attr) === -1) {
            state = state.addDisjunctiveFacet(attr);
          }
        });
        if (state !== helper.state) helper.setState(state);
      }

      function clearVintageBadges(helper) {
        (helper.getRefinements(BADGES_ATTR) || []).forEach((r) => {
          if (isVintageBadge(r.value)) {
            helper.removeDisjunctiveFacetRefinement(BADGES_ATTR, r.value);
          }
        });
      }

      function clearMto(helper) {
        helper.clearRefinements(MTOP_ATTR);
      }

      function clearCondition(helper) {
        helper.clearRefinements(CONDITION_ATTR);
      }

      function clearMaxMakeTime(helper) {
        helper.clearRefinements(MAX_ATTR);
      }

      function clearInStock(helper) {
        // Real stock filter uses inventory_quantity > 0 (custom widget), not inventory_available
        if (window.__oblistInStockQuantity && typeof window.__oblistInStockQuantity.clearAndApply === 'function') {
          window.__oblistInStockQuantity.clearAndApply(helper);
        } else if (window.__oblistInStockQuantity && typeof window.__oblistInStockQuantity.clear === 'function') {
          window.__oblistInStockQuantity.clear();
          if (helper) {
            try { helper.removeNumericRefinement('inventory_quantity'); } catch (e) { /* ok */ }
          }
        }
        if (helper) helper.clearRefinements('inventory_available');
      }

      function syncInStockToggleUi(mtoActive) {
        // Re-render is driven by helper.search(); keep a light DOM hint for snappiness
        const root = document.querySelector('.ais-facets-container .ais-ToggleRefinement');
        if (!root) return;
        root.classList.toggle('ais-ToggleRefinement--disabled-by-mto', !!mtoActive);
        const input = root.querySelector('input[type="checkbox"]');
        if (input) {
          input.disabled = !!mtoActive;
          if (mtoActive) input.checked = false;
        }
        let hint = root.querySelector('.ais-ToggleRefinement-mtoHint');
        if (mtoActive) {
          if (!hint) {
            hint = document.createElement('p');
            hint.className = 'ais-ToggleRefinement-mtoHint';
            root.appendChild(hint);
          }
          hint.textContent = translateTerm(
            'Ready to ship now — not available with Made to order.'
          );
        } else if (hint) {
          hint.remove();
        }
      }

      function applyVintageBadge(helper, badgeItems) {
        const available = new Set((badgeItems || []).map((i) => String(i.value)));
        const picks = VINTAGE_BADGES.filter((v) => available.has(v));
        (picks.length ? picks : ['VINTAGE', 'vintage']).forEach((v) => {
          helper.addDisjunctiveFacetRefinement(BADGES_ATTR, v);
        });
      }

      function applyMto(helper, mtoEntries) {
        const available = (mtoEntries || []).map((e) => String(e.name != null ? e.name : e.value));
        const picks = MTO_VALUES.filter((v) => available.includes(v));
        (picks.length ? picks : ['Yes']).forEach((v) => {
          helper.addDisjunctiveFacetRefinement(MTOP_ATTR, v);
        });
      }

      function applyMaxBucket(helper, bucket, availableWeeks) {
        weeksForMaxBucket(bucket, availableWeeks).forEach((value) => {
          helper.addDisjunctiveFacetRefinement(MAX_ATTR, value);
        });
      }

      // Normalize facet condition values (trim / trailing-space duplicates in index)
      function normalizeConditionEntries(entries) {
        const byKey = new Map();
        (entries || []).forEach((entry) => {
          const raw = String(entry.name != null ? entry.name : entry.value);
          const key = raw.trim();
          if (!key) return;
          const prev = byKey.get(key);
          if (prev) {
            prev.count += entry.count || 0;
            if (raw !== key) prev.aliases.add(raw);
          } else {
            byKey.set(key, {
              key,
              count: entry.count || 0,
              aliases: new Set(raw !== key ? [raw] : []),
            });
          }
        });
        return Array.from(byKey.values()).sort((a, b) => b.count - a.count);
      }

      function applyItemTypeState(helper, badgeItems, mtoEntries, availableWeeks) {
        if (!helper) return;
        ensureDisjunctiveFacets(helper);
        clearVintageBadges(helper);
        clearMto(helper);
        clearCondition(helper);
        clearMaxMakeTime(helper);

        if (itemTypeState.mode === 'vintage') {
          applyVintageBadge(helper, badgeItems);
          itemTypeState.conditions.forEach((key) => {
            helper.addDisjunctiveFacetRefinement(CONDITION_ATTR, key);
            // Index sometimes stores a trailing space on the same value
            helper.addDisjunctiveFacetRefinement(CONDITION_ATTR, key + ' ');
          });
        } else if (itemTypeState.mode === 'mto') {
          // MTO = crafted after purchase → cannot combine with "In stock only"
          clearInStock(helper);
          applyMto(helper, mtoEntries);
          const bucket = MAX_BUCKETS.find((b) => b.id === itemTypeState.maxBucketId);
          if (bucket && bucket.id !== 'any') {
            applyMaxBucket(helper, bucket, availableWeeks);
          }
        }
        syncInStockToggleUi(itemTypeState.mode === 'mto');
        helper.search();
      }

      let boundRoot = null;
      const itemTypeWidget = connectRefinementList((renderOptions) => {
        const { items, widgetParams, canRefine, instantSearchInstance } = renderOptions;
        const root = typeof widgetParams.container === 'string'
          ? document.querySelector(widgetParams.container)
          : widgetParams.container;
        if (!root) return;

        const helper = instantSearchInstance && instantSearchInstance.helper;
        const results = helper && helper.lastResults;
        ensureDisjunctiveFacets(helper);

        // Sync mode from helper if URL/state restored refinements externally
        const badgeRefined = (items || []).filter((i) => i.isRefined).map((i) => String(i.value));
        if (badgeRefined.some(isVintageBadge)) itemTypeState.mode = 'vintage';
        else if (helper && (helper.getRefinements(MTOP_ATTR) || []).some((r) => isMtoValue(r.value))) {
          itemTypeState.mode = 'mto';
        } else if (
          !badgeRefined.some(isVintageBadge) &&
          !(helper && (helper.getRefinements(MTOP_ATTR) || []).some((r) => isMtoValue(r.value))) &&
          itemTypeState.conditions.length === 0 &&
          itemTypeState.maxBucketId === 'any'
        ) {
          itemTypeState.mode = 'any';
        }

        const selectedId = itemTypeState.mode;
        const localeTag = current_locale === 'fr' ? 'fr-FR' : 'en-US';

        const badgeCountByValue = {};
        (items || []).forEach((item) => {
          badgeCountByValue[String(item.value)] = item.count || 0;
        });
        const vintageCount = VINTAGE_BADGES.reduce(
          (sum, v) => sum + (badgeCountByValue[v] || 0),
          0
        );

        const mtoEntries = facetEntries(results, MTOP_ATTR);
        const mtoCount = mtoEntries.reduce((sum, entry) => {
          const name = String(entry.name != null ? entry.name : entry.value);
          return isMtoValue(name) ? sum + (entry.count || 0) : sum;
        }, 0);

        const conditionEntries = normalizeConditionEntries(facetEntries(results, CONDITION_ATTR));
        const conditionRefined = new Set(itemTypeState.conditions);

        const maxEntries = facetEntries(results, MAX_ATTR);
        const weeksFromFacet = maxEntries
          .map((e) => weekNumber(e.name != null ? e.name : e.value))
          .filter((n) => n != null);
        const availableWeeks = Array.from(new Set(weeksFromFacet)).sort((a, b) => a - b);
        // Pad with common weeks only once facet data exists (avoids fake 0 buckets)
        const weekUniverse = availableWeeks.length
          ? Array.from(new Set(availableWeeks.concat([1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 15, 16, 20, 24, 30]))).sort((a, b) => a - b)
          : [];
        const countByWeek = {};
        maxEntries.forEach((entry) => {
          countByWeek[String(entry.name != null ? entry.name : entry.value)] = entry.count || 0;
        });
        const selectedMaxId = itemTypeState.maxBucketId;

        function maxBucketCount(bucket) {
          if (bucket.id === 'any') return null;
          if (!weekUniverse.length) return 0;
          return weeksForMaxBucket(bucket, weekUniverse)
            .reduce((sum, w) => sum + (countByWeek[w] || 0), 0);
        }

        let html = '<div class="ais-delivery-facet ais-item-type-facet">';

        html +=
          '<label class="ais-delivery-option' + (selectedId === 'any' ? ' is-selected' : '') + '">' +
            '<input type="radio" name="ais-item-type" data-bucket="any" ' +
              (selectedId === 'any' ? 'checked ' : '') + '/>' +
            '<span class="ais-delivery-label">' + escapeHtml(translateTerm('All')) + '</span>' +
          '</label>';

        html +=
          '<label class="ais-delivery-option' + (selectedId === 'vintage' ? ' is-selected' : '') + '">' +
            '<input type="radio" name="ais-item-type" data-bucket="vintage" ' +
              (selectedId === 'vintage' ? 'checked ' : '') + '/>' +
            '<span class="ais-delivery-label">' + escapeHtml(translateTerm('Antique and vintage')) + '</span>' +
            (canRefine
              ? '<span class="count">' + vintageCount.toLocaleString(localeTag) + '</span>'
              : '') +
          '</label>';

        if (selectedId === 'vintage' && conditionEntries.length) {
          html += '<div class="ais-item-type-subfacet">';
          html += '<div class="ais-item-type-subfacet-title">' +
            escapeHtml(translateTerm('Vintage Condition')) + '</div>';
          conditionEntries.forEach((entry) => {
            const checked = conditionRefined.has(entry.key);
            html +=
              '<label class="ais-item-type-condition' + (checked ? ' is-selected' : '') + '">' +
                '<input type="checkbox" data-condition="' + escapeHtml(entry.key) + '" ' +
                  (checked ? 'checked ' : '') + '/>' +
                '<span class="ais-delivery-label">' + escapeHtml(translateTerm(entry.key)) + '</span>' +
                '<span class="count">' + entry.count.toLocaleString(localeTag) + '</span>' +
              '</label>';
          });
          html += '</div>';
        }

        html +=
          '<label class="ais-delivery-option' + (selectedId === 'mto' ? ' is-selected' : '') + '">' +
            '<input type="radio" name="ais-item-type" data-bucket="mto" ' +
              (selectedId === 'mto' ? 'checked ' : '') + '/>' +
            '<span class="ais-delivery-label">' + escapeHtml(translateTerm('New and made to order')) + '</span>' +
            (canRefine
              ? '<span class="count">' + mtoCount.toLocaleString(localeTag) + '</span>'
              : '') +
          '</label>';

        // Only show max-make-time once Algolia returns facet values (avoid fake zeros)
        if (selectedId === 'mto' && maxEntries.length) {
          html += '<div class="ais-item-type-subfacet">';
          html += '<div class="ais-item-type-subfacet-title">' +
            escapeHtml(translateTerm('Max make time')) + '</div>';
          MAX_BUCKETS.forEach((bucket) => {
            const count = maxBucketCount(bucket);
            const checked = selectedMaxId === bucket.id;
            html +=
              '<label class="ais-item-type-condition' + (checked ? ' is-selected' : '') + '">' +
                '<input type="radio" name="ais-mto-max" data-max-bucket="' + escapeHtml(bucket.id) + '" ' +
                  (checked ? 'checked ' : '') + '/>' +
                '<span class="ais-delivery-label">' + escapeHtml(translateTerm(bucket.label)) + '</span>' +
                (count != null
                  ? '<span class="count">' + count.toLocaleString(localeTag) + '</span>'
                  : '') +
              '</label>';
          });
          html += '</div>';
        }

        html += '</div>';
        root.innerHTML = html;

        // Open once on first paint only. Re-running this on every InstantSearch
        // render (e.g. clicking Product Type) was forcing Item type back open.
        if (!root.dataset.oblistItemTypeDefaultExpanded) {
          root.dataset.oblistItemTypeDefaultExpanded = '1';
          const panelBody = root.closest('.ais-Panel-body');
          if (panelBody && !panelBody.classList.contains('ais-Panel-body--expanded')) {
            panelBody.classList.add('ais-Panel-body--expanded');
            const panelHeader = panelBody.previousElementSibling;
            if (panelHeader && panelHeader.classList.contains('ais-Panel-header')) {
              panelHeader.classList.add('is-expanded');
            }
          }
        }

        syncInStockToggleUi(selectedId === 'mto');
        if (window.__oblistItemTypeExclusive) {
          window.__oblistItemTypeExclusive.helper = helper;
        }

        root._itemTypeHelper = helper;
        root._itemTypeBadgeItems = items || [];
        root._itemTypeMtoEntries = mtoEntries;
        root._itemTypeMaxWeeks = weekUniverse;

        if (boundRoot !== root) {
          boundRoot = root;
          root.addEventListener('change', (event) => {
            const input = event.target;
            if (!(input instanceof HTMLInputElement)) return;
            const helperRef = root._itemTypeHelper;
            if (!helperRef) return;

            const conditionValue = input.getAttribute('data-condition');
            if (conditionValue != null) {
              const key = String(conditionValue).trim();
              itemTypeState.mode = 'vintage';
              const set = new Set(itemTypeState.conditions);
              if (set.has(key)) set.delete(key);
              else set.add(key);
              itemTypeState.conditions = Array.from(set);
              itemTypeState.maxBucketId = 'any';
              applyItemTypeState(
                helperRef,
                root._itemTypeBadgeItems,
                root._itemTypeMtoEntries,
                root._itemTypeMaxWeeks
              );
              return;
            }

            const maxBucketId = input.getAttribute('data-max-bucket');
            if (maxBucketId != null) {
              itemTypeState.mode = 'mto';
              itemTypeState.maxBucketId = maxBucketId;
              itemTypeState.conditions = [];
              applyItemTypeState(
                helperRef,
                root._itemTypeBadgeItems,
                root._itemTypeMtoEntries,
                root._itemTypeMaxWeeks
              );
              return;
            }

            const bucketId = input.getAttribute('data-bucket');
            if (bucketId == null) return;

            itemTypeState.mode = bucketId;
            if (bucketId !== 'vintage') itemTypeState.conditions = [];
            if (bucketId !== 'mto') itemTypeState.maxBucketId = 'any';
            applyItemTypeState(
              helperRef,
              root._itemTypeBadgeItems,
              root._itemTypeMtoEntries,
              root._itemTypeMaxWeeks
            );
          });
        }
      });

      const itemTypePanel = panel({
        hidden: () => false,
        templates: {
          header() {
            return `<div class="ais-Panel-header-span">${translateTerm('Creation Type')}
              ${chevronHTML}</div>`;
          },
        },
      });

      const mainWidget = itemTypePanel(itemTypeWidget)({
        container: config.container,
        attribute: BADGES_ATTR,
        operator: 'or',
        limit: 100,
        showMore: false,
        sortBy: ['count'],
      });

      function hydrateItemTypeFromUiState(uiState) {
        if (!uiState || !uiState.oblistCreation || typeof uiState.oblistCreation !== 'object') return;
        const creation = uiState.oblistCreation;
        const mode = creation.mode;
        if (mode === 'vintage' || mode === 'mto' || mode === 'any') {
          itemTypeState.mode = mode;
        }
        itemTypeState.conditions = Array.isArray(creation.conditions)
          ? creation.conditions.map((v) => String(v).trim()).filter(Boolean)
          : [];
        itemTypeState.maxBucketId = creation.max ? String(creation.max) : 'any';
      }

      function applyItemTypeToSearchParameters(searchParameters) {
        let next = searchParameters
          .addDisjunctiveFacet(BADGES_ATTR)
          .addDisjunctiveFacet(MTOP_ATTR)
          .addDisjunctiveFacet(CONDITION_ATTR)
          .addDisjunctiveFacet(MAX_ATTR);

        try { next = next.clearRefinements(BADGES_ATTR); } catch (e) { /* ok */ }
        try { next = next.clearRefinements(MTOP_ATTR); } catch (e2) { /* ok */ }
        try { next = next.clearRefinements(CONDITION_ATTR); } catch (e3) { /* ok */ }
        try { next = next.clearRefinements(MAX_ATTR); } catch (e4) { /* ok */ }

        // Re-declare facets after clearRefinements on some algoliasearch-helper versions
        next = next
          .addDisjunctiveFacet(BADGES_ATTR)
          .addDisjunctiveFacet(MTOP_ATTR)
          .addDisjunctiveFacet(CONDITION_ATTR)
          .addDisjunctiveFacet(MAX_ATTR);

        if (itemTypeState.mode === 'vintage') {
          VINTAGE_BADGES.forEach((v) => {
            next = next.addDisjunctiveFacetRefinement(BADGES_ATTR, v);
          });
          itemTypeState.conditions.forEach((key) => {
            next = next.addDisjunctiveFacetRefinement(CONDITION_ATTR, key);
            next = next.addDisjunctiveFacetRefinement(CONDITION_ATTR, key + ' ');
          });
        } else if (itemTypeState.mode === 'mto') {
          MTO_VALUES.forEach((v) => {
            next = next.addDisjunctiveFacetRefinement(MTOP_ATTR, v);
          });
          const bucket = MAX_BUCKETS.find((b) => b.id === itemTypeState.maxBucketId);
          if (bucket && bucket.id !== 'any') {
            const weekUniverse = [1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 15, 16, 20, 24, 30];
            weeksForMaxBucket(bucket, weekUniverse).forEach((value) => {
              next = next.addDisjunctiveFacetRefinement(MAX_ATTR, value);
            });
          }
        }
        return next;
      }

      const facetRegistrarWidget = {
        $$type: 'oblist.itemTypeFacets',
        init({ helper, uiState }) {
          const indexUiState = (uiState && uiState[algoliaIndexName]) || uiState || {};
          hydrateItemTypeFromUiState(indexUiState);
          ensureDisjunctiveFacets(helper);
        },
        render() {},
        dispose() {},
        getWidgetUiState(uiState) {
          if (itemTypeState.mode === 'any') {
            if (!uiState.oblistCreation) return uiState;
            const next = { ...uiState };
            delete next.oblistCreation;
            return next;
          }
          return {
            ...uiState,
            oblistCreation: {
              mode: itemTypeState.mode,
              conditions: itemTypeState.conditions.slice(),
              max: itemTypeState.maxBucketId || 'any',
            },
          };
        },
        getWidgetSearchParameters(searchParameters, { uiState }) {
          hydrateItemTypeFromUiState(uiState);
          return applyItemTypeToSearchParameters(searchParameters);
        },
      };

      return [mainWidget, facetRegistrarWidget];
    }

    function createShippingLocationFacet(config) {
      const zonesApi = window.OblistShippingZones;
      if (!zonesApi || typeof connectRefinementList !== 'function') {
        console.warn('[Algolia] Shipping zones helper or connectRefinementList missing');
        return null;
      }

      const visitorZoneId = zonesApi.getVisitorZoneId(market_region, marketsMappingEntry);
      const orderedZoneIds = zonesApi.getOrderedZoneIds(visitorZoneId);
      const ATTRIBUTE = 'meta.custom.shipping_country';

      function escapeHtml(str) {
        return String(str || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function cleanCountryLabel(raw) {
        return String(raw || '')
          .replace(/[\[\]"']/g, '')
          .replace(/^\s*,\s*|\s*,\s*$/g, '')
          .trim();
      }

      function groupItemsByZone(items) {
        const groups = { eu: [], us: [], uk: [], other: [] };
        (items || []).forEach((item) => {
          const label = cleanCountryLabel(item.label || item.value);
          if (!label) return;
          const zoneId = zonesApi.getZoneIdForCountry(label);
          (groups[zoneId] || groups.other).push({ ...item, label, value: item.value });
        });
        Object.keys(groups).forEach((zoneId) => {
          groups[zoneId].sort((a, b) => (b.count || 0) - (a.count || 0));
        });
        return groups;
      }

      function zoneStats(countries) {
        const count = countries.reduce((sum, c) => sum + (c.count || 0), 0);
        const refinedCount = countries.filter((c) => c.isRefined).length;
        const allRefined = countries.length > 0 && refinedCount === countries.length;
        const someRefined = refinedCount > 0 && !allRefined;
        return { count, refinedCount, allRefined, someRefined };
      }

      let boundRoot = null;
      const shippingLocationWidget = connectRefinementList((renderOptions) => {
        const { items, refine, widgetParams, canRefine, instantSearchInstance } = renderOptions;
        const root = typeof widgetParams.container === 'string'
          ? document.querySelector(widgetParams.container)
          : widgetParams.container;
        if (!root) return;

        root._locationRefine = refine;
        root._locationHelper = instantSearchInstance && instantSearchInstance.helper;
        root._locationAttribute = ATTRIBUTE;
        root._locationRefineItems = items || [];

        if (!canRefine && (!items || items.length === 0)) {
          root.innerHTML = '';
          return;
        }

        const groups = groupItemsByZone(items);
        root._locationGroups = groups;
        const hasAnyRefinement = (items || []).some((item) => item.isRefined);

        const collapsedBefore = {};
        root.querySelectorAll('[data-zone-countries]').forEach((el) => {
          collapsedBefore[el.getAttribute('data-zone-countries')] = el.classList.contains('hidden');
        });

        let html = '<div class="ais-location-facet">';
        html +=
          '<label class="ais-location-everywhere' + (hasAnyRefinement ? '' : ' is-selected') + '">' +
            '<input type="radio" name="ais-location-everywhere" data-action="everywhere" ' +
              (hasAnyRefinement ? '' : 'checked ') + '/>' +
            '<span class="ais-location-label">' + escapeHtml(translateTerm('Everywhere')) + '</span>' +
          '</label>';

        orderedZoneIds.forEach((zoneId) => {
          const zone = zonesApi.getZoneById(zoneId);
          const countries = groups[zoneId] || [];
          if (!zone || countries.length === 0) return;

          const stats = zoneStats(countries);
          const isVisitor = zoneId === visitorZoneId;
          const expandedDefault = isVisitor || stats.refinedCount > 0;
          const visitorClass = isVisitor ? ' is-visitor-zone' : '';
          const refinedClass = stats.allRefined
            ? ' is-refined'
            : (stats.someRefined ? ' is-partial' : '');

          html +=
            '<div class="ais-location-zone' + visitorClass + refinedClass + '" data-zone="' + escapeHtml(zoneId) + '">' +
              '<div class="ais-location-zone-header' + (expandedDefault ? '' : ' collapsed') + '">' +
                '<button type="button" class="ais-location-zone-toggle" data-action="toggle" data-zone="' + escapeHtml(zoneId) + '" aria-expanded="' + (expandedDefault ? 'true' : 'false') + '">' +
                  '<span class="category-toggle" aria-hidden="true">' +
                    '<svg class="chevron-icon" width="12" height="12" viewBox="0 0 12 12">' +
                      '<path d="M3 4.5L6 7.5L9 4.5" fill="none" stroke="currentColor" stroke-width="1.5"/>' +
                    '</svg>' +
                  '</span>' +
                '</button>' +
                '<label class="ais-location-zone-check">' +
                  '<input type="checkbox" data-action="zone" data-zone="' + escapeHtml(zoneId) + '" ' +
                    (stats.allRefined ? 'checked ' : '') + '/>' +
                  '<strong>' + escapeHtml(translateTerm(zone.label)) + '</strong>' +
                '</label>' +
                '<span class="count">(' + stats.count + ')</span>' +
              '</div>' +
              '<div class="ais-location-zone-countries' + (expandedDefault ? '' : ' hidden') + '" data-zone-countries="' + escapeHtml(zoneId) + '">';

          countries.forEach((country) => {
            html +=
              '<label class="ais-location-country">' +
                '<input type="checkbox" data-action="country" data-value="' + escapeHtml(country.value) + '" ' +
                  (country.isRefined ? 'checked ' : '') + '/>' +
                '<span class="ais-location-label">' + escapeHtml(translateTerm(country.label)) + '</span>' +
                '<span class="count">' + (country.count || 0) + '</span>' +
              '</label>';
          });

          html += '</div></div>';
        });

        html += '</div>';
        root.innerHTML = html;

        root.querySelectorAll('[data-zone-countries]').forEach((el) => {
          const id = el.getAttribute('data-zone-countries');
          if (!Object.prototype.hasOwnProperty.call(collapsedBefore, id)) return;
          const header = el.previousElementSibling;
          const hidden = collapsedBefore[id];
          el.classList.toggle('hidden', hidden);
          if (header) {
            header.classList.toggle('collapsed', hidden);
            const btn = header.querySelector('[data-action="toggle"]');
            if (btn) btn.setAttribute('aria-expanded', hidden ? 'false' : 'true');
          }
        });

        orderedZoneIds.forEach((zoneId) => {
          const stats = zoneStats(groups[zoneId] || []);
          if (!stats.someRefined) return;
          const input = root.querySelector('input[data-action="zone"][data-zone="' + zoneId + '"]');
          if (input) input.indeterminate = true;
        });

        if (boundRoot !== root) {
          boundRoot = root;
          root.addEventListener('click', (event) => {
            const toggleBtn = event.target.closest('[data-action="toggle"]');
            if (!toggleBtn) return;
            event.preventDefault();
            const zoneId = toggleBtn.getAttribute('data-zone');
            const list = root.querySelector('[data-zone-countries="' + zoneId + '"]');
            const header = toggleBtn.closest('.ais-location-zone-header');
            if (!list || !header) return;
            const willHide = !list.classList.contains('hidden');
            list.classList.toggle('hidden', willHide);
            header.classList.toggle('collapsed', willHide);
            toggleBtn.setAttribute('aria-expanded', willHide ? 'false' : 'true');
          });

          root.addEventListener('change', (event) => {
            const input = event.target;
            if (!(input instanceof HTMLInputElement)) return;
            const refineFn = root._locationRefine;
            const helper = root._locationHelper;
            const attribute = root._locationAttribute;
            const action = input.getAttribute('data-action');

            const toggleMany = (values, shouldSelect, currentlyRefined) => {
              if (helper && attribute) {
                values.forEach((value) => {
                  const isOn = currentlyRefined.has(value);
                  if (shouldSelect && !isOn) helper.toggleFacetRefinement(attribute, value);
                  if (!shouldSelect && isOn) helper.toggleFacetRefinement(attribute, value);
                });
                helper.search();
                return;
              }
              if (typeof refineFn !== 'function') return;
              values.forEach((value) => {
                const isOn = currentlyRefined.has(value);
                if (shouldSelect !== isOn) refineFn(value);
              });
            };

            if (action === 'everywhere') {
              if (helper && attribute) {
                helper.clearRefinements(attribute).search();
                return;
              }
              const refined = (root._locationRefineItems || [])
                .filter((item) => item.isRefined)
                .map((item) => item.value);
              toggleMany(refined, false, new Set(refined));
              return;
            }

            if (action === 'zone') {
              const zoneId = input.getAttribute('data-zone');
              const countries = (root._locationGroups && root._locationGroups[zoneId]) || [];
              const shouldSelect = input.checked;
              const refinedSet = new Set(
                (root._locationRefineItems || [])
                  .filter((item) => item.isRefined)
                  .map((item) => item.value)
              );
              toggleMany(
                countries.map((c) => c.value),
                shouldSelect,
                refinedSet
              );
              return;
            }

            if (action === 'country') {
              const value = input.getAttribute('data-value');
              if (value != null && typeof refineFn === 'function') refineFn(value);
            }
          });
        }
      });

      // panel(templates)(widgetFactory)({ options })
      return shippingLocationPanel(shippingLocationWidget)({
        container: config.container,
        attribute: ATTRIBUTE,
        operator: 'or',
        limit: 100,
        showMore: false,
        sortBy: ['count:desc', 'name:asc'],
      });
    }

    function createHierarchicalFacet(config) {
      const {
        facetType,
        attribute,
        panelTitle,
        categorizer,
        categoryOrder,
        previewType = 'circle' // 'circle' for colors, 'square' for materials
      } = config;
      
      const facetPanel = panel({
        templates: {
          header() {
            const translatedTitle = translateTerm(panelTitle);
            return `<div class="ais-Panel-header-span">${translatedTitle} ${chevronHTML}</div>`;
          },
        },
        cssClasses: {
          body: " ", // Start expanded to show categories
        },
      })(refinementList);
      
      return facetPanel({
        container: config.container,
        attribute: attribute,
        limit: 100,
        showMore: true,
        showMoreLimit: 300,
        sortBy: ["count:desc", "name:asc"],
        transformItems(items) {
          // Clean and deduplicate items
          const cleanedItems = items.map(item => {
            let cleanLabel = item.label;
            cleanLabel = cleanLabel
              .replace(/[\[\]"']/g, '')
              .replace(/^\s*,\s*|\s*,\s*$/g, '')
              .trim();
            if (cleanLabel.includes(',')) {
              cleanLabel = cleanLabel.split(',')[0].trim();
            }
            return {
              ...item,
              label: cleanLabel,
              highlighted: cleanLabel
            };
          });
          
          const seen = new Map();
          const uniqueItems = [];
          cleanedItems.forEach(item => {
            const normalizedLabel = item.label.toLowerCase().trim();
            if (!seen.has(normalizedLabel)) {
              seen.set(normalizedLabel, true);
              uniqueItems.push(item);
            } else {
              const existingItem = uniqueItems.find(ui => ui.label.toLowerCase().trim() === normalizedLabel);
              if (existingItem) {
                existingItem.count += item.count;
              }
            }
          });

          // Hide dead-end options (count 0) unless already selected so the user can uncheck
          const visibleItems = uniqueItems.filter((item) => (item.count || 0) > 0 || item.isRefined);

          // Group by categories if categorizer is available
          if (categorizer && categorizer.getCategory) {
            const categoryGroups = {};
            
            visibleItems.forEach(item => {
              const category = categorizer.getCategory(item.label);
              
              if (!categoryGroups[category]) {
                categoryGroups[category] = [];
              }
              categoryGroups[category].push(item);
            });
            
            const hierarchicalItems = [];
            
            categoryOrder.forEach(categoryName => {
              if (categoryGroups[categoryName] && categoryGroups[categoryName].length > 0) {
                const categoryId = categoryName.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
                const hasRefinedItems = categoryGroups[categoryName].some(item => item.isRefined);
                
                hierarchicalItems.push({
                  label: categoryName,
                  value: `category-${categoryId}`,
                  count: categoryGroups[categoryName].reduce((sum, item) => sum + item.count, 0),
                  isCategory: true,
                  isRefined: false,
                  categoryId: categoryId,
                  hasRefinedItems: hasRefinedItems,
                  facetType: facetType
                });
                
                categoryGroups[categoryName]
                  .sort((a, b) => b.count - a.count)
                  .forEach(item => {
                    hierarchicalItems.push({
                      ...item,
                      isSubItem: true,
                      category: categoryName,
                      categoryId: categoryId,
                      facetType: facetType
                    });
                  });
              }
            });

            return hierarchicalItems;
          }
          
          return visibleItems;
        },
        templates: {
                item(item, { html, components }) {
                  // Get facetType from item data or use fallback
                  const currentFacetType = item.facetType || facetType || 'item';
                  if (item.isCategory) {
                    // Category header - NOT a refineable item
                  const categoryId = item.categoryId;
                  const facetHelper = window.hierarchicalFacetHelper;
                  
                  // Categories should be expanded by default unless explicitly collapsed
                  const categoryState = facetHelper.getCategoryState(currentFacetType, categoryId);
                  const shouldBeExpanded = categoryState !== 'collapsed' || item.hasRefinedItems;
                  const collapsedClass = shouldBeExpanded ? '' : 'collapsed';
                  
                  // Set state to expanded by default if not set yet
                  if (categoryState === 'expanded' || categoryState === undefined) {
                    facetHelper.setCategoryState(currentFacetType, categoryId, 'expanded');
                  }
                    
                    const translatedLabel = translateTerm(item.label);
                    return html`
                      <div class="ais-${currentFacetType}-category-header ${collapsedClass}" data-category="${categoryId}" data-category-name="${item.label} ">
                        <span class="category-toggle">
                          <svg class="chevron-icon" width="12" height="12" viewBox="0 0 12 12">
                            <path d="M3 4.5L6 7.5L9 4.5" fill="none" stroke="currentColor" stroke-width="1.5"/>
                          </svg>
                        </span>
                        <strong>${translatedLabel}</strong>
                        <span class="count">(${item.count})</span>
                      </div>
                    `;
                  } else {
                    // Individual color with circle preview (no changes needed)
                    const { isRefined, count, value, label } = item;
                    const colorName = label.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
                    const categoryId = item.categoryId;
                    
                    const facetHelper = window.hierarchicalFacetHelper;
                    const categoryState = facetHelper.getCategoryState(currentFacetType, categoryId);

                    // Determine visibility based on category expansion state
                    const isCategoryExpanded = categoryState !== 'collapsed'; // Show by default unless explicitly collapsed
                    const shouldBeVisible = isCategoryExpanded || isRefined;
                    const hiddenClass = shouldBeVisible ? '' : 'hidden';
                    
                    const translatedItemLabel = translateTerm(label);
                    return html`
                      <label class="ais-${currentFacetType}-item ais-${currentFacetType}-subitem ${hiddenClass}" data-category-item="${categoryId}">
                        <input 
                          class="ais-RefinementList-checkbox" 
                          type="checkbox" 
                          value="${value}" 
                          checked="${isRefined ? 'checked' : ''}"
                          onchange="this.closest('label').classList.toggle('selected', this.checked)"
                        />
                        <span class="color-name">${translatedItemLabel}</span>
                        <span class="color-count">${count}</span>
                      </label>
                    `;
                  }
                }
              },
        rendered() {
          setTimeout(() => {
            const facetHelper = window.hierarchicalFacetHelper;
            const currentFacetType = facetType || config.facetType || 'item';
            facetHelper.cleanupDuplicateCategories(currentFacetType);
            facetHelper.setupCategoryHandlers(currentFacetType);
            
            // Ensure all categories start expanded by showing their items
            const categoryHeaders = document.querySelectorAll(`.ais-${currentFacetType}-category-header:not(.collapsed)`);
            categoryHeaders.forEach(header => {
              const categoryId = header.getAttribute('data-category');
              if (categoryId) {
                const categoryItems = document.querySelectorAll(`.ais-${currentFacetType}-subitem[data-category-item="${categoryId}"]`);
                categoryItems.forEach(item => {
                  item.classList.remove('hidden');
                });
              }
            });
          }, 50);
        }
      });
    }

    // Facettes montées en statique AVANT start() — évite le 2e cycle de
    // dynamicWidgets. Ordre = facetOrdering Algolia (dashboard), pas l'ordre
    // du tableau widgets historique.
    const facetsRoot = document.querySelector('#ais-facets');
    const makeFacetContainer = () => {
      const el = document.createElement('div');
      if (facetsRoot) facetsRoot.appendChild(el);
      return el;
    };

    // Containers créés dans l'ordre d'affichage (DOM = ordre visuel des panels)
    const priceFacetContainer = makeFacetContainer();
    priceFacetContainer.dataset.oblistQuickFacet = 'price';
    const locationFacetContainer = makeFacetContainer();
    const deliveryFacetContainer = makeFacetContainer();
    const itemTypeFacetContainer = makeFacetContainer();
    itemTypeFacetContainer.dataset.oblistQuickFacet = 'creation';
    const inStockFacetContainer = makeFacetContainer();
    const productTypeFacetContainer = makeFacetContainer();
    productTypeFacetContainer.dataset.oblistQuickFacet = 'product_type';
    const locationFacetWidget = createShippingLocationFacet({
      container: locationFacetContainer,
    });
    const deliveryFacetWidget = createDeliveryOptionsFacet({
      container: deliveryFacetContainer,
    });
    const itemTypeFacetWidget = createItemTypeFacet({
      container: itemTypeFacetContainer,
    });

    instant.search.addWidgets([
      // 1. Price — attribute matches displayed currency (URL + quick sheet)
      pricePanel({
        container: priceFacetContainer,
        attribute: getOblistPriceAttribute(),
        min: 0,
        max: 100000,
      }),

      // 2. Item location (juste sous le prix)
      ...(locationFacetWidget ? [locationFacetWidget] : []),

      // 3. Delivery options (min delivery weeks → day buckets)
      ...(deliveryFacetWidget ? [deliveryFacetWidget] : []),

      // 4. Item type — All / Vintage (badge) / Made to order (mtop) + condition nested
      ...(itemTypeFacetWidget || []),

      // 5. In stock only = inventory_quantity > 0 (not inventory_available)
      createInStockQuantityToggle({
        container: inStockFacetContainer,
      }),

      // 6. Product Type
      productTypePanel({
        container: productTypeFacetContainer,
        attribute: "product_type",
        // value reste EN (filtre Algolia) ; seuls label/highlighted sont traduits.
        transformItems(items) {
          return items
            .filter((item) => (item.count || 0) > 0 || item.isRefined)
            .map((item) => {
              const clean = String(item.label || '').replace(/[\[\]"']/g, '').trim();
              const translated = translateTerm(clean);
              return {
                ...item,
                value: item.value,
                label: translated,
                highlighted: translated,
              };
            });
        },
      }),

      // 7. Colour
      createHierarchicalFacet({
        container: makeFacetContainer(),
        facetType: 'color',
        attribute: 'meta.custom.color',
        panelTitle: 'Colour',
        categorizer: window.colorCategorizer || null,
        categoryOrder: [
          'Neutrals', 'Browns', 'Reds & Oranges', 'Yellows & Golds',
          'Greens', 'Blues', 'Purples & Violets', 'Metallics',
          'Stones & Neutrals Extended', 'Special Finishes', 'Other'
        ],
        previewType: 'circle'
      }),

      // 8. Materials
      createHierarchicalFacet({
        container: makeFacetContainer(),
        facetType: 'material',
        attribute: 'meta.custom.materials',
        panelTitle: 'Materials',
        categorizer: window.materialCategorizer || null,
        categoryOrder: [
          'Wood and Derivatives', 'Metals', 'Stone and Minerals', 'Glass and Derivatives',
          'Ceramics and Clays', 'Textiles and Natural Fibers', 'Synthetic and Technical Fibers',
          'Leathers and Skins', 'Plastics and Composites', 'Natural Other',
          'Modern and Miscellaneous Materials', 'Precious Stones and Gems', 'Other'
        ],
        previewType: 'square'
      }),

      // 9. Style
      createHierarchicalFacet({
        container: makeFacetContainer(),
        facetType: 'style',
        attribute: 'meta.custom.style_period',
        panelTitle: 'Style',
        categorizer: window.styleCategorizer || null,
        categoryOrder: [
          '19th Century Styles',
          'Early 20th Century Movements',
          'Mid-20th Century',
          'Late 20th Century',
          'Contemporary & Transitional',
          'Asian & Nature Inspired',
          'Revival & Eclectic Styles',
          '21st Century & Emerging',
          'Other'
        ],
        previewType: 'text'
      }),
      // Vintage condition is nested under Item type → Antique and vintage
      // (meta.vintageconditionreport.vintagecr) — not a standalone panel.

      instantsearch.widgets.hits({
        container: "#ais-hits",
        transformItems(items, {results}) {
          const collection_items_count = document.querySelector('.count_products_slider_collection');
          if(collection_items_count)
            collection_items_count.innerHTML = `${results.nbHits || 0} ${current_locale === 'fr' ? 'PRODUITS' : 'PRODUCTS'}`;

          if (collectionPageEnabled && items.length > 0 && !window.__jsonLdInjected) {
            window.__jsonLdInjected = true;
            try {
              const collectionTitle = collection_title || document.title;
              const collectionUrl = window.location.origin + window.location.pathname;
              const currency = items[0]?.currency || 'EUR';
              // SEO: numeric price only (never "From …"). Prefer variants_min when present.
              // Use isFinite (not Number.isFinite) for older WebViews; avoid optional chaining here.
              const seoPriceOf = function (h) {
                if (!h) return 0;
                const min = h.variants_min_price != null ? Number(h.variants_min_price) : NaN;
                if (isFinite(min) && min > 0) return min;
                const p = h.price != null ? Number(h.price) : NaN;
                return isFinite(p) && p > 0 ? p : 0;
              };
              const prices = items.map(seoPriceOf).filter(function (p) { return p > 0; });
              let lowPrice = 0;
              let highPrice = 0;
              if (prices.length) {
                lowPrice = Math.min.apply(null, prices);
                highPrice = Math.max.apply(null, items.map(function (h) {
                  const max = h && h.variants_max_price != null ? Number(h.variants_max_price) : NaN;
                  if (isFinite(max) && max > 0) return max;
                  return seoPriceOf(h);
                }));
              }
              const totalHits = results.nbHits || items.length;

              const itemListElements = items.slice(0, 40).map((hit, i) => {
                const localizedHit = algolia?.helpers?.localizeHitData ? algolia.helpers.localizeHitData(hit) : hit;
                const productUrl = window.location.origin + '/products/' + (localizedHit.handle || '');
                const imageUrl = localizedHit.image || localizedHit.featured_image || '';
                const price = seoPriceOf(localizedHit);
                return {
                  "@type": "ListItem",
                  "position": i + 1,
                  "item": {
                    "@type": "Product",
                    "name": localizedHit.title || '',
                    "url": productUrl,
                    "image": imageUrl,
                    "offers": {
                      "@type": "Offer",
                      "price": price,
                      "priceCurrency": currency,
                      "availability": localizedHit.inventory_available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock"
                    }
                  }
                };
              });

              const collectionSchema = {
                "@context": "https://schema.org",
                "@type": "CollectionPage",
                "name": collectionTitle,
                "url": collectionUrl,
                "offers": {
                  "@type": "AggregateOffer",
                  "lowPrice": lowPrice.toString(),
                  "highPrice": highPrice.toString(),
                  "priceCurrency": currency,
                  "offerCount": totalHits
                }
              };

              const itemListSchema = {
                "@context": "https://schema.org",
                "@type": "ItemList",
                "numberOfItems": Math.min(totalHits, 40),
                "itemListElement": itemListElements
              };

              const injectSchema = (schema) => {
                const script = document.createElement('script');
                script.type = 'application/ld+json';
                script.textContent = JSON.stringify(schema);
                document.head.appendChild(script);
              };
              injectSchema(collectionSchema);
              injectSchema(itemListSchema);
            } catch (e) {
              console.error('[Schema] Error injecting collection JSON-LD:', e);
            }
          }

          return items;
        },
        templates: {
          item(hit, { html, components, sendEvent }) {
            hit = algolia?.helpers?.localizeHitData ? algolia.helpers.localizeHitData(hit) : hit;
            return algolia.instantSearchProductTemplate(hit, html, components, sendEvent);
          },
          showMoreText(data, { html }) {
            return html`<span>Show more products</span>`;
          },
          // Template pour "0 résultats" - Enhanced UX (uniquement sur /search)
          empty(results, { html }) {
            const isEnglish = current_locale === 'en';
            const isSearchPage = window.location.pathname.includes('/search');
            
            // Collection / listing: fallback actionable when filters yield 0 hits
            if (!isSearchPage) {
              const title = isEnglish
                ? "No products match these filters"
                : "Aucun produit ne correspond à ces filtres";
              const subtitle = isEnglish
                ? "Try removing some filters to see more pieces."
                : "Essayez de retirer certains filtres pour voir plus de pièces.";
              const clearLabel = isEnglish ? "Clear all filters" : "Effacer tous les filtres";
              return html`
                <div class="ais-no-results-simple ais-no-results-simple--fallback">
                  <p class="ais-no-results-simple__title">${title}</p>
                  <p class="ais-no-results-simple__subtitle">${subtitle}</p>
                  <button type="button" class="ais-no-results-simple__clear" data-oblist-clear-filters>
                    ${clearLabel}
                  </button>
                </div>
              `;
            }
            
            // Textes traduits (uniquement pour la page /search)
            const texts = {
              title: isEnglish ? "We couldn't find what you're looking for" : "Nous n'avons pas trouvé ce que vous cherchez",
              subtitle: isEnglish ? "But here's what our community is loving right now" : "Mais voici ce que notre communauté adore en ce moment",
              trendingTitle: isEnglish ? "Popular Searches" : "Recherches populaires",
              trendingProductsTitle: isEnglish ? "Trending Now" : "Tendances du moment",
              categoriesTitle: isEnglish ? "Explore Categories" : "Explorer les catégories",
              helpTitle: isEnglish ? "Can't find what you're looking for?" : "Vous ne trouvez pas ce que vous cherchez ?",
              helpText: isEnglish ? "Our team can help you source unique pieces." : "Notre équipe peut vous aider à trouver des pièces uniques.",
              helpButton: isEnglish ? "Contact Our Curators" : "Contacter nos curateurs",
              loading: isEnglish ? "Loading..." : "Chargement..."
            };

            // Charger le contenu dynamique après le rendu
            setTimeout(() => {
              loadNoResultsContent(isEnglish);
            }, 100);

            return html`
              <div class="ais-no-results">
                <div class="ais-no-results__header">
                  <h2 class="ais-no-results__title">${texts.title}</h2>
                  <p class="ais-no-results__subtitle">${texts.subtitle}</p>
                  <div id="no-results-did-you-mean" class="ais-no-results__did-you-mean"></div>
                </div>
                
                <div class="ais-no-results__section">
                  <div class="ais-no-results__section-header">
                    <span class="ais-no-results__section-title">${texts.trendingTitle}</span>
                    <div class="ais-no-results__section-line"></div>
                  </div>
                  <div id="no-results-trending-searches" class="ais-no-results__trending-searches">
                    <div class="ais-no-results__loading">${texts.loading}</div>
                  </div>
                </div>
                
                <div class="ais-no-results__section">
                  <div class="ais-no-results__section-header">
                    <span class="ais-no-results__section-title">${texts.trendingProductsTitle}</span>
                    <div class="ais-no-results__section-line"></div>
                  </div>
                  <div id="no-results-trending-products" class="ais-no-results__products-grid">
                    <div class="ais-no-results__loading">${texts.loading}</div>
                  </div>
                </div>
                
                <div class="ais-no-results__section">
                  <div class="ais-no-results__section-header">
                    <span class="ais-no-results__section-title">${texts.categoriesTitle}</span>
                    <div class="ais-no-results__section-line"></div>
                  </div>
                  <div id="no-results-categories" class="ais-no-results__categories"></div>
                </div>
                
                <div class="ais-no-results__help">
                  <h3 class="ais-no-results__help-title">${texts.helpTitle}</h3>
                  <p class="ais-no-results__help-text">${texts.helpText}</p>
                  <a href="/pages/curation-service" class="ais-no-results__help-button">${texts.helpButton}</a>
                </div>
              </div>
            `;
          },
        },
      }),

    
      instantsearch.widgets.pagination({
        container: ".algolia-pagination-container",
        padding: 2,
        showFirst: false,
        showLast: false,
        showPrevious: true,
        showNext: true,
        templates: {
          previous: "&#8592 Previous page",
          next: "Load more products",
        },
      }),
       
      instantsearch.widgets.configure(
        collection_handle == "search" ? (function () {
          const cfg = buildTextSearchConfigure(customQuery, statedPage, { omitPage: true });
          if (frSearchResolved.query !== customQuery || frSearchResolved.extraFilters) {
            console.warn('[Algolia FR search]', customQuery, '→', frSearchResolved);
          }
          return cfg;
        })() : (
          collection_product_types.length ? {
            // Collection "type" : filtre par product_type EXACT (requête vide) -> PAS de
            // recherche neural, donc aucun intrus sémantique (ex. bowl dans "mirrors").
            // Le programme featured s'applique par appartenance de type (boost premium,
            // items pertinents par construction).
            filters: '(' + collection_product_types.map(function (t) {
              return 'product_type:"' + String(t).replace(/"/g, '') + '"';
            }).join(' OR ') + ')',
            hitsPerPage: 40,
            analytics: true,
            clickAnalytics: true,
            analyticsTags: ['collection:' + collection_title],
            maxValuesPerFacet: 100,
            optionalFilters: ['inventory_available:true<score=10000>', 'meta.custom.soldout:false<score=10000>'],
          }
          : collection_meta_enabled ?
          buildTextSearchConfigure(collection_meta_keyword, statedPage, { omitPage: true })
          : {
            // Collection browse filter.
            // IMPORTANT : filtre PRINCIPAL = collection_ids PROPRE (sans OR). Les Query
            // Rules de merchandising (pins, re-ranking) sont conditionnées sur
            // collection_ids et NE se déclenchent PAS si le filtre est une expression OR.
            // Le handle est mémorisé comme FALLBACK, utilisé uniquement si collection_ids
            // renvoie 0 hit (ex. gifts, où une rule vide l'id) via
            // wrapSearchClientCollectionFallback. -> merchandising respecté partout,
            // gifts toujours peuplé, et zéro impact sur les collections normales.
            filters: (function () {
              if (!collectionPageEnabled) { window.__OBLIST_COLL_FALLBACK__ = ''; return ''; }
              const clean = (v) => String(v || '').replace(/"/g, '').trim();
              const id = clean(collection_id);
              const metaHandle = clean(collection_handle);
              const shopHandle = clean(
                window.__OBLIST_COLLECTION__ && window.__OBLIST_COLLECTION__.handle
              );
              const handleParts = [];
              if (metaHandle) handleParts.push(`collections:"${metaHandle}"`);
              if (shopHandle && shopHandle !== metaHandle) handleParts.push(`collections:"${shopHandle}"`);
              const handleFilter = !handleParts.length ? ''
                : (handleParts.length === 1 ? handleParts[0] : `(${handleParts.join(' OR ')})`);
              // Fallback handle mémorisé UNIQUEMENT si on part sur l'id (sinon inutile).
              window.__OBLIST_COLL_FALLBACK__ = id ? handleFilter : '';
              return id ? `collection_ids:${id}` : handleFilter;
            })(),
            hitsPerPage: 40,
            analytics: true,  // Activé pour comptabiliser les vues dans Analytics
            clickAnalytics: true,  // Nécessaire pour avoir un queryID et tracker les clicks
            analyticsTags: [`collection:${collection_title}`],  // Titre lisible pour les analytics
            maxValuesPerFacet: 100,
            // Boost les produits en stock pour qu'ils apparaissent en premier
            optionalFilters: ['inventory_available:true<score=10000>', 'meta.custom.soldout:false<score=10000>'],
          })
      ),
    ]);

    /**
     * Sort by — one InstantSearch widget, two UIs:
     * - desktop search: native <select> in #aisSortByDefault
     * - mobile filter sheet: radio list in #ais-mobile-sort-by
     */
    function createOblistSortByWidget() {
      const items = (instant.sortOrders && instant.sortOrders.length)
        ? instant.sortOrders
        : activeSortOrders;
      if (!items || items.length < 2) return null;

      function escapeHtml(str) {
        return String(str || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      function syncDesktopSelect(options, currentRefinement, refine) {
        const desktopRoot = document.getElementById('aisSortByDefault');
        if (!desktopRoot) return;
        desktopRoot.classList.add('customSortBy');
        let select = desktopRoot.querySelector('select.customSortBySelect');
        if (!select) {
          select = document.createElement('select');
          select.className = 'customSortBySelect customSortBySelect--subclass';
          desktopRoot.appendChild(select);
          select.addEventListener('change', () => refine(select.value));
        }
        const nextHtml = (options || []).map((opt) => {
          const selected = opt.value === currentRefinement ? ' selected' : '';
          return `<option value="${escapeHtml(opt.value)}"${selected}>${escapeHtml(opt.label)}</option>`;
        }).join('');
        if (select.dataset.oblistOptionsHtml !== nextHtml) {
          select.dataset.oblistOptionsHtml = nextHtml;
          select.innerHTML = nextHtml;
        }
        if (select.value !== currentRefinement) {
          select.value = currentRefinement;
        }
      }

      function syncMobileRadios(options, currentRefinement, refine) {
        const mobileRoot = document.getElementById('ais-mobile-sort-by');
        if (!mobileRoot) return;

        if (!mobileRoot.dataset.oblistSortMounted) {
          mobileRoot.dataset.oblistSortMounted = '1';
          const sortTitle = translateTerm('Sort by');
          mobileRoot.innerHTML =
            '<div class="ais-Panel ais-sort-facet-panel">' +
              '<div class="ais-Panel-header">' +
                `<div class="ais-Panel-header-span">${escapeHtml(sortTitle)} ${chevronHTML}</div>` +
              '</div>' +
              '<div class="ais-Panel-body">' +
                '<div class="ais-sort-facet ais-delivery-facet" data-oblist-sort-options></div>' +
              '</div>' +
            '</div>';
          mobileRoot.addEventListener('change', (event) => {
            const input = event.target;
            if (!(input instanceof HTMLInputElement) || input.name !== 'ais-mobile-sort-by') return;
            refine(input.value);
          });
        }

        const optionsRoot = mobileRoot.querySelector('[data-oblist-sort-options]');
        if (!optionsRoot) return;

        let html = '';
        (options || []).forEach((opt) => {
          const checked = opt.value === currentRefinement;
          html +=
            '<label class="ais-delivery-option' + (checked ? ' is-selected' : '') + '">' +
              '<input type="radio" name="ais-mobile-sort-by" value="' + escapeHtml(opt.value) + '" ' +
                (checked ? 'checked ' : '') + '/>' +
              '<span class="ais-delivery-label">' + escapeHtml(opt.label) + '</span>' +
            '</label>';
        });
        optionsRoot.innerHTML = html;
      }

      if (typeof connectSortBy === 'function') {
        return connectSortBy((renderOptions) => {
          const { options, currentRefinement, refine } = renderOptions;
          syncDesktopSelect(options, currentRefinement, refine);
          syncMobileRadios(options, currentRefinement, refine);
        })({ items });
      }

      // Fallback without connector: drive index via helper + paint both UIs
      return {
        $$type: 'oblist.sortBy',
        init() {},
        render({ helper }) {
          if (!helper) return;
          const currentRefinement = helper.state.index;
          const refine = (value) => {
            if (!value || value === helper.state.index) return;
            helper.setIndex(value).search();
          };
          const options = items.map((item) => ({
            label: item.label,
            value: item.value,
            isRefined: item.value === currentRefinement,
          }));
          syncDesktopSelect(options, currentRefinement, refine);
          syncMobileRadios(options, currentRefinement, refine);
        },
        dispose() {},
      };
    }

    // Sort by: desktop select (search) + mobile radios inside filter sheet
    if (activeSortOrders.length > 1) {
      const sortByWidget = createOblistSortByWidget();
      if (sortByWidget) {
        instant.search.addWidgets([sortByWidget]);
      }
    }
    var aisStats = document.querySelector('#aisStats');
    if(aisStats) {
      instant.search.addWidgets([
        instantsearch.widgets.stats({
              container: '#aisStats',
              cssClasses: {
                // Do not use theme `.section` / `.h2` — at ≥1400px --text-h2 jumps to ~3rem
                // and section spacing inflates. Dedicated classes keep the title compact.
                root: 'ais-stats-root',
                text: 'ais-stats__text',
              },
              templates: {
                text(data, { html }) {
                  // Toujours afficher le terme saisi (URL), pas data.query qui peut être
                  // vide quand resolveFrSearchParams réécrit la requête Algolia.
                  const displayQuery = customQuery || data.query || '';
                  const quotedTerms = displayQuery ? `"${displayQuery}"` : '';
                  const applyTerms = (template) => template
                    .replace('{{ count }}', data.nbHits)
                    .replace('"{{ terms }}"', quotedTerms)
                    .replace('&quot;{{ terms }}&quot;', quotedTerms)
                    .replace('{{ terms }}', displayQuery);

                  let text = '';
                  if (data.hasManyResults) {
                    text += applyTerms(window.translations.search.results_count?.other || '');
                    document.title = text;
                  } else if (data.hasOneResult) {
                    text += applyTerms(window.translations.search.results_count?.one || '');
                  } else {
                    text += applyTerms(window.translations.search.results_count?.zero || '');
                  }

                  return html`<p class="ais-stats__title">${text}</p>`;
                },
              },
          }),
      ]);
    }

    // Sold-out poussés en fin : uniquement collections SEO (keyword).
    // Collections normales = merchandisées (pins) → on laisse les rules intactes.
    if (collection_handle !== 'search' && collection_meta_enabled) {
      wrapSearchClientStockLast(instant.search.client, algoliaIndexName);
    }

    // Programme "Featured" : plafonds anti-monopolisation (search + collections).
    // Installé en couche EXTERNE (après stock-last) : sur les collections SEO il
    // consomme la séquence déjà ordonnée in-stock-first. Gate par index (UAE en).
    wrapSearchClientFeaturedCaps(instant.search.client, algoliaIndexName);

    // Fallback collection (couche la plus externe) : retente en handle si collection_ids
    // renvoie 0 (ex. gifts). Pass-through sinon -> n'affecte ni featured ni le reste.
    if (collection_handle !== 'search') {
      wrapSearchClientCollectionFallback(instant.search.client, algoliaIndexName);
    }

    // Query déjà fournie par le widget configure + routing (param q).
    // setUiState post-start redéclenchait un 2e POST principal au chargement.
    instant.search.start();
    if (window.OblistCollectionReturn) {
      window.OblistCollectionReturn.bindSearch(instant.search);
    }

    const syncMobileFiltersFooterFromResults = () => {
      const nbHits = instant.search.helper?.lastResults?.nbHits;
      if (nbHits == null) return;
      updateMobileFiltersResultsCount(nbHits);
    };
    instant.search.on('render', () => {
      oblistListingRouterReady = true;
      syncMobileFiltersFooterFromResults();
    });
    syncMobileFiltersFooterFromResults();
    initOblistQuickFilters();
    initOblistCollectionFiltersEntry();

    // Collection empty-state CTA + mobile sheet "Clear all"
    if (!document.documentElement.dataset.oblistClearFiltersBound) {
      document.documentElement.dataset.oblistClearFiltersBound = '1';
      document.addEventListener('click', (event) => {
        const btn = event.target && event.target.closest
          ? event.target.closest('[data-oblist-clear-filters]')
          : null;
        if (!btn) return;
        event.preventDefault();
        const helper = instant.search && instant.search.helper;
        if (!helper) return;
        if (window.__oblistInStockQuantity && typeof window.__oblistInStockQuantity.clearAndApply === 'function') {
          window.__oblistInStockQuantity.clearAndApply(helper);
        }
        if (window.__oblistItemTypeExclusive && typeof window.__oblistItemTypeExclusive.resetAll === 'function') {
          window.__oblistItemTypeExclusive.resetAll(helper);
        }
        helper.clearRefinements();
        helper.setPage(0);
        helper.search();
      });
    }

    instant.search.on('error', ({ error }) => {
      console.log('instant error', error);
    });

    let algoliaPageContentReady = false;
    let algoliaHitsPaginating = false;
    let algoliaHitsPaginatingTimeout = null;

    function setHitsPaginating(active) {
      const hitsEl = document.querySelector('#ais-hits');
      if (!hitsEl) return;

      if (active && !algoliaHitsPaginating) {
        hitsEl.style.minHeight = `${Math.max(hitsEl.offsetHeight, 320)}px`;
      } else if (!active) {
        hitsEl.style.minHeight = '';
      }

      algoliaHitsPaginating = active;
      hitsEl.classList.toggle('ais-hits--paginating', active);
    }

    function beginHitsPaginationTransition() {
      if (!algoliaPageContentReady) return;
      setHitsPaginating(true);
      if (algoliaHitsPaginatingTimeout) clearTimeout(algoliaHitsPaginatingTimeout);
      algoliaHitsPaginatingTimeout = setTimeout(() => setHitsPaginating(false), 10000);
    }

    function isAlgoliaHitsReady() {
      const status = instant.search.status;
      if (status === 'loading' || status === 'stalled') return false;

      const results = instant.search.helper?.lastResults;
      if (!results || results.__isArtificial) return false;

      const hitsEl = document.querySelector('#ais-hits');
      if (!hitsEl) return false;

      const hitItems = hitsEl.querySelectorAll('.ais-Hits-item, .ais-Hits-list > li, product-card');
      if (hitItems.length > 0) return true;

      if (hitsEl.querySelector('.ais-Hits--empty, .ais-no-results-simple, .ais-no-results')) {
        return true;
      }

      return results.nbHits === 0 && hitsEl.textContent.trim().length > 0;
    }

    function revealAlgoliaPageContent() {
      if (algoliaPageContentReady) return;
      algoliaPageContentReady = true;

      const section = document.querySelector('.shopify-section--main-collection');
      section?.classList.remove('collection-algolia--loading');
      section?.classList.add('collection-algolia--ready');

      const collectionDiv = document.querySelector('.shopify-section--main-collection .container');
      if (collectionDiv) {
        collectionDiv.style.minHeight = 'auto';
      }

      const loadingIndicator = document.querySelector('.loading-state');
      if (loadingIndicator) loadingIndicator.style.display = 'none';

      if (window.OblistCollectionReturn) window.OblistCollectionReturn.restoreAfterHits();

      // Sync Storefront prices now that hits are rendered
      if (window.ShopifyPriceSync) window.ShopifyPriceSync.syncVisible();
    }

    function tryRevealAlgoliaPageContent() {
      if (algoliaPageContentReady) return;
      if (!isAlgoliaHitsReady()) return;
      requestAnimationFrame(() => revealAlgoliaPageContent());
    }

    setTimeout(() => {
      if (!algoliaPageContentReady) {
        console.warn('[Algolia] loading timeout — revealing collection content');
        revealAlgoliaPageContent();
      }
    }, 8000);

    let lastKnownAlgoliaPage = null;
    instant.search.helper.on('change', () => {
      if (!algoliaPageContentReady) return;
      const page = instant.search.helper?.getPage?.() ?? 0;
      if (lastKnownAlgoliaPage !== null && page !== lastKnownAlgoliaPage) {
        beginHitsPaginationTransition();
      }
      lastKnownAlgoliaPage = page;
    });

    document.querySelector('.algolia-pagination-container')?.addEventListener('click', (event) => {
      if (event.target.closest('.ais-Pagination-item a')) {
        beginHitsPaginationTransition();
      }
    });

    instant.search.on('render', () => {
      syncFacetPanelChevrons();
      performAfterSearchActivity();
      // Did you mean + related searches + material chips : 1 POST multi-queries
      runAuxiliarySearches();
      syncMaterialRefinementTagActiveState();
      tryRevealAlgoliaPageContent();

      // Sync prices from Shopify Storefront API (only after initial reveal)
      if (window.ShopifyPriceSync && algoliaPageContentReady) {
        window.ShopifyPriceSync.debouncedSync();
      }

      if (algoliaPageContentReady && algoliaHitsPaginating && isAlgoliaHitsReady()) {
        if (algoliaHitsPaginatingTimeout) {
          clearTimeout(algoliaHitsPaginatingTimeout);
          algoliaHitsPaginatingTimeout = null;
        }
        requestAnimationFrame(() => setHitsPaginating(false));
      }
    });
    
    // Mots outils EN/FR : ne jamais "corriger" (évite en→des, de→des, etc.)
    const DID_YOU_MEAN_STOPWORDS = new Set([
      'a', 'an', 'the', 'and', 'or', 'of', 'for', 'to', 'in', 'on', 'at', 'by', 'with',
      'un', 'une', 'le', 'la', 'les', 'de', 'des', 'du', 'au', 'aux', 'et', 'ou', 'en',
      'dans', 'sur', 'sous', 'par', 'pour', 'avec', 'sans', 'chez', 'vers', 'entre',
      'd', 'l', 'y', 'a',
    ]);

    // Fonction pour vérifier si c'est une typo probable
    function isLikelyTypo(query, suggestion) {
      const q = query.toLowerCase().trim();
      const s = suggestion.toLowerCase().trim();
      
      // Si identiques, pas une typo
      if (q === s) return false;

      // Trop court / mot-outil → jamais une typo fiable
      if (q.length < 4 || s.length < 4) return false;
      if (DID_YOU_MEAN_STOPWORDS.has(q) || DID_YOU_MEAN_STOPWORDS.has(s)) return false;
      
      // Si la suggestion contient la query et que la différence est > 2 chars, c'est un mot partiel pas une typo
      // Ex: "table" dans "coffee table" = mot partiel, mais "213" dans "213a" = typo (1 char de diff)
      const lengthDiff = Math.abs(q.length - s.length);
      if ((s.includes(q) || q.includes(s)) && lengthDiff > 2) return false;
      
      // Rejeter si la suggestion est juste le mot + 1 lettre à la fin (trivial)
      // Ex: "metal" → "metall" = rejeté (pas une vraie typo)
      if (s.startsWith(q) && lengthDiff === 1) return false;
      if (q.startsWith(s) && lengthDiff === 1) return false;
      
      // Calculer la distance de Levenshtein
      function levenshtein(a, b) {
        const matrix = [];
        for (let i = 0; i <= b.length; i++) matrix[i] = [i];
        for (let j = 0; j <= a.length; j++) matrix[0][j] = j;
        for (let i = 1; i <= b.length; i++) {
          for (let j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
              matrix[i][j] = matrix[i - 1][j - 1];
            } else {
              matrix[i][j] = Math.min(
                matrix[i - 1][j - 1] + 1,
                matrix[i][j - 1] + 1,
                matrix[i - 1][j] + 1
              );
            }
          }
        }
        return matrix[b.length][a.length];
      }
      
      const distance = levenshtein(q, s);
      const minLen = Math.min(q.length, s.length);
      
      // Compter les caractères communs (même position ou décalés)
      let commonChars = 0;
      const qChars = q.split('');
      const sChars = s.split('');
      for (const c of qChars) {
        const idx = sChars.indexOf(c);
        if (idx !== -1) {
          commonChars++;
          sChars.splice(idx, 1); // Retirer le char pour ne pas le compter deux fois
        }
      }
      
      // Ratio de caractères communs
      const commonRatio = commonChars / minLen;
      
      // Premier caractère identique = bonus fort (probable typo)
      const sameFirstChar = q[0] === s[0];
      
      // Seuils resserrés : mots 4-5 → dist 1 ; 6-8 → 2 ; plus longs → 3
      let maxDistance;
      if (minLen <= 5) maxDistance = 1;
      else if (minLen <= 8) maxDistance = 2;
      else maxDistance = 3;
      
      const isDistanceOk = distance <= maxDistance && distance > 0 && sameFirstChar;
      const isCommonCharsOk = commonRatio >= 0.8 && sameFirstChar && distance <= maxDistance + 1;
      
      return isDistanceOk || isCommonCharsOk;
    }

    // Guards partagés pour les recherches annexes (1 POST multi-queries / query)
    let lastCheckedQuery = '';
    let lastCheckedMaterialQuery = '';
    let relatedSearchesLoaded = false;
    let auxiliarySearchesInFlight = false;
    
    // Cache pour les catégories de matériaux
    let materialCategoriesCache = null;
  // Fallback embarqué pour éviter les erreurs 404/403 en prod
  const materialCategoriesFallback = {
    "Wood and Derivatives": [
      "Wood","Oak","Walnut","Mahogany","Maple","Teak","Pine","Birch","Rosewood","Ebony","Ash","Cherry","Beech","Poplar","Cedar","Douglas Fir","Spruce","Sycamore","Elm","Willow","Bamboo","Veneer","Plywood","MDF","Particle Board","Chipboard","Cork","Driftwood","Engineered Wood"
    ],
    "Metals": [
      "Metal","Steel","Stainless Steel","Brass","Bronze","Copper","Aluminium","Iron","Cast Iron","Wrought Iron","Nickel","Chrome","Titanium","Zinc","Pewter","Lead","Gold","Silver","Platinum","Tin"
    ],
    "Stone and Minerals": [
      "Stone","Marble","Travertine","Limestone","Granite","Quartz","Quartzite","Onyx","Jade","Slate","Soapstone","Sandstone","Terrazzo","Concrete","Polished Concrete","Cement","Lava Stone","Basalt","Alabaster","Malachite","Agate"
    ],
    "Glass and Derivatives": [
      "Glass","Clear Glass","Frosted Glass","Stained Glass","Etched Glass","Murano Glass","Colored Glass","Tempered Glass","Laminated Glass","Recycled Glass","Crystal","Lead Crystal","Acrylic Glass (Plexiglass)"
    ],
    "Ceramics and Clays": [
      "Ceramic","Porcelain","Stoneware","Earthenware","Terracotta","Clay","Bone China","Raku","Glazed Ceramic","Majolica","Faience","Tile"
    ],
    "Textiles and Natural Fibers": [
      "Textile","Cotton","Organic Cotton","Linen","Wool","Merino Wool","Silk","Hemp","Jute","Cashmere","Mohair","Alpaca","Camel Hair","Raffia","Rattan","Seagrass","Sisal","Abaca","Kapok","Coir","Canvas","Velvet","Chenille","Bouclé","Tweed","Denim"
    ],
    "Synthetic and Technical Fibers": [
      "Synthetic Fiber","Polyester","Recycled Polyester","Nylon","Acrylic","Microfiber","Rayon","Viscose","Spandex","Elastane","Polypropylene","Polyurethane","PVC Fabric","PU Leather","Faux Leather","Faux Fur","Neoprene","Olefin"
    ],
    "Leathers and Skins": [
      "Leather","Full-Grain Leather","Top-Grain Leather","Bonded Leather","Split Leather","Suede","Nubuck","Patent Leather","Shearling","Cowhide","Goatskin","Lambskin","Pigskin","Buffalo Leather","Crocodile Leather","Ostrich Leather","Snake Leather"
    ],
    "Plastics and Composites": [
      "Plastic","Resin","Epoxy","Polycarbonate","Polyethylene","Polypropylene","PVC","Fiberglass","Carbon Fiber","Lucite","Bakelite","ABS","Acrylic","Bioplastic","Recycled Plastic","3D Printed Polymer","Melamine"
    ],
    "Natural Other": [
      "Natural Material","Mother of Pearl","Shell","Horn","Bone","Ivory (antique only)","Coral","Amber","Pearl","Straw","Feathers","Down","Wicker","Cane","Natural Rubber","Latex"
    ],
    "Modern and Miscellaneous Materials": [
      "Modern Material","Rubber","Silicone","Neoprene","Foam","Memory Foam","High-Density Foam","Paper","Cardboard","Laminates","Laminate Flooring","Composite Wood","Recycled Materials","Biodegradable Polymer"
    ],
    "Precious Stones and Gems": [
      "Gemstone","Diamond","Emerald","Ruby","Sapphire","Amethyst","Topaz","Tourmaline","Citrine","Aquamarine","Garnet","Spinel","Opal","Moonstone","Turquoise","Peridot","Lapis Lazuli","Chalcedony"
    ]
  };
    
    // Fonction pour charger et cacher les catégories de matériaux
    async function getMaterialCategories() {
      if (materialCategoriesCache) return materialCategoriesCache;
      try {
      // Essayer d'abord une version inline si disponible
      if (window.__materialCategories && typeof window.__materialCategories === 'object') {
        materialCategoriesCache = window.__materialCategories;
        return materialCategoriesCache;
      }
      const response = await fetch(window.materialCategoriesUrl || '/assets/material-categories.json');
      if (response.ok) {
        materialCategoriesCache = await response.json();
        return materialCategoriesCache;
      }
      // Fallback si 404/403 ou autre
      materialCategoriesCache = materialCategoriesFallback;
      return materialCategoriesCache;
      } catch (error) {
        console.error('[Material Refinements] Error loading categories:', error);
      materialCategoriesCache = materialCategoriesFallback;
      return materialCategoriesCache;
      }
    }
    
    // Mapping FR → EN pour les termes de recherche génériques
    const searchTermsFRtoEN = {
      "bois": "wood", "métal": "metal", "métaux": "metal", "pierre": "stone", "pierres": "stone",
      "verre": "glass", "céramique": "ceramic", "textile": "textile", "textiles": "textile",
      "cuir": "leather", "plastique": "plastic", "marbre": "marble", "acier": "steel",
      "laiton": "brass", "bronze": "bronze", "cuivre": "copper", "aluminium": "aluminium",
      "fer": "iron", "or": "gold", "argent": "silver", "chrome": "chrome", "nickel": "nickel",
      "chêne": "oak", "noyer": "walnut", "acajou": "mahogany", "érable": "maple", "teck": "teak",
      "pin": "pine", "bouleau": "birch", "frêne": "ash", "ébène": "ebony", "bambou": "bamboo",
      "rotin": "rattan", "osier": "wicker", "lin": "linen", "coton": "cotton", "laine": "wool",
      "soie": "silk", "velours": "velvet", "chanvre": "hemp", "jute": "jute",
      "porcelaine": "porcelain", "terre cuite": "terracotta", "grès": "stoneware", "faïence": "faience",
      "granit": "granite", "quartz": "quartz", "ardoise": "slate", "béton": "concrete",
      "résine": "resin", "acrylique": "acrylic", "cristal": "crystal", "nacre": "mother of pearl"
    };
    
    // Fonction pour obtenir le terme EN à partir d'un terme FR
    function getEnglishSearchTerm(query) {
      const queryLower = query.toLowerCase().trim();
      return searchTermsFRtoEN[queryLower] || queryLower;
    }
    
    function matchMaterialCategory(userQuery, materialCategories) {
      if (!materialCategories) return null;
      const queryLower = userQuery.toLowerCase().trim();
      const queryEN = getEnglishSearchTerm(queryLower);
      for (const [categoryName, materials] of Object.entries(materialCategories)) {
        const genericTerm = materials[0].toLowerCase();
        const categoryKeywords = categoryName.toLowerCase().split(/\s+/);
        if (genericTerm === queryEN || categoryKeywords.includes(queryEN)) {
          return { categoryName, matchedSubTypes: materials.slice(1) };
        }
      }
      return null;
    }

    function ensureDidYouMeanContainer() {
      let didYouMeanContainer = document.getElementById('ais-did-you-mean');
      const topContainer = document.querySelector('.ais-custom-container-top');
      if (!didYouMeanContainer && topContainer) {
        didYouMeanContainer = document.createElement('div');
        didYouMeanContainer.id = 'ais-did-you-mean';
        didYouMeanContainer.className = 'ais-did-you-mean';
        topContainer.parentNode.insertBefore(didYouMeanContainer, topContainer);
      }
      return didYouMeanContainer;
    }

    function ensureMaterialRefinementsContainer() {
      let refinementsContainer = document.getElementById('ais-material-refinements');
      const statsContainer = document.getElementById('aisStats');
      if (!refinementsContainer && statsContainer) {
        refinementsContainer = document.createElement('div');
        refinementsContainer.id = 'ais-material-refinements';
        refinementsContainer.className = 'ais-material-refinements';
        statsContainer.appendChild(refinementsContainer);
      }
      return refinementsContainer;
    }

    function applyDidYouMeanFromResults(userQuery, countResult, hitsResult) {
      const didYouMeanContainer = ensureDidYouMeanContainer();
      if (!didYouMeanContainer) return;

      const currentNbHits = countResult?.nbHits || 0;
      if (currentNbHits >= 30) {
        didYouMeanContainer.innerHTML = '';
        return;
      }

      const hits = hitsResult?.hits || [];
      const wordsFromTitles = new Set();
      hits.forEach(hit => {
        if (hit.title) {
          hit.title.toLowerCase().split(/[\s\-–—,.'"/()]+/).forEach(word => {
            if (word.length >= 4 && !DID_YOU_MEAN_STOPWORDS.has(word)) wordsFromTitles.add(word);
          });
        }
        if (hit.product_type) {
          hit.product_type.toLowerCase().split(/[\s\-–—,.'"/()]+/).forEach(word => {
            if (word.length >= 4 && !DID_YOU_MEAN_STOPWORDS.has(word)) wordsFromTitles.add(word);
          });
        }
      });

      const queryWords = userQuery.toLowerCase().split(/\s+/);
      let hasCorrection = false;
      const correctedWords = queryWords.map(queryWord => {
        if (queryWord.length < 4 || DID_YOU_MEAN_STOPWORDS.has(queryWord)) return queryWord;
        if ([...wordsFromTitles].find(w => w === queryWord)) return queryWord;
        const prefixMatch = [...wordsFromTitles].find(w => {
          if (w.startsWith(queryWord) && w.length > queryWord.length) {
            const lengthDiff = w.length - queryWord.length;
            if (lengthDiff === 1) return false;
            return queryWord.length >= 3 && (queryWord.length / w.length) >= 0.5;
          }
          return false;
        });
        if (prefixMatch) { hasCorrection = true; return prefixMatch; }
        for (const titleWord of wordsFromTitles) {
          if (isLikelyTypo(queryWord, titleWord)) {
            hasCorrection = true;
            return titleWord;
          }
        }
        return queryWord;
      });

      if (!hasCorrection) {
        didYouMeanContainer.innerHTML = '';
        return;
      }
      const correctedQuery = correctedWords.join(' ');
      if (correctedQuery.toLowerCase() === userQuery.toLowerCase()) {
        didYouMeanContainer.innerHTML = '';
        return;
      }
      const isEnglish = current_locale === 'en';
      const didYouMeanText = isEnglish ? 'Did you mean' : 'Vouliez-vous dire';
      const searchUrl = `${window.Shopify.routes.root}search?q=${encodeURIComponent(correctedQuery)}`;
      didYouMeanContainer.innerHTML = `
        <p class="ais-did-you-mean__text">
          ${didYouMeanText} <a href="${searchUrl}" class="ais-did-you-mean__link">${correctedQuery}</a> ?
        </p>
      `;
    }

    function syncMaterialRefinementTagActiveState() {
      const refinementsContainer = document.getElementById('ais-material-refinements');
      const helper = instant.search.helper;
      if (!refinementsContainer || !helper) return;
      const activeValues = helper.getRefinements('meta.custom.materials').map(r => String(r.value).toLowerCase());
      refinementsContainer.querySelectorAll('.ais-material-refinements__tag').forEach(btn => {
        const materialValue = btn.dataset.material;
        if (!materialValue) return;
        const isActive = activeValues.includes(materialValue.toLowerCase());
        const displayLabel = translateTerm(materialValue);
        btn.classList.toggle('is-active', isActive);
        btn.textContent = isActive ? `${displayLabel} ✕` : displayLabel;
      });
    }

    function applyMaterialRefinementsFromResults(userQuery, matchedSubTypes, searchResult) {
      const refinementsContainer = ensureMaterialRefinementsContainer();
      if (!refinementsContainer) return;

      if (!matchedSubTypes || !matchedSubTypes.length || !searchResult) {
        refinementsContainer.innerHTML = '';
        return;
      }

      const hits = searchResult.hits || [];
      const foundSubTypes = new Map();
      hits.forEach(hit => {
        const titleLower = (hit.title || '').toLowerCase();
        const tagsLower = (hit.tags || []).map(t => t.toLowerCase());
        const typeLower = (hit.product_type || '').toLowerCase();
        const searchText = `${titleLower} ${tagsLower.join(' ')} ${typeLower}`;
        matchedSubTypes.forEach(subType => {
          const subTypeLower = subType.toLowerCase();
          if (searchText.includes(subTypeLower)) {
            foundSubTypes.set(subType, (foundSubTypes.get(subType) || 0) + 1);
          }
        });
      });

      let sortedSubTypes = [...foundSubTypes.entries()]
        .sort((a, b) => b[1] - a[1])
        .map(([subType]) => subType);
      if (sortedSubTypes.length === 0) {
        sortedSubTypes = matchedSubTypes.slice(0, 6);
      } else if (sortedSubTypes.length < 6) {
        const fallback = matchedSubTypes.filter(sub => !sortedSubTypes.includes(sub)).slice(0, 6 - sortedSubTypes.length);
        sortedSubTypes = [...sortedSubTypes, ...fallback];
      } else {
        sortedSubTypes = sortedSubTypes.slice(0, 6);
      }

      const isEnglish = current_locale === 'en';
      const capitalizedQuery = userQuery.charAt(0).toUpperCase() + userQuery.slice(1).toLowerCase();
      const refineText = isEnglish
        ? `What type of ${capitalizedQuery} are you looking for?`
        : `Quel type de ${capitalizedQuery} recherchez-vous ?`;

      const helper = instant.search.helper;
      const currentRefinements = helper ? helper.getRefinements('meta.custom.materials') : [];
      const activeValues = currentRefinements.map(r => String(r.value).toLowerCase());

      refinementsContainer.innerHTML = `
        <div class="ais-material-refinements__wrapper">
          <span class="ais-material-refinements__label">${refineText}</span>
          <div class="ais-material-refinements__tags">
            ${sortedSubTypes.map(subType => {
              const isActive = activeValues.includes(subType.toLowerCase());
              const displayLabel = translateTerm(subType);
              return `<button type="button" class="ais-material-refinements__tag${isActive ? ' is-active' : ''}" data-material="${subType}">${displayLabel}${isActive ? ' ✕' : ''}</button>`;
            }).join('')}
          </div>
        </div>
      `;

      refinementsContainer.querySelectorAll('.ais-material-refinements__tag').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const materialValue = e.currentTarget.dataset.material;
          if (!helper || !materialValue) return;
          // 1 POST InstantSearch uniquement — pas de reset auxiliaire (évite 2e POST).
          helper.toggleRefinement('meta.custom.materials', materialValue);
          helper.search();
        });
      });
    }

    function applyRelatedSearchesFromResults(userQuery, searchResults) {
      const relatedSection = document.getElementById('related-searches-section');
      const tagsContainer = document.getElementById('related-searches-tags');
      const categoryLink = document.getElementById('related-searches-category-link');
      if (!relatedSection || !tagsContainer) return;

      if (!searchResults || searchResults.nbHits === 0) {
        relatedSection.style.display = 'none';
        return;
      }

      const cleanAndFormat = (text) => {
        if (!text) return '';
        let cleaned = text.replace(/[\[\]"']/g, '').trim();
        cleaned = cleaned.replace(/^(open|close|the|a|an)\s+/i, '');
        return cleaned.split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
          .join(' ');
      };
      const cleanFormatAndTranslate = (text) => translateTerm(cleanAndFormat(text));
      const isValidSuggestion = (text) => {
        if (!text || text.length < 2) return false;
        if (/[\[\]"']/.test(text)) return false;
        return text.replace(/[\[\]"']/g, '').trim().length >= 2;
      };

      const relatedSearches = [];
      const addedQueries = new Set();
      const queryLower = userQuery.toLowerCase();

      const productTypes = searchResults.facets?.product_type || {};
      const productTypeEntries = Object.entries(productTypes).sort((a, b) => b[1] - a[1]).slice(0, 5);
      productTypeEntries.forEach(([typeName, count]) => {
        const cleanedType = cleanAndFormat(typeName);
        const translatedType = translateTerm(cleanedType);
        if (!isValidSuggestion(typeName)) return;
        if (!queryLower.includes(cleanedType.toLowerCase()) && count >= 3) {
          const formattedQuery = cleanAndFormat(userQuery);
          const translatedQuery = translateTerm(formattedQuery);
          const combinedQuery = `${formattedQuery} ${cleanedType}`;
          const combinedLabel = `${translatedQuery} ${translatedType}`;
          if (!addedQueries.has(combinedQuery.toLowerCase())) {
            relatedSearches.push({ label: combinedLabel, query: combinedQuery });
            addedQueries.add(combinedQuery.toLowerCase());
          }
        }
      });

      const materials = searchResults.facets?.['meta.custom.materials'] || {};
      Object.entries(materials)
        .filter(([name, count]) => {
          const nameLower = name.toLowerCase();
          return !queryLower.includes(nameLower) && !nameLower.includes(queryLower) && count >= 2;
        })
        .sort((a, b) => b[1] - a[1])
        .slice(0, 6)
        .forEach(([materialName]) => {
          if (!isValidSuggestion(materialName)) return;
          const cleanedMaterial = cleanAndFormat(materialName);
          const translatedMaterial = translateTerm(cleanedMaterial);
          if (!addedQueries.has(cleanedMaterial.toLowerCase())) {
            relatedSearches.push({ label: translatedMaterial, query: cleanedMaterial });
            addedQueries.add(cleanedMaterial.toLowerCase());
          }
        });

      const collections = searchResults.facets?.['named_tags.Collection'] || {};
      Object.entries(collections)
        .filter(([, count]) => count >= 3)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 4)
        .forEach(([collectionName]) => {
          if (!isValidSuggestion(collectionName)) return;
          const cleanedCollection = cleanAndFormat(collectionName);
          const translatedCollection = translateTerm(cleanedCollection);
          if (!addedQueries.has(cleanedCollection.toLowerCase())) {
            relatedSearches.push({ label: translatedCollection, query: cleanedCollection });
            addedQueries.add(cleanedCollection.toLowerCase());
          }
        });

      const titleKeywords = new Map();
      (searchResults.hits || []).forEach(hit => {
        const title = hit.title || '';
        title.split(/\s+/).filter(word => {
          const w = word.toLowerCase().replace(/[^a-z]/g, '');
          return w.length > 4 && !queryLower.includes(w) && !w.includes(queryLower);
        }).forEach(word => {
          const w = word.replace(/[^a-zA-Z]/g, '');
          if (w) titleKeywords.set(w.toLowerCase(), (titleKeywords.get(w.toLowerCase()) || 0) + 1);
        });
      });
      [...titleKeywords.entries()]
        .filter(([, count]) => count >= 5)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 3)
        .forEach(([keyword]) => {
          const cleanedKeyword = cleanAndFormat(keyword);
          const translatedKeyword = translateTerm(cleanedKeyword);
          if (cleanedKeyword.length < 3) return;
          if (!addedQueries.has(cleanedKeyword.toLowerCase())) {
            relatedSearches.push({ label: translatedKeyword, query: cleanedKeyword });
            addedQueries.add(cleanedKeyword.toLowerCase());
          }
        });

      const finalSearches = relatedSearches.slice(0, 12);
      if (finalSearches.length < 3) {
        relatedSection.style.display = 'none';
        return;
      }

      const rootPath = window.Shopify?.routes?.root || '/';
      tagsContainer.innerHTML = finalSearches.map(search => {
        const searchUrl = `${rootPath}search?q=${encodeURIComponent(search.query)}`;
        return `<a href="${searchUrl}" class="related-searches__tag">${search.label}</a>`;
      }).join('');
      if (categoryLink) categoryLink.style.display = 'none';
      relatedSection.style.display = 'block';
    }

    // Regroupe Did you mean + related searches + material chips en UN POST multi-queries
    // (params strictement identiques aux anciennes requêtes séparées → même display).
    async function runAuxiliarySearches() {
      const isSearchPage = window.location.pathname.includes('/search');
      if (!isSearchPage || auxiliarySearchesInFlight) return;

      const urlParams = new URLSearchParams(window.location.search);
      const userQuery = urlParams.get('q') || '';
      if (!userQuery || userQuery.length < 3) return;

      const needDidYouMean = lastCheckedQuery !== userQuery;
      const needMaterial = lastCheckedMaterialQuery !== userQuery;
      const relatedSection = document.getElementById('related-searches-section');
      const needRelated = !relatedSearchesLoaded && !!relatedSection;

      if (!needDidYouMean && !needMaterial && !needRelated) return;

      auxiliarySearchesInFlight = true;
      const prevDidYouMean = lastCheckedQuery;
      const prevMaterial = lastCheckedMaterialQuery;
      const prevRelated = relatedSearchesLoaded;
      if (needDidYouMean) lastCheckedQuery = userQuery;
      if (needMaterial) lastCheckedMaterialQuery = userQuery;
      if (needRelated) relatedSearchesLoaded = true;

      try {
        let matchedSubTypes = [];
        if (needMaterial) {
          const materialCategories = await getMaterialCategories();
          const matched = matchMaterialCategory(userQuery, materialCategories);
          if (!matched || !matched.matchedSubTypes.length) {
            const emptyEl = ensureMaterialRefinementsContainer();
            if (emptyEl) emptyEl.innerHTML = '';
          } else {
            matchedSubTypes = matched.matchedSubTypes;
          }
        }

        const requests = [];
        const keys = [];

        if (needDidYouMean) {
          // Count SANS filtre stock (≠ lastResults InstantSearch) — inchangé vs avant.
          requests.push({
            indexName: algoliaIndexName,
            query: userQuery,
            params: { hitsPerPage: 0, analytics: false },
          });
          keys.push('dymCount');
          requests.push({
            indexName: algoliaIndexName,
            query: userQuery,
            params: {
              hitsPerPage: 30,
              attributesToRetrieve: ['title', 'product_type'],
              typoTolerance: true,
            },
          });
          keys.push('dymHits');
        }

        if (needRelated) {
          requests.push({
            indexName: algoliaIndexName,
            query: userQuery,
            params: {
              hitsPerPage: 50,
              facets: ['product_type', 'meta.custom.materials', 'named_tags.Collection'],
              maxValuesPerFacet: 20,
              analytics: false,
            },
          });
          keys.push('related');
        }

        if (needMaterial && matchedSubTypes.length) {
          requests.push({
            indexName: algoliaIndexName,
            query: userQuery,
            params: {
              hitsPerPage: 50,
              attributesToRetrieve: ['title', 'tags', 'product_type'],
              typoTolerance: true,
            },
          });
          keys.push('material');
        }

        if (!requests.length) return;

        const response = await AlgoliaProxy.clientSearch(requests);
        const byKey = {};
        keys.forEach((k, i) => { byKey[k] = response.results[i]; });

        if (needDidYouMean) {
          applyDidYouMeanFromResults(userQuery, byKey.dymCount, byKey.dymHits);
        }
        if (needRelated) {
          applyRelatedSearchesFromResults(userQuery, byKey.related);
        }
        if (needMaterial && matchedSubTypes.length) {
          applyMaterialRefinementsFromResults(userQuery, matchedSubTypes, byKey.material);
        }
      } catch (error) {
        console.error('[Auxiliary Searches] Error:', error);
        // Autoriser un retry au prochain render
        lastCheckedQuery = prevDidYouMean;
        lastCheckedMaterialQuery = prevMaterial;
        relatedSearchesLoaded = prevRelated;
        const dym = document.getElementById('ais-did-you-mean');
        if (dym) dym.innerHTML = '';
        if (relatedSection) relatedSection.style.display = 'none';
      } finally {
        auxiliarySearchesInFlight = false;
      }
    }

    // After search render, set up color, material, and style facet handlers
    function performAfterSearchActivity() {
      window.hierarchicalFacetHelper.setupCategoryHandlers('color');
      window.hierarchicalFacetHelper.setupCategoryHandlers('material');
      window.hierarchicalFacetHelper.setupCategoryHandlers('style');
      // Add to favourites event - TO-DO: Verify if this is working
      let swymButtonArray = document.querySelectorAll(".swym-button");
      for (let i = 0; i < swymButtonArray.length; i++) {
        swymButtonArray[i]?.addEventListener("click", function () {
          // console.log("swym button clicked");
        });
      }
    }

    
    // Test user token works
    // console.log("userToken", userToken);
    
  });
})(window.algoliasearch);
